{
  "roIfV8": "Range structure",
  "lQbuj+": "Directional structure",
  "m68fwH": "Basic structure",
  "AcgWRN": "Volatility structure",
  "Oun8cx": "1 leg",
  "4tBtHB": "{count} legs",
  "EzjwhO": "Free combination",
  "DKLopw": "Strategy structure",
  "lZh4DD": "Remove favorite",
  "pYaV6+": "Add favorite",
  "h6oI1g": "Explore strategy",
  "0f7XX1": "Use strategy",
  "sIcQ7Q": "Theory",
  "yoo4hj": "Loading practice...",
  "09CmBC": "Guest quiz progress lasts while this page is open.",
  "pD4hJR": "P&L details",
  "rbrahO": "Close",
  "B/LMTA": "Total P&L · USD",
  "wx5z2a": "Enter the actual total. Use a negative amount for a loss.",
  "P7PLVj": "Date",
  "3Hcl9v": "Notes (optional)",
  "zdLDux": "Confirm deletion",
  "Ol4RmZ": "Delete strategy",
  "Lc9nUH": "Delete record",
  "E6+QMz": "Copy strategy",
  "WUV28A": "Saving…",
  "0mjohm": "Save record",
  "aysJvP": "Quick P&L entry",
  "zGHadw": "Strategy",
  "+p1waH": "Edit P&L",
  "m7+C5p": "Record P&L",
  "EnCOBJ": "Buy",
  "9AgXoz": "Sell",
  "f+GKc4": "Call",
  "HTYkFc": "Put",
  "yw6I5x": "P&L not recorded",
  "T4VxQN": "Loading…",
  "V5rFLm": "Could not load records.",
  "62nsdy": "Retry",
  "a3sxXl": "All records",
  "WuGkfJ": "Returns",
  "X7grYV": "Recorded P&L",
  "RYpASu": "P&L to record",
  "TBovrx": "Month",
  "FzwzBR": "All months",
  "iex2YB": "Ticker",
  "5tx9gM": "All tickers",
  "inyj8R": "No matching records.",
  "fu5x2o": "No P&L recorded yet.",
  "c1GLGz": "No P&L to record.",
  "46Fylq": "Save a strategy to add a record. Fill in the actual P&L later.",
  "+AbGsu": "Record date",
  "x/oJ17": "Expiry date",
  "AnP70a": "Net P&L",
  "wL7VAE": "Actions",
  "otDHS/": "Record pages",
  "JJNc3c": "Previous",
  "9+Ddtu": "Next",
  "s3jIMU": "Today's total",
  "Uiqc6K": "Cumulative P&L",
  "jtM9t3": "Offset",
  "At+qYb": "Strategy offset",
  "Z0OIGW": "Buy {strike} {type}",
  "4jBZs/": "Sell {strike} {type}",
  "XyQ6Tz": "Build an idea from contracts.",
  "ebizDo": "Quote snapshot",
  "M9qpSD": "Buy / ASK",
  "NWm89j": "Strike",
  "e4WZAu": "Sell / BID",
  "fvRdJl": "Loading option chain…",
  "0TW6Fq": "No option quotes are available for this selection.",
  "70jbDq": "Your selection",
  "6tTb3Y": "Select a buy or sell quote. Your contracts will appear here.",
  "86rWuG": "Remove selected contract",
  "2wnqME": "{count} contracts selected",
  "Q4yHuA": "Add selected contracts",
  "H24iSt": "Delete this strategy?",
  "Na3L+7": "Edit contracts",
  "ZwpbZp": "Contracts",
  "itWRRt": "Add contracts from option chain",
  "2rO17V": "The strategy and its contracts will be removed. Journal entries will remain.",
  "uQVmjH": "Return to editing",
  "uRtNMW": "1 Select structure",
  "LY+2as": "2 Edit contracts",
  "y5iRD+": "3 View payoff",
  "fNrfbJ": "Strategy name",
  "dhPbpj": "Edit the name directly. Each contract can have its own expiry and quantity.",
  "nV7Cv+": "Contract",
  "e8Bk1E": "Delete this leg",
  "7xpfuy": "Side",
  "ktMgsf": "Option type",
  "YK27+4": "Contracts per set",
  "CICBj0": "Expiration date",
  "KgeekN": "Premium per share · USD",
  "Hn90P4": "Add contract",
  "fYd71s": "Strategy sets",
  "h3gzda": "Cancel changes",
  "Q1NxeC": "Save and view payoff",
  "C5xzTC": "Premium",
  "+ICdVm": "Saved date",
  "fhfSHc": "Close details",
  "qZbedW": "Fees",
  "BaAi7W": "Realized P&L",
  "Vs3d3N": "Strategy expiry",
  "++2QjX": "Multiple expiries",
  "FcYnDI": "Contract details are unavailable for this record.",
  "0jQplV": "Delete strategy and P&L",
  "37Hd+s": "Edit close",
  "mSJ0dz": "Month calendar",
  "L3S5GE": "Choose a date to see that day's schedule.",
  "8mRNBD": "Previous month",
  "PqmLVn": "Next month",
  "XkzUAq": "1 contract",
  "+iB0Qw": "{count} contracts",
  "44xSOg": "{dates} expiry",
  "c7ayat": "View strategy",
  "BC1G69": "Write review",
  "3Rx6Qo": "Advanced",
  "o5/DJA": "Intermediate",
  "6RRX7X": "Foundations",
  "eEOtmw": "Strategies",
  "Cjv9+J": "Greeks",
  "OuR/Ij": "Quiz",
  "9KHvD/": "{days} DTE",
  "n3VxC3": "Position details are not ready. Please retry.",
  "bUe80+": "Details deleted",
  "N9aL82": "Choose a trading day for each contract expiry.",
  "1eSZed": "Could not save. Your changes are still here. Please retry.",
  "0fwVtw": "Template saved",
  "V+A++8": "Save template",
  "+rBfGg": "Strategy deleted",
  "3UiyM0": "Could not finish deleting. Please retry or undo the deletion.",
  "ejEGdx": "Home",
  "DWmFUp": "Workbench",
  "0/DoJD": "Options Theory",
  "itPgxd": "Profile",
  "03mQgY": "Strategy library",
  "StcK67": "Library",
  "QiIw/s": "Understand the structure before building your strategy.",
  "zQvVDJ": "All",
  "fNCCY7": "Basic",
  "AZJT7B": "Directional",
  "vhQqLj": "Range",
  "EHsGJ+": "Volatility",
  "rOZptg": "Workspace",
  "CFS8/C": "Main navigation",
  "aEp+N8": "Interface version",
  "xey8lP": "2.0 General",
  "Cr6WNE": "3.0",
  "3z1ihQ": "1.0 Flagship",
  "rlzoEL": "Feature overview",
  "y1Z3or": "Language",
  "hGQqkW": "Schedule",
  "046zjm": "Journal",
  "svEqhD": "Returns overview",
  "GhJzE3": "Strategy Builder",
  "Q3Y5Ha": "Position simulation",
  "VxyqWZ": "All structures",
  "VoFF/J": "Loading workspaces…",
  "1RrqRr": "Could not load workspaces.",
  "JkS37H": "Undo",
  "H9bg9B": "Your daily",
  "h1vUvt": "Today’s",
  "eDvEED": "agenda",
  "kPRXyx": "Keep notes and review your decisions.",
  "mgm/go": "Quickly add reminders and review upcoming expirations.",
  "H3AR3E": "Expiration schedule",
  "wXmakI": "Choose date",
  "8sf72h": "Pre-market",
  "B+yA9l": "No strategies expire on this date.",
  "cnTUAk": "1 strategy expires on this day.",
  "ZSdmVQ": "{count} strategies expire on this day.",
  "FgydNe": "View",
  "Flp5EE": "Expiring on this day",
  "UOCLhC": "1 strategy",
  "J/UkMD": "{count} strategies",
  "f55DWz": "To-dos",
  "ItDqLZ": "{count} items",
  "bW7B87": "New",
  "HCrRaj": "To-do",
  "wEQDC6": "Edit",
  "Uym+w+": "Today's P&L",
  "SNUidU": "Selected day P&L",
  "EUIi10": "Show P&L amount",
  "dYgLxd": "Hide P&L amount",
  "iPv7db": "This month's P&L",
  "zCYmSr": "Selected month P&L",
  "MtaFwz": "View cumulative returns",
  "tr+EKe": "Write a review",
  "/nJRat": "Journal saved",
  "YGAlXb": "Switch ticker workspace",
  "B3xAC5": "Quick start strategy",
  "mqs6T/": "Theory quiz",
  "UwBPRJ": "Learning progress",
  "Dr13kE": "Continue where you left off",
  "8Orgfi": "Start learning",
  "9uOFF3": "Overview",
  "flJCao": "overview",
  "g26B7+": "Strategy records and P&L overview.",
  "hneo2M": "New strategy",
  "8iO53k": "Ticker workspace",
  "K1Fap+": "Choose ticker",
  "A8QzWU": "Current strategy",
  "ObGhob": "Choose a structure",
  "yYeCWE": "Payoff simulation",
  "hzmswI": "Groups",
  "RQVoCk": "Current strategy · Expiration view",
  "el7vse": "Enter valid contract details to view the simulation.",
  "BpZUWo": "This structure uses advanced features.",
  "2nn+Sf": "Open in 3.0",
  "iL0n4U": "Decrease quantity",
  "3ZPs5M": "Increase quantity",
  "JXdbo8": "Done",
  "Ri9b0M": "Discard strategy",
  "Y3NN5e": "Start with a strategy",
  "D3idYv": "Settings",
  "BnasDI": "My",
  "47MEOU": "Personal workspace",
  "oGAqgT": "Strategy workflow",
  "A8Vn9q": "Select workspace",
  "j6x71P": "Go to strategy builder",
  "qu5E+x": "Go to position simulation",
  "Cogg6U": "Go to returns overview",
  "DPEFal": "View journal",
  "t8KawU": "Untitled entry",
  "4ft8js": "New journal",
  "nZxxhf": "New review entry",
  "47FYwb": "Cancel",
  "3/D6e1": "Saved templates",
  "VpMTSI": "Save a template in the strategy editor to reuse it here.",
  "NoC/ht": "Reference price",
  "KkwoIE": "A market price is not available. Enter a reference price to set the initial strikes; you can edit every contract next.",
  "YSuGxS": "Choose your ticker workspace",
  "Jq3FDz": "Content",
  "K3r6DQ": "Delete",
  "X0ha1a": "Save changes",
  "2/2yg+": "Add",
  "BwnwWr": "Theoretically unlimited",
  "t/247F": "SPY · Teaching example",
  "+M7CqF": "All option legs have the same expiration.",
  "OievG4": "Premiums are per share. Each standard contract represents 100 shares.",
  "qVGRIE": "Quantity",
  "Y/Y5ET": "Net premium",
  "ZdOaAg": "Maximum expiration profit",
  "PjOosS": "Maximum expiration loss",
  "ngoOEX": "Expiration breakeven",
  "450Fty": "None",
  "xHblRN": "Expiration scenarios",
  "fiXytS": "Underlying at expiration",
  "evf6uW": "Profit / loss",
  "Bz+H46": "Illustrative prices, before fees. Expiration payoffs exclude early assignment and changes in time value or volatility. Editing strikes keeps the entered premiums; no market quotes are fetched.",
  "21yJ8q": "Explore this example",
  "9a9+ww": "Title",
  "7+Domh": "Notes",
  "jvo0vs": "Save",
  "x9YTOO": "Entry type",
  "oZI+Us": "Detailed entry",
  "1QER8V": "Ticker (optional)",
  "clknDE": "No ticker",
  "sE7l6a": "Choose strategy",
  "RokZsg": "No saved strategies for this ticker. Use quick entry instead.",
  "NceOkd": "Record scope",
  "rbYjy2": "Whole strategy",
  "5IP7AP": "Width",
  "gyuZSt": "Strategy width",
  "MVpSCW": "Explore position P&L",
  "fsB/4p": "Saved",
  "0EMLB9": "Start simulation",
  "y269Y9": "Save options",
  "PWeUbj": "Save to overview",
  "64eVDw": "Record returns later",
  "rMo5L2": "Elapsed",
  "KFvx8w": "Until selected date",
  "q4Qeln": "Remaining this year",
  "WN5lCH": "Trading days",
  "cXZ3+s": "Link a strategy, or keep this as an independent entry.",
  "W6iocE": "Linked strategy",
  "M8SEnW": "No link · Independent entry",
  "K9dnUB": "Entry title",
  "RhsDlp": "For example: Why I adjusted this contract",
  "ccXLVi": "Category",
  "avbgBi": "Build notes",
  "OZserT": "Adjustment record",
  "R+J5ox": "Review",
  "altbih": "Entry content",
  "cT7liw": "Initial reasoning, changes made, and what happened next…",
  "fddyTp": "Save entry",
  "H8KGyc": "Enter",
  "clUcU+": "Keep your progress",
  "ZCxE6c": "Your selection is held in this tab for up to 24 hours. Sign in here to save it to your account.",
  "emZo12": "Check your email for your login PIN, then return here to sign in and save your selection.",
  "wTbis3": "Sign in and save",
  "RBZX5n": "This email already has an account. Sign in below to save your selection.",
  "EX+sDo": "Could not create your account. Please try again.",
  "sy+pv5": "Email",
  "ff2VGL": "Sending…",
  "huqKGl": "Create account",
  "k/jPgQ": "Already have an account? Sign in and save",
  "oimOv6": "By creating an account, you agree to our",
  "xkr+zo": "Terms",
  "3mvL2Q": "and",
  "vx0nkZ": "Privacy Policy",
  "nSmKfC": "Change strategy expiry",
  "XBVRCo": "Choose expiration date",
  "gJOXzn": "Apply to all contracts",
  "MeGdHj": "Use this expiry for the new strategy.",
  "EE/sp8": "Loading expiries…",
  "r1nMz3": "Available expiries",
  "8iD1fY": "Selected expiry",
  "U/+d+C": "To change just one contract, edit its expiry in the contract row.",
  "oRPMUF": "You can adjust individual contract dates in the editor.",
  "6Hca8c": "Sync to",
  "N2IrpM": "Confirm",
  "JCRkgU": "Recorded at",
  "yGcAsT": "Loading reviews…",
  "sQDKyM": "Review reminder",
  "EaXqqJ": "1 review entry for this day",
  "HlwPE3": "{count} review entries for this day",
  "DX/Uv6": "After the close, leave a note.",
  "LFo5aY": "Personal review reminder",
  "gVLnrh": "Could not load journal entries.",
  "pFK6bJ": "View all",
  "W4SaxY": "Local",
  "pbQZea": "UTC",
  "F9AZpf": "New York (ET)",
  "n6sx52": "Los Angeles (PT)",
  "mU/tMS": "Chicago (CT)",
  "w/uBeK": "London (GMT/BST)",
  "4FwhdX": "Paris (CET/CEST)",
  "1x6hvP": "Shanghai (CST)",
  "qsO47r": "Tokyo (JST)",
  "jLCfhX": "Singapore (SGT)",
  "HAlOn1": "Name",
  "uE6ELS": "Not provided",
  "e/4U0n": "PIN",
  "PwJJQJ": "Edit PIN",
  "VA/Z1S": "Hide",
  "K7AkdL": "Show",
  "Q5Sgak": "PIN already taken",
  "ZOeQK5": "Must be 6 digits",
  "+OtV6h": "Failed to save",
  "WkrNSk": "English",
  "RsD3Mg": "Chinese",
  "IcUakl": "Time zone",
  "lJlH1M": "Flip profit/loss colors",
  "3hYpLY": "Email notifications",
  "Awq32I": "Push notifications",
  "vzYPVX": "Keyboard shortcuts",
  "F62y+K": "Sign Out",
  "8JXfhE": "Read entry",
  "AjSNyH": "Could not delete this entry. Please retry.",
  "OvdZnF": "Search journal",
  "r5knpq": "Search title or notes",
  "xmcVZ0": "Search",
  "/GCoTA": "Clear",
  "sR7qpA": "Journal types",
  "NVV46j": "No matching entries.",
  "GplR9g": "No reviews yet.",
  "YxMnIj": "No journals yet.",
  "WOab0k": "Could not load more entries. Please retry.",
  "00LcfG": "Load more",
  "o7CI6C": "Edit journal entry",
  "i1rX6C": "Delete entry",
  "FB//Ed": "Edit entry",
  "MnpUD7": "View details",
  "ekXood": "Unlimited",
  "zGWqEw": "Different expiries: use the flagship model to compare time value.",
  "SGPNh4": "Add a contract to start your simulation.",
  "5mbT1F": "Simulated profit / loss",
  "r/Hdwg": "Moving the slider only changes the scenario, not the contracts.",
  "luKKRk": "Different expiries: expired contracts settle at the scenario price; open contracts use the simulated date.",
  "Ci95k0": "Different expiries: this total assumes the same underlying price at each contract’s expiry. It is not a valuation on one date.",
  "+v9Ok5": "Example payoff",
  "5gfsxq": "Example premiums · Fill every contract premium to see your calculated payoff.",
  "jAfo6c": "Expiry P&L / USD",
  "UPQyHx": "Estimated P&L / USD",
  "5r79gy": "Example P&L / USD",
  "XbpSci": "P&L / USD",
  "UDdxHp": "Compare expiry curve",
  "MfCKsM": "Strategy payoff at simulated date",
  "SjQMC5": "Combined strategy payoff at expiration",
  "vHiAre": "Strategy payoff at expiration",
  "tgcX/z": "Scenario price",
  "uNxDFh": "Price at expiration",
  "HR5dPj": "Simulation conditions",
  "2uavLm": "Restore current price, current time and baseline IV.",
  "snb1ZU": "Back to current",
  "sudrJ2": "Underlying price",
  "WTKrlG": "Underlying price at expiration",
  "gHwYMn": "Change from current underlying price",
  "NWx9PZ": "Simulation time",
  "ZSAr7w": "{days} days remaining",
  "tgvES0": "Now",
  "dyElqO": "Expiry",
  "ux9Tju": "Implied volatility",
  "EYTjSo": "Assumed IV",
  "sfUw+e": "IV adjustment",
  "BeguqH": "IV has no effect at expiry.",
  "3oRjFS": "IV shift: {points} percentage points",
  "R1aEXn": "Maximum profit at expiry",
  "jDpwch": "Max profit",
  "apDkIS": "Best outcome",
  "6ADOnZ": "Maximum profit",
  "B6a/9X": "Maximum loss at expiry",
  "6xIl78": "Max loss",
  "vAz6ml": "Worst outcome",
  "zEJOhp": "Maximum loss",
  "JU9yiP": "Theoretical estimate · Fees and early exercise excluded",
  "W/vRg3": "Illustrative premiums only · Not written to your contracts",
  "7Uersh": "Offset simulation · Entered premiums · Fees excluded",
  "MMd4lt": "Expiration model · Fees excluded",
  "/9p+Ih": "Saved template",
  "dQvZ+J": "Use template",
  "+roKUl": "Choose a valid reference price and expiry.",
  "/Poesi": "Apply template",
  "ge6D/c": "Four legs define both boundaries. You can adjust each contract in the editor.",
  "48gLpx": "Two call strikes define the spread. You can adjust each contract in the editor.",
  "vRR065": "Buy the higher put and sell the lower put. You can adjust each contract in the editor.",
  "iTADZf": "Build around a center strike. You can adjust each contract in the editor.",
  "ETev4J": "Start with one call. You can adjust the contract in the editor.",
  "7uLCb3": "Start with one put. You can adjust the contract in the editor.",
  "R49Wra": "Combine a call and put at the same strike. You can adjust each contract in the editor.",
  "gNMjJl": "Choose your own contracts from the option chain.",
  "R1O9di": "Basic structures",
  "ovr52i": "My templates",
  "/iMMxS": "Step 1: choose a structure for {ticker}",
  "ji6oXc": "View payoff simulation",
  "bZ5yLj": "Your structure",
  "RegPoj": "Contract legs",
  "Sjo1P4": "Custom",
  "h4DDCx": "Example net premium",
  "Um3WQs": "Choose from option chain",
  "QThAQH": "Choose contracts",
  "LcvOVT": "Scheduled items",
  "2cQYUL": "Iron condor spread",
  "rDhkA9": "Bull call spread",
  "b9MNfz": "Bear put spread",
  "iZppcE": "Butterfly spread",
  "5JiUi1": "Long call option",
  "mnZbrH": "Long put option",
  "nf2rO+": "Long straddle",
  "tWrG9I": "Custom contracts",
  "nuELd+": "{count} sets",
  "flHGiq": "Details unavailable",
  "vd8ZAT": "Closed contract",
  "I3IAZH": "Payoff chart",
  "sPfikH": "Strategies and contracts",
  "U2FDW0": "Combined strategy simulation",
  "RaHmdD": "Selected strategy simulation",
  "kh1KeO": "Simulation underlying",
  "ECxnAP": "No workspaces yet",
  "RahCRH": "Expired",
  "6NctwV": "Show strategies",
  "fWqQu0": "Focus chart",
  "3fcUbU": "Closed. Realized P&L is saved in Returns overview.",
  "0J97KX": "No open positions in this workspace",
  "3ZV73A": "Go to builder",
  "THumjI": "All journals",
  "rMu3el": "Saved strategies",
  "tZrr+Z": "Contract details",
  "1LgskT": "Selected leg",
  "d2qC6D": "Close selected leg",
  "MZ+S/I": "Close strategy",
  "LzlMDx": "Close position",
  "WOFp4a": "Close all positions",
  "DOCgI8": "BTO",
  "SKMqP4": "STO",
  "C4MfxN": "STC",
  "MSrN2L": "BTC",
  "HvG5s7": "Entry price for {contract}",
  "hIT1Zf": "Close price for {contract}",
  "M1wP5r": "Close leg",
  "krfuyl": "Could not record the close. Check your prices or refresh the position, then retry.",
  "rY0sJm": "Entry price",
  "FwabZ1": "Close price",
  "x3WH1N": "Opening date",
  "4szKlZ": "Closing date",
  "hCQDkn": "USD",
  "Gzw24e": "Closing fees",
  "C5c66h": "Could not delete strategy. Please retry.",
  "Em4YSu": "Today's journal",
  "zVmice": "Journal · {date}",
  "V47K8v": "All entries →",
  "cO4q4O": "Nothing written today yet.",
  "HwqI7M": "Nothing written that day.",
  "3kbIhS": "Untitled",
  "3DWBhG": "+ Write an entry",
  "fBWFdu": "What happened, what you learned, what you'll do next time…",
  "2oVFY7": "Could not save. Your writing is still here — try again.",
  "TiR/Hq": "Saving...",
  "k45Tc7": "Not saved yet — will retry",
  "0DQlON": "Saved to your account",
  "+0CDAs": "Compound plan",
  "jwn+FG": "Set a daily target, then check off each trading day you hit it.",
  "NrVp1o": "Plan settings",
  "kxleqd": "Daily target as",
  "TOefst": "A % per day",
  "9GG2Xx": "A $ amount per day",
  "nQxsCH": "Starting amount ($)",
  "VjtXzx": "Daily target ($)",
  "EVkL9+": "Daily target (%)",
  "zSVA42": "Changing these starts the plan over from day 1.",
  "sI6Dzc": "Where it leads",
  "efRTJ2": "After {count} days",
  "Y7nVKh": "Total gain",
  "1G04pn": "Total return",
  "sIMS7i": "Progress",
  "Rk2moj": "Day {done} of {total}",
  "3ocoxe": "Balance now {amount}",
  "wjja+z": "Day {day} target: make {amount}",
  "nM92Ob": "{from} → {to}",
  "y6KAzd": "Undo the last day",
  "e8bHkL": "Hit today's target",
  "YMu/qW": "Plan complete — {amount}",
  "JgLxsC": "Start again",
  "d8EqQY": "Days",
  "18WUUn": "Day {day}: {amount}",
  "69lfhL": "Finished plans",
  "sL+Hht": "{from} → {to} in {count} days",
  "FL82mv": "Cumulative profit and loss over time",
  "echqSA": "Largest drawdown {amount}",
  "tUEyB3": "Importing...",
  "rX+nJg": "Import trade history",
  "J3fNDZ": "This month",
  "E0NcxQ": "Last 3 months",
  "lPShsT": "This year",
  "s+lPP3": "All time",
  "74vgSJ": "Time range",
  "ebsyku": "My trading performance",
  "RM2hgl": "Sample data",
  "OPkC7N": "What this page looks like with a year of trades",
  "TLFZUH": "From your imported Robinhood trades",
  "yPp6MA": "These numbers are an example. Import your Robinhood activity CSV and this page shows your own results.",
  "v3FUUN": "No trades in this period. Try a longer range.",
  "SZxMzN": "Key numbers",
  "JXYCuG": "Total P&L",
  "f3tYS8": "About {amount} per trading day",
  "frdDRv": "Win rate",
  "31CMuF": "Across {count} trades",
  "J9uqCq": "Profit factor",
  "HH3P1N": "Needs both wins and losses",
  "CauQjJ": "Each $1 lost, about {amount} made back",
  "ed7fzy": "Largest drawdown",
  "4BEceR": "Most it fell from a high point",
  "NiX9uT": "Each point is the running total at that day's close",
  "JcVSMb": "Daily P&L",
  "hreg2u": "Each day in {month}",
  "qWAtAh": "By ticker",
  "hrUnBT": "Which ticker made the most",
  "8arthz": "{count} trades",
  "X1BkPN": "low volatility",
  "kYXgI/": "normal volatility",
  "Oibvak": "high volatility",
  "GJ1lEe": "{name} has expired",
  "ETzlVJ": "{name} expires today",
  "TaqQu7": "{name} expires tomorrow",
  "6dCRsS": "Write a review or stop tracking it",
  "qHyTW1": "Check it before the close",
  "Hlnpps": "Up {amount} right now",
  "UvZ16D": "Down {amount} right now",
  "eCQt9W": "Take a look →",
  "AhvSpr": "{name} is {pct} from a sold strike",
  "NPW35l": "A move of about {points} points starts to hurt",
  "qffCWd": "May move the market",
  "UJQfky": "Macro event",
  "cxme7e": "{name} expires",
  "rkFB/J": "{time} ET",
  "nIDN2t": "Often moves the market",
  "tKX8iy": "Smaller impact",
  "zWgbGg": "Today",
  "YuycZQ": "US market open",
  "/jrcCT": "US market closed",
  "GCY0dr": "Market",
  "c0IFFx": "Today {pct}",
  "xwoKl5": "VIX {value} ({mood})",
  "8PvMjZ": "My strategies today",
  "HZetdf": "Nothing tracked yet",
  "9vPqc1": "{count} tracked · {winners} up, {losers} down",
  "SVNm5M": "Expiring this week",
  "ql3gYo": "Nothing expires in the next 7 days",
  "L3gu8h": "The nearest expires today",
  "kCPMIt": "The nearest expires tomorrow",
  "zB7rG3": "The nearest expires in {count} days",
  "J8cAGG": "Needs attention",
  "ADMDcn": "+ Add reminder",
  "QOAy/W": "Reminder",
  "zS3+iV": "e.g. Review last week's iron condor",
  "Q7Mnz2": "Date (optional)",
  "Y2CVS0": "All clear — nothing needs you right now.",
  "BNJagY": "Mark not done",
  "tQpQon": "Mark done",
  "9TErKa": "My reminder · {date}",
  "HUksLW": "My reminder",
  "zxb1ad": "Delete reminder",
  "Coy6SH": "Calendar",
  "kb3HsS": "Trading days left this year",
  "uaLaoc": "Trading days since {date}",
  "Q4g24h": "Trading days until {date}",
  "7IND0c": "All of {month}",
  "8OVI1m": "Today · {date}",
  "iKR+lr": "Back to one day",
  "Xyw7Y4": "Whole month",
  "W0hZ6y": "No macro events or expiries this month",
  "gSqFNc": "No macro events or expiries this day",
  "CTpgXu": "Value of the investment over time",
  "mKlmhg": "Lowest point {pct}",
  "Y4CW7K": "All at once",
  "g7bjQR": "Every week",
  "YaEHga": "Every month",
  "QT7hEe": "Every quarter",
  "561yCs": "Every year",
  "DlTYle": "If you had bought then, where would you be now?",
  "Ff3npZ": "Pick a ticker, a date and an amount; it replays real prices day by day.",
  "y4Eo2M": "Replay settings",
  "n5QvJy": "Start date",
  "zgEYiS": "How to invest",
  "u41foB": "Amount (USD)",
  "/bIiUw": "Each time (USD)",
  "c0XrfH": "Replay until",
  "As4HMM": "Replaying…",
  "UuYZob": "Start replay",
  "qLc/ld": "The replay could not be loaded. Please try again.",
  "ZpQ6us": "Result",
  "i2ZE5B": "{ticker} from {date}",
  "rjJ0yv": "Worth now",
  "wYBYdt": "Put in {amount}",
  "x9zwkN": "Gain",
  "fzH6GY": "Per year on average",
  "o4hKqH": "Biggest fall along the way",
  "GufXy5": "Value",
  "6EswL/": "Money put in",
  "aZbPsq": "Earlier replays",
  "JfG49w": "Open",
  "7h/SxN": "Monthly adds",
  "psQHJx": "Return range",
  "2SEDWH": "After fees and tax",
  "cVSCKc": "Added each month ($)",
  "8v8RsN": "Annual return (%)",
  "u8/88U": "Bad-year return (%)",
  "f91VBA": "Good-year return (%)",
  "QLRDAT": "Yearly fees (%)",
  "/yFqrS": "Tax on gains (%)",
  "Jr5tMR": "Years",
  "5RxU8A": "Starting amount",
  "7VnwiS": "monthly compounding",
  "5d/WPc": "monthly add",
  "Kv2YtY": "ending balance",
  "iuVrr4": " (",
  "Dp+l9/": "annual return",
  "rrWnge": ", ",
  "F3SSRi": "years",
  "iZcM81": ")",
  "GOATn6": "Monthly return",
  "AxDOiG": "Months",
  "LVtqqd": "Starting amount grows to",
  "NpVbMA": "Monthly adds grow to",
  "S+cLw1": "Ending balance",
  "BagSEj": "You put in",
  "yNgteA": "Earned from returns",
  "y1s/tR": "bad year",
  "1LUj1M": " and ",
  "M9rHAA": "good year",
  "/3DFFw": "each worked out once",
  "VkmOv5": "If returns are poor",
  "VR8YzH": "If returns are good",
  "RX1uhE": "Middle of the range",
  "7ojO80": "Monthly compounding",
  "fAPZhr": "fees",
  "ipPKTM": "tax on gains",
  "60yoJI": "what you keep",
  "Ml9tvh": "starting amount",
  "Ige1p7": "Return after fees",
  "tfPbAr": "Balance after fees",
  "cjLie9": "Taxable gain",
  "HJHKrH": "Tax paid",
  "c7hs9J": "Lost to fees and tax",
  "3PndDP": "Net gain",
  "bsDIPy": "Long-term calculators",
  "p1S7eD": "For years, not days: regular adds, a range of outcomes, and the real number after costs.",
  "wExAzx": "Calculator",
  "oaOXL5": "Good years",
  "23WQaV": "Bad years",
  "H5+NAX": "Balance",
  "AOI6LI": "{count} yrs",
  "QZEMm+": "Formula",
  "g4IidV": "Hide the calculation",
  "vsJ4NZ": "Show the calculation",
  "vMaDp6": "Express a directional view",
  "wmS2kr": "Shape a range or carry view",
  "+B/js+": "Trade movement and time",
  "uw/XvT": "Protect or reshape exposure",
  "JA5EZS": "Bull Call Spread",
  "CEoGfK": "A defined-risk bullish debit spread that exchanges unlimited upside for a lower entry cost.",
  "Qnw/66": "Bullish",
  "MxD6vP": "Debit",
  "OCbHib": "Capped upside",
  "BYG8vL": "Width between strikes minus the cost",
  "W2KShT": "What you paid",
  "K8ZzHW": "Bear Put Spread",
  "JLmqw+": "A defined-risk bearish debit spread for a measured move lower with capped reward.",
  "t9Ww7K": "Bearish",
  "2Iw4HH": "Defined risk",
  "8qhcGp": "Broken Wing Butterfly",
  "Zwyi64": "An asymmetric butterfly that shifts the payoff peak and changes the risk on one side.",
  "I7/6Bs": "Asymmetric",
  "G2Sx1j": "Targeted move",
  "gsKVsH": "Expiring right at the middle strike",
  "8r1p+j": "Wider wing minus the credit",
  "zGfAc4": "Iron Condor",
  "oF+IUK": "A defined-risk credit structure that benefits when price remains between two short strikes.",
  "mLvz+r": "Credit",
  "ASv306": "Defined wings",
  "Yc4o3e": "The premium you collect",
  "v3ow+a": "Wing width minus the premium",
  "BngmX1": "Iron Butterfly",
  "zdskl7": "A centered credit structure with its maximum payoff concentrated near one strike.",
  "W08Ku7": "Centered range",
  "qhTEzo": "Pin risk",
  "P3esPL": "Jade Lizard",
  "tgPdmY": "A short-put and call-spread combination that collects premium with asymmetric exposure.",
  "gJkHZk": "Income",
  "auhBZZ": "Asymmetric risk",
  "wU1eH/": "Like a short put if it falls hard",
  "mS8WNh": "Straddle",
  "GVA13j": "A symmetric two-leg structure centered at one strike and driven by movement in either direction.",
  "kd49zH": "Two-sided move",
  "6fFeZ0": "Convexity",
  "F3VvGB": "No cap",
  "hYNHGG": "Both premiums together",
  "zLk4mQ": "Strangle",
  "jA01Oi": "A two-sided volatility structure with separated strikes and a wider breakeven range.",
  "0dusgQ": "Wide move",
  "wjuBgH": "Two-sided",
  "sy4hXI": "Time Spread",
  "3OgfpA": "A same-strike, different-expiry structure that isolates relative time decay and term value.",
  "POMyDy": "Term structure",
  "RIULuy": "Time decay",
  "DNnPtu": "Same strike",
  "Gi+vNw": "Price sits at the strike when the near month expires",
  "WxYHUj": "Covered Call",
  "KZzSw0": "An income overlay that collects call premium while capping upside above the short strike.",
  "Lxvmvp": "Income overlay",
  "NdO7IB": "Stock exposure",
  "bytjHw": "Strike minus purchase price, plus the premium",
  "HvQYdV": "The stock falling, softened by the premium",
  "2MUZlt": "Cash-Secured Put",
  "oZOUBW": "A premium-selling structure that accepts potential stock assignment at the chosen strike.",
  "XPX/Qj": "Assignment",
  "X8y889": "Downside exposure",
  "xwKYHW": "Strike minus the premium, if the stock goes to zero",
  "1suwkn": "Long Put",
  "mcEaAi": "A direct downside hedge with limited premium risk and increasing value as price falls.",
  "HZemdo": "Downside hedge",
  "EYHw8t": "Premium risk",
  "4IXRIN": "The further it falls, the more it makes",
  "QcpLur": "It will rise or fall",
  "k7moAa": "It won't move much",
  "CKtwZR": "It will move a lot",
  "IhweV7": "Protect what I hold",
  "7/leLd": "Where do you think {ticker} goes next?",
  "ZsA2ql": "Market view",
  "YwrXpc": "About this strategy",
  "teADxz": "Most you can make",
  "QLYibs": "Most you can lose",
  "YPRgOM": "Try it in the workbench",
  "B7h6uL": "Learn how it works",
  "V4mLb8": "All topics",
  "xxg9v7": "Core concepts",
  "MicBq3": "Payoff",
  "v6rYjQ": "Risk",
  "KV+O0y": "Practice",
  "xdvBUY": "A few questions at a time. Ones you haven't got right yet come first.",
  "V8VdhC": "Mastered",
  "w1DTYJ": "In this set",
  "j1R+QE": "Last score",
  "y1Qr81": "Level",
  "UdtpV7": "Topic",
  "dgp0C9": "How many questions",
  "uS55uE": "No questions for this choice yet",
  "9hGA1m": "Start practice",
  "+23axj": "Set complete",
  "P768k7": "correct",
  "mSlTjl": "Another set",
  "ksbZO4": "Change level or topic",
  "ibUSAQ": "Question {current} of {total}",
  "WsGXkp": "✓ Answer",
  "Alz3GP": "Your pick",
  "xmF49T": "Correct!",
  "++l7ni": "Not quite",
  "CpNb11": "See results",
  "vdq4Hg": "Next question",
  "LHWk5F": "Height in the middle",
  "ZOnZYq": "At-the-money options are rich: buying costs more, selling collects more.",
  "X3e30b": "At-the-money options are cheap: buying costs less, selling collects less.",
  "yxDmP5": "At-the-money options are priced at a normal level.",
  "zG1F8i": "How high the wings rise",
  "4tfRtm": "Far-from-the-money options carry extra premium — the market is paying up for big moves.",
  "Iw+I3j": "Flat wings: the market isn't worried about big moves.",
  "D87sC9": "The wings bend by a normal amount.",
  "KJ0lGx": "Which side is higher",
  "mAmTqc": "Left is higher: people fear a drop more, so puts cost more (common for indexes).",
  "O7GXCr": "Right is higher: people fear a jump more, so calls cost more.",
  "LgPglG": "Both sides are about even.",
  "hCblsN": "Implied volatility across strikes",
  "DkxIgq": "Rich",
  "vVI22b": "Cheap",
  "hthCof": "Lower strikes",
  "/9FTru": "Near the price",
  "qshK65": "Higher strikes",
  "gwN7SL": "Your curve",
  "URL784": "Neutral",
  "jm/spn": "Reset",
  "EMqgIx": "Smile and Skew",
  "+GqWXc": "Educational example only, not financial advice",
  "X5pxp9": "Name that strategy",
  "wa2P/1": "What strategy is this?",
  "cC1L4r": "Across: price at expiry · Up and down: profit or loss",
  "iLuOpJ": "Close — it's {name}",
  "K1enjE": "Profit: {profit}. Risk: {risk}.",
  "6jxIJE": "Open in the workbench",
  "Oi87/W": "Volatility smile",
  "+20iSw": "Which strikes does the market price richer?",
  "zX8mxy": "Option rights and obligations",
  "6fpLnn": "Option",
  "+tCOWZ": "Buyer: right",
  "VgY0qi": "Seller: if assigned",
  "M6msls": "Buy at the strike",
  "KfnBTY": "Sell at the strike",
  "Y+QOjo": "Strike price",
  "GYkWVG": "The agreed buy price",
  "YjvJn3": "Expiration",
  "RP3hYa": "In 30 days",
  "2eCe/p": "The right ends",
  "RE3ors": "Premium breakdown",
  "GSGain": "Intrinsic value",
  "sev5fd": "Time value",
  "OpxkQd": "Expiration profit calculation",
  "ecS8Dj": "Expiration value",
  "dl1keI": "Premium paid",
  "kbLBuY": "Profit",
  "IL4Qg4": "Same call, different expiration prices",
  "0h1Wff": "Underlying at expiry",
  "lWVgwX": "Option value",
  "qLHsyu": "Buyer profit / loss",
  "x6ZRnG": "Maximum loss on this call",
  "Mjayw+": "Buyer: maximum loss",
  "R5nC8M": "The premium paid",
  "sM3cVf": "Uncovered seller: maximum loss",
  "/kN3Yy": "Remember this",
  "6FPUFh": "Course contents",
  "JIOlLn": "{done} / {total} done",
  "Jvdbat": "Daily practice",
  "1bUTsf": "{section} · Lesson {number}",
  "HK3ph8": "How it works",
  "xrCRnH": "Example",
  "9miVrB": "How it changes",
  "lBO+mc": "How it is built",
  "hH7EXB": "What moves it",
  "+jvttV": "Do a practice question",
  "+o/8P3": "Next: {title} →",
  "knUjT2": "Mark as done",
  "7JlauX": "Explore",
  "0ah2ud": "Space",
  "VMIM8/": "Analysis",
  "5yUsUe": "Replay",
  "p00N+q": "Compounding",
  "RSctv1": "Build",
  "pCWKud": "3D model",
  "D+v5e+": "Tracking",
  "avVNaX": "Strategy gallery",
  "EdBvQ5": "Recognition & surface",
  "Zkykx8": "Options theory",
  "4CrCbD": "Community",
  "VCMKbt": "Inbox",
  "NDx+B0": "Personal",
  "83dK3t": "Toggle language",
  "o0/SZQ": "AI assistant",
  "KOv/OJ": "Page tabs",
  "P1bU4o": "{days} days",
  "ewgnOI": "{hours} hours",
  "Xwb/1h": "Down 2%",
  "6kdJPp": "Unchanged",
  "FJkSzV": "Up 2%",
  "KJ+H2j": "Back to now",
  "IwgvVf": "What if…",
  "fjpowc": "{ticker} price",
  "1t0KYX": "Same as now",
  "hVvJRR": "{pct}% above now",
  "HDBEbb": "{pct}% below now",
  "yCle8w": "Time left to expiry",
  "lfhGP4": "How much the market expects prices to swing — higher makes options pricier",
  "T77nEZ": "In this case",
  "keXWWi": "{amount} more than now",
  "ejzuSU": "{amount} less than now",
  "jOWhbe": "Gain or loss",
  "IXb0HA": "Time cost",
  "QIUyHQ": "Price risk",
  "pZx3uk": "Volatility impact",
  "dPIOSt": "Which number to show",
  "NHQVSv": "Daily time decay",
  "DZ2Koj": "Direction",
  "5yFKER": "Direction change speed",
  "4blH1o": "Volatility sensitivity",
  "Yt0EtO": "How much you make or lose at that point",
  "brRlK6": "What the whole position is worth at that point",
  "nLZ0Sc": "How much you make or lose per day just from time passing",
  "O5yrxl": "How much you make or lose when the price moves $1",
  "RHIj7h": "How fast the direction number changes as the price moves",
  "rCWeDL": "How much you make or lose when volatility rises 1 point",
  "mv038n": "Loss",
  "PVGcgq": "Cheaper",
  "CJrA88": "Pricier",
  "9idWIv": "Time costs you",
  "f/cK7p": "Time pays you",
  "F4GXad": "Bets on a fall",
  "t4yQLQ": "Bets on a rise",
  "VRgMWX": "Steady",
  "0mTVq9": "Swings fast",
  "GNMXeA": "Barely reacts",
  "MLYgNV": "Reacts strongly",
  "b1zuN9": "Price",
  "ug01Mk": "Time",
  "h/1/v5": "Height shows",
  "ZFsxcy": "Colour shows",
  "UAYQOz": "Across",
  "RrLcW9": "Height = {name}",
  "YRHtS6": "Colour = {name}",
  "77Iatp": "Price S",
  "WGXTdT": "Strike K",
  "yYsILG": "Moneyness m",
  "bFdR14": "Volatility σ",
  "dfU1kx": "Days left T",
  "bFbJbG": "Further right, the higher the price.",
  "LiEK40": "Further right, the higher the strike.",
  "2BsvyJ": "Further right, the higher the strike against the price.",
  "nDuBJg": "Further right, the higher the volatility.",
  "qzW1Xi": "Further right, the more days left to expiry.",
  "h5gpvE": "Further back, the higher the price.",
  "UVziCU": "Further back, the higher the strike.",
  "rF1pvZ": "Further back, the higher the strike against the price.",
  "CTPS9y": "Further back, the higher the volatility.",
  "Fb6kGs": "Further back, the more days left. Near expiry the surface sharpens into the expiry line.",
  "DNGYsU": "Above the zero floor is profit, below it is loss.",
  "7l1MAG": "{sentence}.",
  "0va1RP": "How to read this chart",
  "hBpqPJ": "Price and time move together — profit or loss?",
  "I47tqT": "Past expiry",
  "1OaCCr": "Expires today",
  "syp54I": "Expires tomorrow",
  "LUwWqv": "{pct} from a sold strike",
  "Q4/nm9": "Watching",
  "CyY0OO": "Price per share",
  "MZ+Ksj": "per share",
  "BtANKA": "Premium received",
  "Rfp0wT": "Your fill prices",
  "r9wemy": "Estimated by the model when you saved it. Type your real fill to correct it.",
  "MtrTNy": "Tomorrow",
  "cZ1FA9": "In {count} days",
  "MguPVS": "Open review",
  "WYjFFK": "Recorded at {ticker} {price}",
  "8LKNRv": "If {ticker} expires…",
  "5Ws83M": "Shape",
  "xhQMeQ": "Expires",
  "tzMNF3": "Status",
  "NbMCpc": "Strategies I'm tracking",
  "GGTOGW": "Nothing is being tracked right now.",
  "17bpAU": "Totals",
  "SW6RNm": "Combined now",
  "zDN2m+": "{count} strategies · {winners} up, {losers} down",
  "t9e9y5": "Worst case, most you can lose",
  "TqbLpg": "If every strategy expires at its worst",
  "Cby8i2": "One expires tomorrow",
  "lXMl+7": "Within the next 7 days",
  "KTPiJ1": "Finished strategies ({count})",
  "wRc1f0": "Realized",
  "ZbAkDy": "Delete this tracked strategy?",
  "iRH/Yw": "It leaves the tracking page for good. Reviews you wrote stay in your journal.",
  "iJH4/q": "Buy call {strike}",
  "BYcrvD": "Sell put spread {high} / {low}",
  "0euVT9": "{pct} from the sold strike",
  "Pfhg1a": "This is an example. Build a strategy and tap Save and track — yours shows up here with live profit and loss.",
  "UMKDTc": "Go to Build",
  "v8B8F6": "Upper",
  "V9URnj": "Lower",
  "KtEZXn": "Long",
  "juU558": "Short",
  "cb2kY6": "Standard",
  "vRTZ4K": "Reverse",
  "WhCw5t": "Strip",
  "UvJpJt": "Strap",
  "JvUqIl": "Add strategy",
  "4Y/Ab3": "Near expiry",
  "0wjTjz": "{count} days left",
  "I97lFf": "Fewer dates",
  "XkNUgy": "More dates",
  "i1xha+": "Filter strategies",
  "1WRwEc": "No strategies match",
  "XU4+MR": "This expiry already holds {count} strategies, the most it can. Pick another date, or delete one first.",
  "PhY7Pq": "Halfway",
  "xhcwmC": "Just before expiry",
  "luTJgk": "Simulate a time",
  "LTWMkP": "ET · {days}d {hours}h to expiry",
  "6EeYsX": "Up at that time",
  "q/zar5": "Down at that time",
  "s3YoNc": "Up now",
  "ofK0y+": "Down now",
  "fhywne": "Each leg",
  "W/V6+Y": "Collapse",
  "0oLj/t": "Expand",
  "G4cWHH": "Pick one strategy on the left to adjust it.",
  "smpLHp": "{count} DTE",
  "HHH8MR": "Strikes",
  "fSFsx5": "Move strikes down",
  "6vaHZI": "Move strikes up",
  "1osJ1h": "Quantity (contracts)",
  "KI5I3A": "Decrease strategy quantity",
  "VUhEPq": "Increase strategy quantity",
  "p9QToR": "Premium you pay",
  "O022IZ": "All combined",
  "mDtdP3": "No strategy yet",
  "UT3At6": "My strategies",
  "n1Whvj": "Switch",
  "2ip6TD": "{count} strategies together",
  "eE4RqV": "Expired {date}",
  "/VQpyO": "Expires {date}",
  "wG5E1e": "Market data is not ready.",
  "tTxMax": "No active legs to record.",
  "GHE9Li": "Could not save strategy.",
  "xuXvQ+": "Turn this leg on",
  "GjsXP1": "Turn this leg off",
  "+MqqK2": "Lower this leg's strike",
  "MJUbr7": "Raise this leg's strike",
  "OrYssY": "Lower this leg's premium",
  "9iyAfm": "Raise this leg's premium",
  "9P8Aa0": "Premium per share",
  "UpiJbj": "Use estimate",
  "cyfLan": "+ Add ticker",
  "55ru1f": "Pick a ticker to start",
  "1peGKq": "Each ticker keeps its own strategies, like a folder.",
  "1XBnBy": "Build your first {ticker} strategy",
  "2nvHVU": "Pick a structure; you can adjust the expiry, strikes and legs afterward.",
  "fhGzJi": "Adjust",
  "PWpQsY": "Delete this strategy",
  "rDk0BN": "Change strategy",
  "U8o7F2": "Save and track",
  "CPEwfO": "Expired {date} · pick a new expiry under Adjust",
  "41HBlh": "Expires {date} · today",
  "Aq0OpM": "Expires {date} · {count} days left",
  "noADbl": "{name} will be removed from the workbench. Strategies you are tracking are not affected.",
  "2q3DnK": "If {ticker} expires below {price}",
  "cCnkS1": "If {ticker} expires above {price}",
  "SvEt3U": "If {ticker} expires between {low} and {high}",
  "UvxD/d": "Losses grow if the price keeps moving against you",
  "eV+wmZ": "If it expires in the worst range",
  "SgXUPO": "The further it moves your way, the more you make",
  "dz/i4w": "If it expires in the best range",
  "TxpTEx": "No single breakeven price",
  "NYvBK0": "Needs to rise {pct} from now",
  "LtnD+9": "Can fall {pct} from now",
  "s/lD8x": "Breakeven price",
  "MC+lq0": "{loss}; {breakeven}",
  "soTyye": "{loss}, losing at most {amount}; {breakeven}",
  "kDNmhM": "Delta",
  "SPjHkt": "Each 1-point rise makes about {amount}",
  "jQdTVj": "Each 1-point rise loses about {amount}",
  "a5o3nB": "Theta",
  "lLc5pq": "Each day that passes costs about {amount}",
  "duaBkR": "Each day that passes earns about {amount}",
  "urRYR+": "Vega",
  "SkdHny": "Volatility up 1% makes about {amount}",
  "cxwyPx": "Volatility up 1% loses about {amount}",
  "Wb9Iyu": "Gamma",
  "0SmzU+": "How fast Delta changes as the price moves",
  "tnZjAX": "Advanced analysis",
  "2L5PQy": "Greeks · time decay · 3D",
  "hATZi0": "Profit and loss chart",
  "e7Rt5M": "Nothing to chart: these strategies are past their expiry. Delete them, or pick one and choose a new expiry under Adjust.",
  "p4gDwk": "Payoff chart: profit and loss at expiry across prices",
  "i/HCb7": "Spot {price}",
  "OJXshN": "Breakeven {price}",
  "E+jB60": "Price {price}",
  "f+4VqO": "At that time",
  "mPeAtj": "Value now",
  "goYBDH": "At expiry",
  "esup98": "Profit zone",
  "saddNP": "Loss zone",
  "CM7DlJ": "{price}/year",
  "ueYsIr": "{price}/month",
  "I+1HSy": "Trial",
  "uNuVSs": "Flagship access ended",
  "CUVzHJ": "Subscription member",
  "wxFA74": "Membership",
  "/NokQV": "Annual plan · {price}",
  "lHgR2N": "Monthly plan · {price}",
  "CXsnkT": "Your last payment didn't go through. Update your card to keep 3.0.",
  "sP/VLr": "Cancelled, active until {date}",
  "NWED1U": "Renews on {date}",
  "hIHeqt": "1 day remaining",
  "6uS8Qe": "Opening...",
  "Oj9Phc": "Manage subscription",
  "PAes8S": "Cancel, resume, change card or download invoices",
  "ZBEnv8": "Couldn't open subscription management. Please try again.",
  "FoHB5c": "Renew subscription",
  "gczcC5": "Subscribe",
  "TwyMau": "Account",
  "6caMaA": "Referral Code",
  "HAtMf2": "1 referral",
  "WZWbrp": "{count} referrals",
  "0oL1zz": "Copied!",
  "u5aHb4": "Copy Link",
  "AjkQGQ": "Friends who subscribe annually through your link pay $98 instead of $168.",
  "PCSt5T": "Preferences",
  "Dxz5va": "Flip ",
  "vAyQap": "profit",
  "XIbwNE": "/",
  "hcmJ3s": "loss",
  "VedtZs": " colors",
  "dIfgoA": "Flip profit and loss colors",
  "aT5Flo": "{count} unread",
  "OCzXq7": "{count} messages",
  "aRAHZZ": "Loading messages...",
  "sqAJjf": "Messages could not be loaded.",
  "FazwRl": "Try again",
  "BX5BGP": "All clear",
  "u/yZzt": "In this entry",
  "NpWjvV": "Trading",
  "77DlKj": "Discipline",
  "ln1cCQ": "Achievement",
  "7jg/ge": "Could not save the notebook name.",
  "bEffjZ": "Could not move the notebook.",
  "odDlvt": "Could not move the chapter.",
  "n+mflb": "Could not delete this entry.",
  "Gj4ztn": "Could not delete the notebook.",
  "rZCxYP": "Notebook name",
  "pO99pv": "Save name",
  "pJ+8Yp": "All entries",
  "jeQ2Zg": "Notebooks",
  "Io+AJO": "+ New notebook",
  "MyIJbr": "Contents",
  "87ZCAe": "Entries",
  "G91Z0C": "Contents · {count} chapters",
  "U9O2UX": "Move notebook up",
  "fptBhp": "Move notebook down",
  "kehJ5O": "Rename notebook",
  "1qpYGC": "Rename this notebook",
  "hdoPUE": "Delete notebook",
  "k5IwIp": "This notebook is empty. Write its first chapter.",
  "hsiZMg": "No entries yet. Write down a plan, a review, or a rule you want to keep.",
  "VsSsWh": "Move chapter up",
  "X220vi": "Move chapter down",
  "vK2Mer": "Notebook",
  "J7KTJS": "No notebook",
  "wR7xTu": "Entry",
  "IPmY+p": "Chapter no. {number}",
  "3QmPY0": "Linked: {ticker} {name}",
  "Do1Pfd": "Chapters",
  "OkD4xZ": "Pick an entry, or write a new one.",
  "UrYcLf": "Delete this notebook?",
  "skHT4P": "Delete this entry?",
  "e++AM/": "“{name}” and the {count} entries in it will be deleted together. This can't be undone.",
  "d9+mTP": "“{title}” will be deleted.",
  "QjmqN6": "Section heading",
  "Dkkmwm": "Bold",
  "B2GmBO": "bold text",
  "k1MVLc": "Bulleted list",
  "lbsCQS": "Numbered list",
  "atzUcB": "Quote",
  "0XWmRm": "Divider",
  "Ldc2c7": "Math formula",
  "JBWS0c": "Link",
  "k5KdCo": "link text",
  "3/XSUG": "Formatting",
  "JfaoH6": "Back to writing",
  "TJo5E6": "Preview",
  "vs1u6W": "AI Assistant",
  "cyR7Kh": "Back",
  "U3e2LV": "Save to Library",
  "ZjmERS": "Log",
  "FffCH1": "My books",
  "xejP63": "Add to book",
  "FgBZZi": "Create new book",
  "bv2X6I": "Book",
  "dOgCSN": "Chapter",
  "XlrkAJ": "New book name",
  "JxHQPA": "e.g. My Iron Condor Notes",
  "DC2jfb": "Could not save. Please try again.",
  "SIfKJW": "Deep Guidance",
  "+xJ09d": "Ask about a strategy, a metric, or how something works...",
  "gFfm+i": "Ask a follow-up question...",
  "ZT0z9z": "Ask",
  "W/5hwr": "Something went wrong. Please try again.",
  "QrZMdi": "Thinking...",
  "B5dkeJ": "Reading your question carefully...",
  "9aALVT": "Consulting the strategy playbook...",
  "s4QB5O": "Cross-referencing options math...",
  "bDOKRs": "Checking historical volatility patterns...",
  "rY1htH": "Weighing risk across market regimes...",
  "c6IluE": "Formulating the clearest explanation...",
  "E1J2uJ": "Ask AI",
  "pig+2F": "Select month",
  "HppWvq": "Select year",
  "Ia/CZp": "Failed to save. Please try again.",
  "RSdGvw": "Failed to delete. Please try again.",
  "QVtFOj": "Failed to load data. Please try again.",
  "NQREOs": "Failed to update. Please try again.",
  "qGc0qW": "This item already exists.",
  "YPPpwY": "Cannot delete — this item is still in use.",
  "yluQWn": "Item not found. It may have been deleted.",
  "xhjcHL": "Too many requests. Please wait a moment.",
  "v7s25K": "Please sign in to continue.",
  "wX+jrn": "You don't have permission for this action.",
  "X8G8je": "This PIN is already taken. Try another.",
  "G18mTN": "An account with this email already exists.",
  "nRzzEa": "Connection lost. Check your network and try again.",
  "owYnPh": "Checkout could not be started. Please try again.",
  "eLHxis": "Import failed. Please check your file and try again.",
  "lF6IK8": "Enter your email to continue",
  "wq1FQY": "This email already has an account",
  "IoUxKH": "A market calendar built for trading plans",
  "+xDdOy": "Events, reminders, and attention points",
  "c4fSUd": "Replay a past market window in context",
  "zZ8y5V": "Layered multi-leg strategy modeling",
  "gjDKIh": "Price, time, volatility, and P&L in 3D",
  "CMqgq2": "Payoff, Greeks, and volatility surfaces",
  "nlAzCg": "Options theory and strategy recognition",
  "4mBq9J": "A personal knowledge base for notes and reviews",
  "+8xPrz": "Compound scenarios and context-aware explanations",
  "CjV8nU": "Review workspace",
  "x4GQmc": "Make every decision reviewable.",
  "Jjn7Fh": "Learn options, simulate strategies, and record and review your trading decisions in one workspace.",
  "xlN9Jm": "Built for reflection and risk understanding — not trade calls, execution, or investment advice.",
  "3eUVDM": "Check your email for your PIN",
  "vR2vRi": "Go to Login",
  "82Y7Sa": "Sending...",
  "/y8HkO": "Start with 2.0 for free",
  "yUVl6+": "email",
  "nYrQd6": "you@email.com",
  "+e/Mjn": "No card required. No trial countdown.",
  "hSNxZT": "View all plans",
  "odXlk8": "Log in",
  "qFsEJC": "Attribution",
  "SaqU2A": "Drawdown",
  "qhbpLN": "Expiry timeline",
  "F++dDy": "Decision notes",
  "AA5h7P": "Performance",
  "k96yNe": "This quarter",
  "+vBFap": "Reminders",
  "rhKUnG": "Review center",
  "HNqVXJ": "Position and decision review",
  "CtNvkT": "Bring market events, expiries, personal reminders, and historical context into one timeline without turning the calendar into a trade signal.",
  "wim34p": "Market planning",
  "Fl6Fj2": "Keep market time, events, and reminders in one place.",
  "8QPOWk": "Macro",
  "My2ZiO": "August 2026",
  "iWKF7c": "Review before the event",
  "dZga36": "SPX · 08:30 ET",
  "BeiV54": "Open market replay",
  "33XGsD": "SPX · 2025–2026",
  "uhe98j": "Market calendar",
  "znF9Ou": "Build layered option structures, read payoff and Greeks, then move through price, time, and volatility to understand how the risk changes.",
  "yUdneB": "Structure and dimensions",
  "8rQjEd": "Model the structure before capital is at risk.",
  "0MxxVa": "P&L and Greeks",
  "sJEG3n": "Time to expiry",
  "KQRIu5": "Multi-dimensional model",
  "5YL/Su": "Explore options in 3D",
  "cob9oz": "Study theory, recognize structures, save review notes, test compound scenarios, and turn explanations into a personal knowledge system.",
  "kAajM8": "Learning loop",
  "FYXy5I": "Turn every review into reusable knowledge.",
  "H136aY": "Compound calculator",
  "0PUDb+": "Context-aware guidance",
  "v++xuR": "Knowledge base and notes",
  "tIh0Js": "Knowledge workspace",
  "UjDl7O": "Scope and safety",
  "8PzAbn": "Built for reflection, not trade calls.",
  "VT73Hz": "ABG does not route orders, hold funds, or tell you what to buy or sell. It gives you tools to document, model, understand, and review your own decisions.",
  "loab8/": "Read scope and safety",
  "lG8JCg": "One workspace. Choose your pace.",
  "1RpBnq": "Use 2.0 General for free. Subscribe to 3.0 Flagship when you need deeper analysis.",
  "EaucLA": "View plans",
  "g5pX+a": "About",
  "zE1J/t": "Philosophy",
  "p1SM+f": "Scope & safety",
  "Rcp4Jx": "Official website",
  "xpod2V": "Preview mode",
  "aElHrs": "This is your branded landing page. Once live, fans visiting getabg.one/{slug} will see exactly this.",
  "4gGjKG": "Welcome, fans of {name}",
  "Ci8kNI": "Learn options, test ideas, and explore market behavior through interactive tools.",
  "p7fNYZ": "Fan-exclusive deal",
  "grwZlV": "1 Year",
  "uhAvqf": "Strategy structures",
  "zgE4dq": "Buy 1 year for $98",
  "t0yPJm": "Sign up for a free account",
  "q/GFui": "Includes 30 days of full access. No credit card. No invite code needed.",
  "aoT0kc": "No credit card. No invite code needed.",
  "VL/B6x": "your@email.com",
  "d82w2J": "Create a free account",
  "cXBJ7U": "Privacy",
  "Mwff1H": "Scan to Sign Up Free",
  "tru4ls": "Scan for the New Member Price",
  "ZFu/dr": "Scan for the Creator Annual Offer",
  "yK89ew": "Create a free αβΓ✻1 account — start with 2.0 General",
  "K2oKdT": "$98 a year when you subscribe within 3 days of signing up · normally $168",
  "BRLIKd": "One year for $98 · creator exclusive",
  "ME+0W0": "Member share",
  "mOBsIb": "Creator share",
  "qxHg3H": "per year",
  "W10lyi": "getabg.one",
  "3zhDZd": "Creator code: {code}",
  "EAO/K+": "Download PNG",
  "RyfXNL": "Share getabg.one",
  "zU/q1N": "Link copied",
  "wDWpwe": "Couldn't copy the link",
  "yLOx6H": "Share card",
  "zxvhnE": "Daily",
  "4fSUVQ": "Cumulative",
  "+dLAnb": "Estimated Total",
  "gDdkZX": "Estimated expiry P&L",
  "VpUKzG": "Current P&L",
  "EvJAQk": "Expected price",
  "Lv0zJu": "Details",
  "BvmTwT": "All strategies",
  "PzutAl": "Strike edit mode",
  "+IbuDO": "Drag the chart to change the strike price. Lock it to restore payoff inspection.",
  "RyG+bT": "INVALID PIN",
  "j0EUOG": "Your account is ready!",
  "NaVryt": "Your free account is ready!",
  "uWYDYQ": "Your 30-day full-access trial is active.",
  "HAlBRm": "Check your email for your login PIN.",
  "r2Jjms": "Log In",
  "B05Zig": "If an account exists with that email, your PIN has been sent.",
  "E6nn1R": "Don't see it? Check your spam folder.",
  "o/DO8l": "Email used at purchase",
  "kfL0Qd": "Send PIN",
  "7tSUe8": "Back to login",
  "wXVN4/": "Safety",
  "tluEJw": "Purchase Access",
  "dg8ZEb": "Close menu",
  "Spd88H": "Deselect all",
  "94Fg25": "Select all",
  "Gp8E4j": "My Strategies",
  "g/rwmh": "Generated Strategies",
  "jHJmjf": "No results",
  "k55jq9": "No saved strategies",
  "Ab9Hz6": "No generated strategies",
  "SNmzJ/": "Try a different search",
  "wl1b+c": "Save a strategy to see it here",
  "qkwNvX": "Generated strategies will appear here",
  "N87BeP": "Open All",
  "J1Hzu0": "Close All",
  "NKPfmm": "{count} selected",
  "AJXG3C": "No strategies yet",
  "iH2jXN": "Filter strategies...",
  "DRWfAe": "Duplicate Selected",
  "CA09f6": "Combine As New",
  "1sODf+": "Delete Selected",
  "0h4MAj": "Navigate",
  "kQAf2d": "Select",
  "+TsRJH": "Delete \"{name}\" permanently? This cannot be undone.",
  "h12Fxr": "Delete Strategy",
  "qCe51a": "Delete {count} strategies permanently? This cannot be undone.",
  "iXNbPf": "Rename",
  "4fHiNl": "Duplicate",
  "ZDo+Xb": "Flatten",
  "AVI/0j": "Split",
  "M56d6a": "Tabs",
  "bwAKk1": "Switch to tab 1-10",
  "PPJSRo": "Previous tab",
  "cEiT8I": "Next tab",
  "9a2ShG": "New tab",
  "HqPKrA": "Close tab",
  "nyPHb+": "Duplicate tab",
  "Kx4w9M": "Revert changes",
  "Hhi+or": "Toggle payoff / decay",
  "1iEPTM": "General",
  "0ajICy": "Show shortcuts",
  "Rq6Tqd": "Cancel / close",
  "nFkLBj": "Keyboard Shortcuts",
  "BHBJUz": "Are you sure you want to sign out?",
  "GjCS6U": "Choose a template",
  "oLVyck": "Combined",
  "BNSmGR": "Redirecting...",
  "FAhMYJ": "Unlock 3.0 Flagship",
  "pChEdk": "3.0 Flagship",
  "Jp8u8l": "Auto-renews. Cancel anytime.",
  "hOdd5/": "Unauthorized Access Detected",
  "6TAWBD": "Tampering with the interface to access paid features is a violation of our terms of service. Continued attempts will result in your account being disabled.",
  "p5wxjR": "I understand",
  "P8cAQd": "New book",
  "3Qevik": "Book name",
  "VzzYJk": "Create",
  "xaXcEh": "{count} books",
  "f6GoZg": "Delete Book",
  "NTYWCy": "Delete \"{name}\" and all its articles? This cannot be undone.",
  "C8RLOp": "Membership expires tomorrow",
  "qlC/X6": "Trial ends tomorrow",
  "s2gfPU": "Add Time",
  "F3ws3N": "Trial ends in {days} days",
  "vMnQkW": "Membership expires in {days} days",
  "rAoKdW": "Discard this tab?",
  "9X3q96": "Unsaved Changes",
  "m5ZIW0": "Save this new tab, or discard it?",
  "EPbatK": "Are you sure you want to discard this tab? This can't be undone.",
  "N33YMo": "\"{name}\" has unsaved changes.",
  "nmpevl": "Discard",
  "IeSXNb": "In development",
  "tf1lIh": "Free",
  "qxOTzD": "Your everyday workspace. No subscription required.",
  "NQEV8/": "Quickly add reminders, review upcoming expirations, and record your reflections.",
  "5YBB0f": "Review saved strategies as prices change, edit contracts, adjust strikes and spread widths, and simulate payoff.",
  "Qf74lF": "Learn options basics, Greeks, and strategy structures. Save your favorites and reinforce your understanding with quizzes.",
  "OhHiCw": "Manage your personal details and interface preferences.",
  "R/6nsx": "Subscription",
  "utj1/p": "Includes everything in 2.0 General, plus these features:",
  "/M0jfm": "Market calendar and performance",
  "AsQByo": "Macroeconomic events, trading performance, review and analysis, and compound growth planning.",
  "KB109+": "Multi-layer strategy builder",
  "rsEYOJ": "Combine multiple strategy layers and adjust each layer independently.",
  "7C9eJ1": "Advanced strategy monitoring",
  "MQuJ1/": "Go beyond basic tracking with Greeks, risk metrics and time-decay analysis.",
  "G9KZDq": "3D analysis",
  "51eRAk": "Examine payoff across price and time in 3D.",
  "/0kwWy": "Volatility surface",
  "+2MV36": "Study volatility surfaces, smile and skew.",
  "IrKPeO": "Strategy discovery and payoff recognition",
  "UmkJCu": "Compare strategy choices and learn to recognize payoff shapes.",
  "wxdvRr": "Personal knowledge notebook",
  "UmnFCA": "Capture trading thoughts and review insights, and gradually build your own knowledge system.",
  "UM7Ot1": "Creators, books and messages",
  "+MEUNc": "Creator profiles, shared posts, books, notes and messages are being rolled out in stages.",
  "hnvuOt": "3D Model",
  "s9xNrU": "3D",
  "YpVoLg": "Monitor",
  "7uLFdD": "Could not open this structure. Try again.",
  "sXyuGt": "Route and validate",
  "0Azlrb": "Manage",
  "Jdy2Mu": "Plan and review",
  "EbNaDn": "Knowledge Base",
  "UuA+7N": "Study structures and cases",
  "iHN12u": "Admin",
  "nG6XOe": "Operate users, KOLs, and system workflows",
  "GfKYkN": "Build. Manage. Learn. Explore.",
  "jLwPtz": "Four immersive paths.",
  "oOmpTH": "Creator verification",
  "KIT+yN": "KOL",
  "v0N8B2": "Apply to become a KOL",
  "c54D7x": "Personal space",
  "05muiR": "Application under review",
  "Ilv0jd": "Application approved",
  "wJfSNK": "Your KOL application has been submitted. Your dashboard will become available after approval.",
  "rOeXWb": "Your application has been approved. Refresh to open your KOL dashboard.",
  "s1u1Vq": "Refresh status",
  "hHQgTJ": "Tell us about your audience and content. We will review your application before enabling your creator dashboard and referral code.",
  "eWgjM2": "Your benefits after approval",
  "9+1x9N": "20% default commission",
  "P3A7yR": "Earn commission on qualifying paid orders through your referral code.",
  "H1CYrB": "KOLs and fans: $98/year",
  "CoCWPv": "You and your fans both get the $98 annual price, compared with the regular $168. Sign in to use your KOL price; fans use your referral code.",
  "62wdi4": "Your own referral tools",
  "NY8HFB": "Get a referral code, share card, and a dashboard for conversions, commissions, and payouts.",
  "tloLHf": "Your commission rate is confirmed during review. At 20%, a qualifying $98 order earns $19.60. Refunded orders and your own purchases do not earn commission.",
  "CvXn/g": "Application not approved",
  "r/YHV4": "Update your details below and submit again.",
  "DR+23P": "Contact email",
  "Mmuj1R": "Platform",
  "pzTOmv": "Followers",
  "CzoQvD": "Public profile link",
  "cvtlil": "Handle (optional)",
  "oawD4b": "About your content and audience (optional)",
  "WIKG6H": "Could not submit your application. Check your details and try again.",
  "txkW56": "Submitting...",
  "BX2m3F": "Submit application",
  "QNcfGl": "Open AI assistant",
  "YXdf6z": "Expand workspace navigation",
  "3C0JhM": "Collapse workspace navigation",
  "3bok0w": "Event day",
  "yAGd/7": "Event window",
  "34jtTc": "Keep the macro tape on the same date baseline as the checklist and journal prompts.",
  "z1SWb+": "Read the selected time range as one macro sequence without leaving the workspace shell.",
  "ZvKSfJ": "Events",
  "CRJk7g": "High impact",
  "9yK8v8": "Days covered",
  "IM6CNm": "Macro calendar",
  "CykfDS": "What lands on this trading day",
  "Meph9+": "What lands across this selected range",
  "PTfLbg": "Loading economic events...",
  "yFXsYM": "Economic events could not be loaded right now.",
  "p31OA7": "No scheduled macro events in the selected range.",
  "1ZSRb3": "Buy the underlying at",
  "Ovw9as": "Later expiration",
  "eW2nXZ": "Near expiration",
  "9HBUv2": "Option premium received",
  "bGbPPs": "Option premium paid",
  "1T7PlY": "Total initial outlay",
  "Xy6kv5": "At the first expiration, suppose the sold options expire worthless and the remaining options are worth",
  "tYW8sC": "Position profit",
  "/OddsD": "The remaining value is an assumption, not a forecast. First-expiration maximum profit and breakevens depend on that value.",
  "HelADF": "With other factors unchanged, for each stock-price rise of",
  "8Ez65Z": "1 yuan",
  "QOjuw7": "Delta =",
  "eW015n": ", the option price rises by about",
  "e51EAt": "0.5 yuan",
  "5l4WKl": ", the option price falls by about",
  "Hwl7Hv": "Positive means a rise; negative means a fall",
  "JUfWg+": "With other factors unchanged and an initial Delta of 0.5, the stock rises by",
  "Cf1wf1": "Gamma =",
  "0DBLpk": ", Delta becomes approximately",
  "9Tfhlv": "Positive Gamma increases Delta on a stock-price rise; negative Gamma decreases it",
  "yc9yHQ": "With other factors unchanged, time passes by",
  "+7PjfV": "1 day",
  "OPEbqF": "Theta =",
  "USw6Qj": ", the position value per share falls by about",
  "eHPr4L": "0.08 yuan",
  "u5n2eD": ", the position value per share rises by about",
  "HTqXwB": "Negative means time decay; positive means time passing helps the position",
  "LKD/8v": "With other factors unchanged, implied volatility rises from 20% to 21%, an increase of",
  "z5qjdP": "1 percentage point",
  "MKXMYj": "Vega =",
  "5bJ+Jx": "0.12 yuan",
  "Dvdctb": "Positive benefits from rising implied volatility; negative benefits from falling implied volatility",
  "pnvbub": "With other factors unchanged, the risk-free rate rises from 4% to 5%, an increase of",
  "VAlW65": "Rho =",
  "C7rvyQ": "0.04 yuan",
  "IE6v1q": "Positive benefits from rising interest rates; negative benefits from falling interest rates",
  "y8xGL8": "Learn about {greek}",
  "5ugQQF": ":",
  "cQgyKS": "Read the full lesson",
  "6PqMEg": "For share-settled options: the buyer pays for the right; the seller receives the premium and must perform if assigned.",
  "fbpcKJ": "The strike is the agreed trade price; expiration is when the right ends.",
  "U6qM8/": "One example throughout: buy a call for 3, with strike 100 and 30 days to expiration.",
  "hTgCxK": "Time value disappears at expiration.",
  "t09Ouk": "At purchase, the underlying is also 100, so exercising immediately has no price advantage.",
  "8WlOCe": "All amounts are per underlying unit before costs. Multiply by contract size and quantity.",
  "imMkmn": "If the underlying finishes at 110, the 100 call is worth 110 − 100 = 10.",
  "zfp8hv": "Breakeven: 100 + 3 = 103. A rise to 102 still loses 1.",
  "/Xpuju": "Assignment means the seller must fulfill the contract: trade shares at the strike for share-settled options, or pay the settlement amount for cash-settled options.",
  "4AyL7g": "No upper limit",
  "skb8c+": "In the same example, the buyer earns 7 at expiration price 110, while the seller loses 7.",
  "gxb72O": "For example, with Delta = 0.5 and other factors unchanged:",
  "EidxI5": "The stock rises by",
  "oGkLU3": "The option price rises by about",
  "devz9w": "For example, with Delta = 0.5, Gamma = 0.04 and other factors unchanged:",
  "osrPrr": "Delta becomes approximately",
  "kGQ3oZ": "0.54",
  "4voegA": "For example, with Theta = -0.08 and other factors unchanged:",
  "9DzSVK": "Time passes by",
  "uDMPDT": "The option price falls by about",
  "zIRb1e": "For example, with Vega = 0.12 and other factors unchanged:",
  "CKLcxn": "Implied volatility rises",
  "D8Wqtt": "20% → 21%",
  "pbDpUK": "For example, with Rho = 0.04 and other factors unchanged:",
  "dP+85H": "The interest rate rises",
  "gZm9JC": "4% → 5%",
  "XadlV3": "These are local estimates. Option-price amounts are per share; multiply by the contract multiplier for one contract.",
  "Pgb3Xj": "Subscribed",
  "o2jbDD": "Permanent",
  "jgwGCD": "Join αβΓ✻1: subscribe within 3 days of signing up and 3.0 Flagship is $98 a year, locked for life (normally $168): {url}",
  "TUZLas": "Copy failed",
  "oVTz5V": "Share link ready",
  "YDMrKK": "Users",
  "+fkGwM": "Preview annual share card",
  "0t5b/d": "New member annual price",
  "GQNYob": "Share link",
  "A8NtAB": "Open card",
  "iBvMKT": "Share new member price",
  "hYOE+U": "Invite",
  "8zAvdb": "Search name, email, PIN...",
  "V6wm5v": "users",
  "XWcjJb": "No users found",
  "9zub+u": "Alerts",
  "ia1YFT": "Backtests",
  "/jJLYy": "Transactions",
  "JpAnzp": "Push Subs",
  "rELDbB": "Refresh",
  "TYDU5O": "Verify public account ownership and review the content sample. This is separate from KOL partnerships and does not certify legal identity, financial qualifications, or investment advice.",
  "vh/xzj": "Awaiting verification",
  "ev3rDM": "Verified accounts",
  "1+1Hds": "Review history",
  "gjBiyj": "Loading...",
  "LsyfBy": "Could not load verification. Please retry.",
  "iG52Ww": "No applications in this section",
  "SNGt6J": "Public profile URL",
  "dCyf13": "Original content URL",
  "jvnB1y": "Verification history",
  "6XFO/C": "Approved",
  "f0W26f": "Revoked",
  "5qaD7s": "Rejected",
  "NsR8eR": "I found the exact verification code on the submitted public profile and checked that the account belongs to this applicant.",
  "8+wvAx": "I reviewed the content sample for authorship and community-rule violations.",
  "9pa0x2": "Review evidence or reason (visible to applicant)",
  "oKMkXN": "Review failed. Refresh the list and try again.",
  "KEYvbc": "Approve verification",
  "VzIOKf": "Reject",
  "BCyfIg": "Revoke verification",
  "pP1R8y": "Sections",
  "VNMoVv": "Your business at a glance. Start with what needs attention.",
  "MUUNrD": "Understand each customer, their membership, and the next step.",
  "EQelVe": "Connect creators and channels to customer acquisition.",
  "Hh+1AP": "Review payments, refunds, and creator commissions.",
  "OJNUL8": "Manage your library, questions, and publishing in one place.",
  "Vf8WU1": "Review activity and manage administrator access.",
  "m6lDC9": "Management",
  "GU7MQx": "Back to product",
  "mbVtNk": "Product analytics",
  "TkYZBT": "Customers",
  "k26pcw": "Follow-ups",
  "u3lsRD": "Membership lifecycle",
  "NAidKb": "Notifications",
  "8pSzl8": "Creators & channels",
  "MDjCOx": "Referral codes",
  "26VckP": "Public learning",
  "X7jl6w": "Orders",
  "Qcar/2": "Commission settlement",
  "2YjM5/": "Social publishing",
  "5+NtAh": "Community reports",
  "t0lUqz": "Activity log",
  "yAaNQA": "Admins",
  "D1sYbh": "Access source",
  "3a5wL8": "Active",
  "1Ns+S9": "Permanent access",
  "R4FxHZ": "Send Notification",
  "/xwYHP": "Sent!",
  "vASobk": "Notification History",
  "PsqxSX": "No notifications sent yet",
  "8N9wG+": "Recipients",
  "filwqD": "Read",
  "0HT+Ib": "Archived",
  "eF0SIH": "Failed to load notifications",
  "ztdbt+": "Delete this notification history record?",
  "SDlYwM": "All Users",
  "QHOTHT": "By Membership Source",
  "kF2z/O": "Specific Users",
  "AmzvJO": "By Expiry",
  "VAdNNz": "Failed to send",
  "Sh368n": "{count} selected users",
  "Bl8xZP": "After {date}",
  "U5sjCv": "Before {date}",
  "HQJg+h": "Compose Notification",
  "W7hXJH": "Message body...",
  "OsIhLl": "Link URL (optional)",
  "ngyB8X": "Send to",
  "p/iF5T": "Search users...",
  "mfnxVr": "Also send push notification",
  "+Nk8iq": "Delete notification",
  "X0hrh/": "Guide book not found.",
  "P8tT2t": "Loading book...",
  "Kq4pTx": "Book not found",
  "J/9jle": "Title (English)",
  "RtFDsr": "Title (中文)",
  "zn0GuF": "Subtitle (English)",
  "oLHosz": "Subtitle (中文)",
  "/bdKNj": "URL slug",
  "3KNMbJ": "Articles",
  "ylNz/0": "New article",
  "cr52zp": "Article title (English)",
  "jfk+6j": "Untitled article",
  "mKC2Yq": "No articles yet. Add one to get started.",
  "TVPV0v": "Select an article to edit, or add a new one.",
  "i4jvwu": "中文",
  "pLur/+": "Article title (中文)",
  "502Gaj": "Body (markdown)",
  "72RCKz": "Delete this article?",
  "qvc9uM": "This cannot be undone.",
  "wmFdws": "Move up",
  "H/r5m6": "Move down",
  "5ljKSh": "New chapter",
  "WNVxCo": "Chapter name",
  "qrkQuq": "Customers from this channel",
  "ljxw1z": "All customers",
  "4GbUB6": "Customers who used this code. Open a customer to review payments and add a follow-up.",
  "B8Sffs": "Back to creator",
  "bVjFta": "Search customers",
  "RYhDwR": "Search name or email",
  "M/IYmR": "Paid through this channel only",
  "t7oXQZ": "{count} customers",
  "gk/lxB": "No customers match these filters",
  "xhnYsq": "Page {page} of {pageCount}",
  "R6oUU3": "No accounts expiring soon",
  "VLj+gQ": "No recent signups",
  "7EMIS2": "1 day left",
  "FBaarm": "Subscriber",
  "vc26Tu": "EXPIRING SOON",
  "kuMUY8": "{days} days left",
  "CzyDZP": "NEW USERS (7D)",
  "sSynIO": "{days}d",
  "Mn4m0R": "Send Invite",
  "/QToxN": "A user with this email already exists",
  "kmwJw5": "Failed to send invite",
  "Mh7T6y": "Invite User",
  "UQwQCj": "Send an invite email with a login PIN",
  "IuFETn": "Duration",
  "SeliBa": "1 Week",
  "EvG8up": "1 Month",
  "8oX0zs": "3 Months",
  "2QQ5Y5": "No posts yet. Compose one above to get started.",
  "2atspc": "Drafts",
  "cXAlMR": "Scheduled",
  "QYYHH3": "Posted",
  "eR3YIn": "Posts",
  "FuJAJi": "Demo Videos",
  "IvjoDS": "Connected",
  "5cFOSr": "Connection failed",
  "TDaF6J": "Dismiss",
  "4l6vz1": "Copy",
  "p556q3": "Copied",
  "QsGagw": "Repurpose",
  "fIEqiO": "Repurposing...",
  "rO/m1g": "Mark Scheduled",
  "TfJ0ks": "Mark Posted",
  "sjdr1Y": "Back to Draft",
  "meoXOo": "Delete this post? This can't be undone.",
  "DLEiSJ": "Publish now",
  "TMicLW": "Send reminder",
  "PesLat": "Publishing...",
  "lqFAMd": "View live post",
  "NEzsjp": "Reminder sent — post manually",
  "eDy55B": "Last publish failed",
  "w7tf2z": "Published",
  "Z1QE8U": "Generate voiceover",
  "y+cNoO": "Regenerate voiceover",
  "Di/X8a": "Generating voiceover...",
  "VMXG0i": "Voiceover generated",
  "5q3qC0": "Download",
  "NfIrYa": "Scheduled for",
  "ssDLEL": "Pick target platforms to generate variants for:",
  "wgr8yV": "Run Repurpose",
  "bVttEp": "No demo videos rendered yet. Pick a script or scene below and run the command on your laptop.",
  "lbr3Lq": "Copy link",
  "iVojI9": "Delete this video? The blob is removed from storage.",
  "+pwUpZ": "Connected accounts",
  "FjU4Qa": "Nothing connected yet. Connect a platform to publish on Kiera's behalf.",
  "+vVZ/G": "Connect",
  "Eg11ZY": "Reconnect",
  "qj1uhz": "Disconnect",
  "pT/nDf": "Disconnect this account? You'll need to re-authorize to publish through it again.",
  "7KMbBa": "Never used",
  "iQhFxR": "Last used",
  "lpbja4": "Paste a Discord webhook URL",
  "Mww6Lr": "Paste credential",
  "TMzzGO": "Loading connections...",
  "PrboG4": "Record sample",
  "q/uwLT": "Stop",
  "3MawrJ": "Submit sample",
  "ewf7D2": "Re-record",
  "raexxM": "Submitted",
  "pGCLGL": "Recorded",
  "vXCeIi": "Failed",
  "bZMC5A": "Voice samples",
  "/U9cX/": "Add body text to read before recording.",
  "zCzIEc": "Microphone permission denied",
  "AUFgrw": "Delete this sample? This can't be undone.",
  "CHpZ5E": "Compose Post",
  "PrvdcD": "Topic, e.g. Iron Condor isn't actually safe",
  "dTo23t": "Hook (first line)",
  "1NdqJf": "Body",
  "x/kNJT": "Ending line",
  "4osWT/": "Internal notes (not generated)",
  "ea6iUX": "Audience",
  "s9SGwm": "Topic Ideas",
  "eNR+LY": "Generate Script",
  "A/lLjO": "Generating...",
  "E048/V": "Save as Draft",
  "CjBL+W": "Schedule for (optional)",
  "2w42m1": "Uses Gemini to draft hook/body/ending. Edit anything afterward.",
  "m5CvOs": "TikTok",
  "13nSzN": "Xiaohongshu",
  "Rb/hb9": "LinkedIn",
  "MXPwVk": "X",
  "iJOiJr": "Reels",
  "w+2Vw7": "Shorts",
  "LzrJWg": "Reddit",
  "FvmV6q": "Discord",
  "1kOFp2": "Threads",
  "0H9Fkb": "Beginner",
  "UTY9Hd": "Early Trader",
  "NGE30i": "Product Users",
  "grfUHB": "Reported by",
  "ZKJI84": "Post edited since report",
  "53wI5L": "This post is no longer visible in the community.",
  "CAZE2E": "This decision resolves all pending reports for this post.",
  "Q/oTBs": "Review note",
  "6JZeyv": "Could not save this review. Refresh to check whether it was already handled.",
  "yBwLaS": "Hide post",
  "23o/Oc": "Dismiss reports",
  "x9mO/b": "Post hidden",
  "/lWTag": "Reports dismissed",
  "yb28IP": "Could not load reports. Please refresh.",
  "VUhaqI": "No reports in this queue.",
  "WbCnuv": "Pending review",
  "JysGE6": "fans",
  "XwJ+oH": "Code users",
  "7sujJr": "Paid conversions",
  "yIuROp": "Commission owed",
  "iNWbVV": "Handle",
  "ooeJ6o": "Vanity URL",
  "5CuZ1f": "2–32 chars: letters, numbers, _ or -. This is the share link fans click.",
  "V4KNjk": "optional",
  "+1HAHt": "Profile URL",
  "mznk9z": "Commission",
  "qbrnAy": "Content notes, negotiated terms, contact context…",
  "1+MVJi": "Confirm & send PIN",
  "oSRgw2": "Email is required to send the PIN",
  "T7yqEv": "This KOL is already onboarded",
  "1mxbAQ": "Failed to onboard KOL",
  "ld9uH3": "Onboard {name}",
  "+O+xBF": "Creates a free General account, mints its affiliate code, and emails the PIN. Existing membership access is preserved.",
  "q/lD8z": "Linked existing user {email}; membership access is unchanged",
  "SgjGlq": "PIN email sent to {email}",
  "CZ6VD0": "PIN:",
  "8S9nW1": "Code:",
  "FhDDzO": "Link:",
  "zND/qF": "Custom code",
  "2my2Wa": "leave empty for auto-generated",
  "4dEFst": "Used in ?ref=CODE. Auto-generated if left empty.",
  "Mjp+Mk": "On confirm we will:",
  "+hTUJX": "Create a free General account with the $98 annual KOL offer",
  "SP+5y6": "Mint the affiliate code and link it to this KOL",
  "buyckq": "Send the login PIN to the email above",
  "0QwyJz": "Transition status to Onboarded",
  "bFhfbm": "That slug is already in use",
  "Vflwur": "That slug is reserved — pick another",
  "WP4Inj": "Failed to save changes",
  "Qva+p6": "Delete KOL",
  "yyI2mr": "Delete this KOL?",
  "QA6slB": "This removes the KOL record permanently. Affiliate codes stay active but lose their owner; payouts and activity are deleted.",
  "FQhUrc": "Edit KOL",
  "nTERwx": "Fix typos, update the handle, or tweak the commission. Status changes still happen on the detail view.",
  "noZdV2": "Deleting...",
  "WVr1QB": "Promotion links",
  "rwb0M0": "Add channel link",
  "XNrWgU": "Links can be reused. Add a separate link only when you want to compare platforms or campaigns.",
  "LAWbIE": "Share each channel's own link or card. The general creator QR code does not distinguish channels; forwarded links keep their original channel.",
  "rK7lyq": "No codes yet",
  "c4gwlB": "Onboard this KOL to mint their affiliate code",
  "OROnnO": "Uses count people who used the code, not visits or scans. Paid people and commission exclude refunded payments.",
  "Z1xMl5": "Unnamed channel",
  "3+UWwF": "active",
  "ajHSDV": "inactive",
  "ySey5M": "No usage limit",
  "rCQZuH": "Usage limit: {count}",
  "zzLV/+": "Paying users",
  "h/0Uuh": "View channel customers",
  "j83w0v": "Rename channel",
  "/xYsBJ": "Channel name",
  "jYZep+": "For example: Xiaohongshu profile or X bio",
  "ajMpUE": "Copy only",
  "pX3pgH": "Logging...",
  "8A/ETL": "Copy & log as sent",
  "2XHGT+": "DM outreach — {name}",
  "FxdJbu": "Pre-filled with their name, platform, slug, and commission. Copy or log as sent.",
  "Yu9Sqk": "Their content (fills [具体内容])",
  "aZQTyb": "e.g., 上周那篇讲 IC 宽度的笔记",
  "LkKgAV": "Must be something you actually read — OUTREACH.md 七 says: \"不要群发同一模板\"",
  "/30QJQ": "chars",
  "qMePPG": "Note",
  "p7ZDhz": "DM sent",
  "9HU8vw": "Reply",
  "xdVU3q": "Payout",
  "h2vipu": "Code",
  "pEvEiR": "Onboarded",
  "ZmlNQ3": "Activity",
  "tgdyVz": "Log a DM, reply, call, or note…",
  "aojEGT": "No activity yet",
  "QgUPiQ": "Save Prospect",
  "3HWlMG": "Failed to create KOL",
  "vNMhsQ": "Add a KOL prospect",
  "NaJZGd": "Log them as a prospect now. Onboard (send PIN + create member account) once they confirm interest.",
  "g4xMRn": "KOL applications",
  "8FwoEX": "Could not load applications. Please retry.",
  "7BIjuP": "No applications awaiting review",
  "gg41yf": "Commission (%)",
  "cBdv6t": "Review note (required when declining)",
  "W9gzl6": "Approval links the applicant's account and creates a referral code. KOLs and fans get the $98 annual price; membership is purchased separately. The review note is visible to the applicant.",
  "x7gRnZ": "Could not save the review. Refresh and try again.",
  "mgwARF": "Approve & onboard",
  "+uc1nO": "Decline application",
  "apr6+g": "QR code",
  "Jlfnum": "Set a vanity slug to generate QR",
  "6vl1G/": "Encodes",
  "R8Q6VQ": "Add this QR code to the creator's profile or video. Scans open their branded landing page.",
  "xzV2K7": "Copy image",
  "MJ2jZQ": "Total",
  "77NxdU": "Total commission",
  "NkF305": "Effective total commission",
  "Q4P6gR": "Current owed commission",
  "56Oum3": "Add KOL",
  "jeoCCx": "Search name, handle, slug…",
  "w6DJdz": "No KOLs match",
  "Fh63wD": "No KOLs yet — add your first prospect",
  "fwIt1X": "Newest",
  "faeHEC": "Most owed",
  "Mhy6AE": "Most conversions",
  "51PqHa": "Most followers",
  "trkSSY": "Name A→Z",
  "8TBgHc": "KOL pipeline",
  "R27mKm": "By platform:",
  "FjxWsX": "Sort:",
  "ydIlLR": "No handle yet",
  "6C3LyS": "profile",
  "LUrJwE": "Channels",
  "y9xHR9": "Payouts",
  "WlSvN2": "Draft DM",
  "ZgxxPi": "Confirm & Onboard",
  "7PhW5W": "Codes",
  "6/+RUy": "Refunded commission",
  "w4JmUR": "Deal terms",
  "Zf7Od0": "KOL & fan price",
  "UW3ZZn": "General creator QR code",
  "Wn+3o7": "Save payout",
  "wbtiQC": "PayPal",
  "mtIIl7": "Bank transfer",
  "3yNuzn": "Alipay",
  "/VnDMl": "Other",
  "d5engH": "Record payout",
  "y+W1RE": "Record a transfer you have already made. This does not send money.",
  "H9mMTC": "Period start",
  "p9+GhL": "Period end",
  "W+1MOm": "Method",
  "V8yJy5": "Unset",
  "PT6kJ+": "Reference (Stripe tx / PayPal receipt)",
  "lwzj63": "No payouts recorded",
  "KLRorU": "No payments yet",
  "8WKgF6": "Revenue",
  "iYc3Ld": "Payments",
  "jtkU3K": "Conversion",
  "XT3gth": "Avg/User",
  "rkMuwE": "REVENUE",
  "/ROgfO": "SIGNUPS",
  "HyMNOt": "RECENT PAYMENTS",
  "A0hXXD": "Customer follow-ups",
  "TeM9UL": "Open a customer profile to add notes and schedule the next step.",
  "H62Zq/": "{count} overdue",
  "Vqhn1a": "Note or next step",
  "LNdZab": "Record the conversation and what to do next.",
  "1TVtQr": "Follow-up date (optional)",
  "KASrlC": "Adding a date creates a follow-up task. Saving a note does not send a message to the customer.",
  "mFRqx3": "Save note",
  "9AanEp": "No follow-ups or notes yet",
  "LH4hW1": "Showing {shown} of {total} records",
  "CzkhrD": "Follow-up",
  "8ujEro": "Reopen",
  "SRJo9I": "Mark complete",
  "95stPq": "Completed",
  "w8TgQj": "Payoff formulas",
  "dMPPSn": "Risk and assignment",
  "W6nwjo": "Draft",
  "5hUPMv": "Board",
  "wTo1un": "Apply filters",
  "UkjwCx": "{count} questions",
  "ptXbgj": "Hide answer",
  "WPipUN": "Hint answer",
  "WCaf5C": "Approve",
  "zz6ObK": "Restore",
  "hrgo+E": "Archive",
  "kgOBET": "Question",
  "TTrWwx": "Answer choice",
  "E1bF/X": "Explanation",
  "Zh+5A6": "On",
  "OvzONl": "Off",
  "Z5dM3R": "Referrer",
  "XMrYSI": "Invitee",
  "Ov2lv+": "REFERRALS",
  "WuHoZ9": "Conversions",
  "bym6gd": "Historical days rewarded",
  "R49KHd": "Affiliates",
  "4Ox3qJ": "No referral codes",
  "zINlao": "Owner",
  "+U6ozc": "Type",
  "Vb+qQ4": "Uses",
  "9rufIf": "RECENT REFERRAL EVENTS",
  "u/vOPu": "Paid",
  "n2haU6": "A clear view of customers, revenue, and the work ahead.",
  "irFBKn": "Last 7 days",
  "Nrw5ql": "New registrations",
  "Eryyuj": "{activated} activated · {pending} awaiting first login",
  "oBPPMi": "Activation requires a successful PIN login",
  "9fFUJh": "Completed payments",
  "DzzxOZ": "Excludes refunds",
  "ohjvu+": "Active users",
  "ud+HGc": "Distinct active customers",
  "U2ovSU": "Open an item to take action",
  "m8DyqM": "Notes, due dates, and next steps",
  "+wzGTM": "Creators awaiting settlement",
  "eGKhde": "Membership renewals",
  "f5haIV": "Review upcoming expirations and recent signups",
  "nz0okQ": "Customer base",
  "u1zcPD": "Registered accounts",
  "/Tv1tX": "Daily trend",
  "pg6z4S": "Signups",
  "acoEBu": "No data yet",
  "IluOt9": "Recent sign-ins",
  "hILBnf": "Open customer profile",
  "CcM05v": "Nobody has signed in yet",
  "ujG2R1": "Promotion",
  "B+uzbw": "Orders & commission",
  "+CwN9C": "System",
  "glTTlD": "Admin navigation",
  "3wNgxT": "Trials",
  "u4eb+l": "Subscribers",
  "Gs86nL": "Refunded",
  "M1w9up": "Awaiting payment",
  "6uJSpm": "Orders for this customer",
  "lNZuWl": "All orders",
  "j7sRXm": "Matches current filters",
  "vQt5XU": "Order history",
  "+VcRi3": "Search orders",
  "HZUgIf": "Search email or order reference",
  "6D+yYX": "Payment status",
  "fvK8Qi": "All statuses",
  "iLe1MK": "No matching orders",
  "hkENym": "Customer",
  "/0TOL5": "Amount",
  "qNTqBe": "Open customer",
  "qxrDKi": "Creator commissions",
  "Bts3K2": "Outstanding only",
  "PPO9Jt": "Commission excludes refunds. Open a creator to review payout records and record settlement.",
  "qhXbDi": "No outstanding commissions",
  "0OBzsv": "No creators yet",
  "udXPv8": "Expires in {days}d",
  "ONySWH": "no email",
  "9vPzIO": "Total spent",
  "mJbA00": "Delete User",
  "tbcrjL": "Resend PIN Email",
  "xh2pgL": "Customer profile",
  "m/jplS": "Notes & follow-ups",
  "kyCLGJ": "Registration date",
  "5O2wWW": "Acquisition source",
  "NHzoVK": "No referral recorded",
  "wv3Ip3": "USER INFO",
  "xU7mdo": "STATS",
  "uJxidV": "Open customer orders",
  "cmaSzx": "PAYMENTS",
  "Ri4ZTj": "No payments",
  "LPn0WX": "ACCESS GRANTS",
  "nuOrfi": "No access grants",
  "+OGJYf": "ACTIONS",
  "YQ3ixO": "DANGER ZONE",
  "2LtDKj": "This will permanently delete {name} and all their data.",
  "OY+R39": "Not refunded",
  "NmK6zy": "Payment",
  "9anxhq": "Starts",
  "04xGLE": "Ends",
  "ORGv1Q": "Created",
  "g2V+es": "Italic",
  "SOtMvF": "Underline",
  "lH8y+X": "Strikethrough",
  "5UoW6K": "Highlight",
  "qGq2PB": "LaTeX formula",
  "R2FZEu": "Enter a LaTeX formula",
  "ofZ+d8": "Link address",
  "wMVWy/": "Paste a URL or internal link",
  "PxD4Pq": "Apply link",
  "HedEP7": "Bold text",
  "qDkbVY": "Italic text",
  "Ow3y0w": "Underlined text",
  "U3P/wo": "Struck text",
  "34+BA1": "Highlighted text",
  "n+Ksiy": "Link text",
  "79IWia": "Header",
  "/jd9eE": "Cell",
  "Zqekct": "Heading 2",
  "BDbgCL": "Heading 3",
  "soCLV+": "Checklist",
  "ggs9Fm": "Separator",
  "IeBejt": "Table",
  "DiyLPv": "Increase indent",
  "OgfsxZ": "Decrease indent",
  "jWDuFc": "Align left",
  "KPMC7r": "Align center",
  "Bz/qc/": "Align right",
  "pQDBN2": "Editor tools",
  "3XyF4d": "Redo",
  "bAF3vO": "Formatted editor",
  "qKqtMC": "Paragraph",
  "dDT6ro": "Markdown source",
  "Esw9HU": "Title {number}",
  "js+IVa": "Chapter {number}",
  "+3Pb5I": "What do you want to remember?",
  "3IOFp2": "Create chapter",
  "mqdE+m": "Cancel editing",
  "2g9D/w": "Exit immersive mode",
  "TpgjfJ": "Enter immersive mode",
  "9Gfkxq": "Open full editor",
  "VGa8CT": "Fit content to screen",
  "2xTrVi": "Expand full content",
  "EL3RLA": "This entry could not be saved. Try again.",
  "TkEsoc": "Version history",
  "BOPse5": "Delete article",
  "pYX859": "Deleting",
  "fuE1Tt": "Delete \"{title}\"? This cannot be undone.",
  "Y9Gzht": "Before entry",
  "cd7SUX": "During trade",
  "j0Nz9M": "After trade",
  "vcSMRI": "Edit preface",
  "vFu9WZ": "Preface",
  "sonIZt": "Preface content",
  "wkgkho": "Write the opening of this book.",
  "caXC2M": "Save preface",
  "KhHXvT": "This preface could not be saved. Try again.",
  "uKCtWZ": "Quick entry",
  "sfETQk": "Link position",
  "q0Kuyy": "Related position",
  "21Q3VS": "No related position",
  "Fv1ZSz": "Closed",
  "Mf1C6g": "Entry date",
  "BTOaG+": "Loading journal...",
  "BlIbeP": "Range: {label}",
  "nZCHBx": "Keep editing",
  "FmeFqm": "Your unsaved changes will be lost.",
  "XTHxOY": "Discard draft?",
  "I5NCub": "Date filter",
  "Er9Eoe": "Choose a date range",
  "Okb++K": "From date",
  "oCPsJO": "To date",
  "EWw/tK": "Apply",
  "V7ambj": "Manage chapters",
  "tp3bMN": "{count} entries",
  "i8L+Sb": "Rename chapter",
  "kcCZue": "Delete chapter",
  "G+doj9": "Search content",
  "EBbTja": "Write a preface for this book",
  "Rim8Gk": "Before exit / adjustment",
  "y0H+MJ": "Add discipline item",
  "sJCpUQ": "New discipline item",
  "jSkymQ": "Write the discipline item",
  "vF39hG": "Mark discipline incomplete",
  "wNUbR3": "Mark discipline complete",
  "bbplxV": "Edit discipline item",
  "PeGD0K": "Choose chapter",
  "4mxaJq": "Edit contents",
  "Hqbl28": "Rename entry title",
  "vjnqOs": "Entry information",
  "tOxzip": "Modified",
  "T3X93o": "Loading versions...",
  "jILjsZ": "Version history could not be loaded. Try again.",
  "+ENgFX": "No previous versions yet.",
  "koEb6E": "Restoring...",
  "2QMJGu": "Page navigation",
  "k9hDFZ": "Previous page",
  "rBj9Ib": "Next page",
  "qWkX3u": "Close preface editor",
  "zoRlVy": "Write the opening note for this book...",
  "UeqQ5C": "Convert formulas",
  "8typ4g": "Code block",
  "5xZNJG": "Edit content",
  "qun7iY": "Close editor",
  "djJp6c": "History",
  "Oz15Gx": "Restore a previous saved version.",
  "pvvecH": "The simulation is still running. It will appear in history when complete.",
  "9aiN0H": "Strategy Evidence Lab",
  "5cgRKt": "Find where a strategy holds up — and where it breaks",
  "peeoVO": "Test the complete layer stack against point-in-time market conditions. The goal is to discover boundaries, not manufacture a perfect curve.",
  "63HmTZ": "Modeled 0DTE evidence, not historical option fills",
  "VsSLqs": "Strategy snapshot",
  "LXGl/Z": "layers",
  "36kFgk": "Choose a saved strategy",
  "T+Yi2v": "Every enabled layer will be priced as one package.",
  "dM+p3/": "From",
  "9j3hXO": "To",
  "VLwJl5": "Starting capital",
  "2JGrIX": "Risk budget per entry",
  "1iGwtF": "Execution assumptions",
  "+5G/dd": "Commission per contract",
  "jD8Z8R": "Slippage per leg",
  "zGCamv": "Stop fill multiplier",
  "wmcjss": "Portfolio stop loss",
  "oBCTRB": "Profit target",
  "7X0lYn": "Skip above entry VIX",
  "lSnDtJ": "This stack includes a time-spread structure that the daily 0DTE model cannot represent honestly.",
  "BBqO55": "Experiment contract",
  "rihWTl": "Structure",
  "w1dDaa": "enabled layers",
  "b7wHG1": "Not selected",
  "K5Tpjo": "Re-entry",
  "m9W7iM": "Every available session",
  "b2WrSS": "Horizon",
  "qh1A9U": "Open to close · 0DTE model",
  "hlRm5H": "Volatility input",
  "aIOGJq": "Previous close · point in time",
  "4lafrr": "Engine",
  "mN1jia": "Portfolio v3",
  "LoScLL": "Running simulation...",
  "K3ZtTt": "Run evidence test",
  "QqF84d": "A new immutable run is saved to history.",
  "L1la1q": "Evidence history",
  "mjueyV": "saved runs",
  "d3wxHm": "Loading history...",
  "KQ3GFX": "No evidence runs yet.",
  "pSrPN9": "trades",
  "TDUfVk": "Started",
  "EQpfkS": "Finished",
  "QInnjm": "Win Rate",
  "yrhXAw": "skipped",
  "9oOUbX": "Sharpe",
  "XO0uH1": "Sortino",
  "92KWuG": "Avg daily",
  "HHFpcy": "Best day",
  "Kvv2xH": "Worst day",
  "C/SEYq": "Avg win",
  "in443e": "Avg loss",
  "b2X2MN": "Max drawdown",
  "qyNB9S": "Streak (W/L)",
  "Wdn0g5": "Choose a strategy to test",
  "6uqYl0": "The complete enabled layer stack will be tested together.",
  "wMtTB8": "Search saved strategies",
  "3vuznk": "No strategy matches this search.",
  "M4tVEs": "Save a strategy in the builder before running a test.",
  "xEs79x": "VIX Range",
  "iF/NIV": "Trades",
  "97yArg": "Avg P&L",
  "TE51b7": "Export CSV",
  "yUhDpZ": "Open→Close",
  "UMbBzo": "Move",
  "eoy4Hp": "Entry VIX",
  "Do29Mx": "P&L",
  "D0e0dO": "Evidence readout",
  "qHWGQ6": "Sample",
  "CVbVx/": "Strongest observed environment",
  "RHgEMy": "Not enough classified history",
  "Gegff6": "Weakest observed environment",
  "Oq18qN": "Evidence coverage",
  "w5J3rx": "Run again with engine v3",
  "KmU3uu": "Not enough prior history for regime labels",
  "DGEdM8": "Point-in-time regimes classified",
  "JRt1Y+": "Where the strategy held up",
  "NNl+dA": "Rows use the prior 20-session trend. Columns use volatility known before entry.",
  "ZykpY3": "No future data in regime labels",
  "Qp1beM": "Path",
  "Orc8Zk": "Distribution",
  "Cicdhm": "Net result distribution",
  "qiXByh": "Average win",
  "j4hRpT": "Average loss",
  "z4WB6T": "What this simulation is — and is not",
  "vrvoJA": "This is a daily re-anchored 0DTE simulation using historical underlying bars and a modeled option surface. It is not a replay of historical option-chain fills. Results include the configured commission and slippage assumptions and should be treated as evidence for further study, not a forecast.",
  "/vWP7U": "Falling trend",
  "VGzSsa": "Sideways trend",
  "Khs765": "Rising trend",
  "hGVzL2": "Low volatility",
  "+sCi5u": "Normal volatility",
  "7NXkmR": "High volatility",
  "CRfCS+": "No sample",
  "quDnKR": "wins",
  "uJC5Gu": "Monthly net results reveal whether performance was persistent or concentrated.",
  "7ACBJ3": "No alerts set",
  "DqTQOp": "Once",
  "/clOBU": "Weekly",
  "wYsv4Z": "Monthly",
  "XfR4wn": "Repeat daily",
  "xWZNHq": "+ Add Alert",
  "WFpYCz": "ALERTS",
  "CC6XgB": "ALERT TRIGGERED",
  "SA1H5e": "Are you sure you want to delete this alert? This cannot be undone.",
  "Soc+LF": "Breakeven",
  "8OtX8p": "Days before",
  "tiTwYW": "days before",
  "h0W8DM": "Time of day",
  "k0eWdm": "Alert title (optional)",
  "/HKWfF": "Message body (optional)",
  "m5eCsU": "At least one channel is required",
  "GN9UDB": "Push",
  "zdN8I5": "Exp",
  "y1De/5": "Example parameters",
  "ugzzHK": "Restore defaults",
  "v9R8gC": "Assumed spot",
  "eVbSIz": "Days to expiry",
  "nuCr1U": "Copy this link to share",
  "OKhRC6": "Share",
  "4xvTgw": "About this example",
  "fk++Xe": "Illustrative SPX structures anchored at 6,500, with theoretical premiums and a single IV. These are example parameters, not live quotes. Changing IV or expiry reprices the example at entry as well as across the surface.",
  "LILvKC": "IV",
  "tfGFyx": "Waiting for live quote...",
  "ATohnZ": "Market price",
  "SY0ypw": "Reset time",
  "IIKaw8": "Reset IV",
  "H19twt": "Could not load your structure. Retry",
  "Q7ij1k": "DTE",
  "yKosLC": "Continue building",
  "drCPHM": "3D scenario analysis",
  "S4AT72": "Open 3D from Simulator or Monitor, then drag to rotate and pinch to zoom.",
  "v0gvt4": "View mode",
  "EucS2p": "Preset",
  "M59JhX": "Manual",
  "+DZFrO": "As Spot and time change, will this strategy make or lose money?",
  "1G15DZ": "Time Decay",
  "UAQFhR": "Time Loss",
  "fnsj/r": "As Spot and time change, where is value lost fastest?",
  "RJSsw9": "Directional Risk",
  "0p+P7U": "Price Risk",
  "n6j13i": "As Spot and time change, where is directional risk most intense?",
  "PKDUWy": "Volatility Impact",
  "T6/D9t": "IV Impact",
  "LKgp2i": "As Spot and IV change, how does P&L change?",
  "jTBbjB": "What does this custom setup show?",
  "V7PbLi": "Evaluation price: the market price used to value the strategy at this point.",
  "m69vGU": "Anchor strike: moves the strategy structure itself to a different center strike.",
  "EM1ADz": "Moneyness: relative distance from the anchor strike, shown as a percentage.",
  "9KcLVp": "Implied volatility: the volatility assumption used to revalue the strategy at this point.",
  "1wrbl3": "Days to expiration. Decimal values mean less than one day; 0.40D is about 9.6 hours.",
  "w2xzwf": "Simulated profit or loss at this point.",
  "dKd90M": "Estimated option value or premium at this point.",
  "6iH5wI": "Estimated change from time passing in this model.",
  "4klIB9": "Estimated P&L change for a 1-point move in price.",
  "QDNL3E": "Local sensitivity: how much Delta changes when price moves 1 point.",
  "S1UHAo": "Estimated change for a move in implied volatility.",
  "ARXFpM": "Input axis: this sweeps one scenario variable across the scene.",
  "eIwiyJ": "Height axis: this controls the surface elevation.",
  "mfidD3": "Color map: this controls the surface coloring.",
  "4e4IBN": "Common analyses",
  "RWeRsK": "Scenario analysis",
  "uRf8T2": "Collapse top controls",
  "ehV3rk": "Expand top controls",
  "+FkQSx": "See strategy performance under different conditions",
  "QZ7TJg": "Market conditions",
  "hfHIMh": "Relative strategy placement",
  "k7mulv": "Anchor strike placement",
  "buhQLp": "Price and time",
  "nLxSRs": "Price and volatility",
  "uz7Su3": "Time and volatility",
  "e2yCwg": "Price and relative placement",
  "rYq1Qo": "Time and relative placement",
  "Ny5QiA": "Volatility and relative placement",
  "eVif46": "Price and anchor strike",
  "bka2Mb": "Time and anchor strike",
  "ATgrw6": "Volatility and anchor strike",
  "t5TDW6": "Choose scenario inputs",
  "m5YjUB": "Where does this strategy make or lose money?",
  "wDeNYA": "How does the strategy value change?",
  "VH2j5I": "Where is time value lost fastest?",
  "ttJxO5": "Where is directional exposure greatest?",
  "PLRHJY": "Where does directional risk change most sharply?",
  "ME92gX": "Where is the strategy most affected by volatility?",
  "KldXu9": "Choose a research goal",
  "X67VJv": "Research goal",
  "n1gFwy": "Scenario conditions",
  "Vgl536": "Auxiliary color",
  "InWqys": "Optional",
  "M9YFIy": "Higher",
  "5m4j06": "Scenario",
  "oFSwDy": "Viewing:",
  "EePJda": "Current build",
  "Ed2qZj": "Current build · {name}",
  "3GLH+d": "Examples",
  "QVZeAu": "Example · {name}",
  "R1y05T": "Log in to explore more",
  "1HGbXh": "Explore more",
  "I+VW5X": "Open in Build →",
  "ieSWnu": "Could not load geography",
  "YMDBNH": "Geography",
  "SdDIj4": "The geography endpoint is not available yet. Sign-in locations appear here once IP resolution ships.",
  "aMwxYb": "Countries",
  "8sPgXj": "last {days} days",
  "eZHLOh": "Located",
  "0U6tmb": "Unresolved",
  "Or9ItZ": "Sign-ins by country",
  "qqZZ0R": "The map could not be drawn",
  "YJ60t1": "Ranking",
  "OGqTOQ": "Visitor",
  "D1+T5B": "{name} viewed {page}",
  "P+gUTH": "a page",
  "aZ5Y8/": "System event",
  "e9uDQ/": "Technical details",
  "m1czzY": "Event",
  "EwRIOm": "User",
  "7Y6Yvq": "Record",
  "kL41aZ": "Could not load the audit log",
  "wzICIz": "No events match this filter",
  "Ho0rsi": "Search event data",
  "WqRRne": "Event volume",
  "wRwX/G": "Events per week",
  "zSOvI0": "Filters",
  "NLeFGn": "to",
  "zyDnZa": "Clear dates",
  "82gNYF": "Event category",
  "QlsDcr": "Action",
  "/x74Ok": "{total} events",
  "ED9RG5": "Audit log",
  "CnpuAf": "DAU",
  "z/pi6K": "WAU",
  "LVeTxv": "MAU",
  "2lC6PV": "Stickiness",
  "xkWJu2": "7-day average",
  "kmM+gk": "Could not load admins",
  "ybfgy3": "No admins yet",
  "t5nDnD": "column",
  "MSaCKq": "env",
  "wHvmSN": "both",
  "m6paUd": "You cannot revoke your own access",
  "7qAhyB": "That did not work. Try again.",
  "tnRDuU": "Revoke",
  "hQZhn8": "Impersonate",
  "f1rHKt": "Admins hold the whole console. Revoking clears the admin column; an admin granted through the environment variable has to be removed there.",
  "AqRInY": "Visits",
  "CUhO2T": "Opened simulator",
  "e6nsuh": "Clicked login",
  "e867RK": "Completed signup",
  "lzgH40": "Google",
  "coc2HA": "Bing",
  "aZPSPA": "ChatGPT",
  "KCWNcP": "Perplexity",
  "ANPQ0A": "Other referrals",
  "4nxb8Y": "Direct or unknown",
  "y6m90b": "Edited simulation",
  "cpJyPS": "Shared scenario",
  "jCNpEL": "Period",
  "Rfvi9/": "Last 30 days",
  "mgYBYo": "Last 90 days",
  "ozDeJH": "Only public 3D visits are counted here. Includes visitors who reached 3D from another page. Percentages use 3D visits as the denominator.",
  "TBZsnf": "Registrations count after a login click on 3D in the same visit. Each action counts once per visit; the period uses the first 3D visit time.",
  "OVPMr3": "Could not load the 3D report. Please retry.",
  "TfOMuw": "{rate} of visits",
  "fqL72s": "No public 3D visits were recorded in this period. Earlier untracked visits cannot be included.",
  "OGtlNI": "Visit sources",
  "3/EJKn": "Sources depend on referral information supplied by the browser. Direct or unknown may include search and AI referrals that did not send this information.",
  "TciE4Y": "Top 20 entry pages",
  "iyZFBV": "The first public page of each 3D visit. A homepage → 3D → signup visit appears under Homepage here and is included in the 3D totals above.",
  "C/XZB/": "Saved strategy",
  "uF2NdB": "Visits first seen in this period, including the homepage. Each action counts once per visit; percentages use all visits as the denominator.",
  "CHCrij": "Visits are not unique people. A new visit starts after 30 minutes without a recorded action. Registration and saving are separate outcomes and do not require every earlier action.",
  "sw3be0": "Could not load the learning report. Please retry.",
  "u8VxaO": "No recorded visits yet",
  "pXT+QZ": "Only visits recorded after tracking is enabled appear here. Select a longer period or check again after people visit the public pages.",
  "mLL1Y9": "An entry page is the first public page recorded for a visit. Outcomes are credited to that entry page even when the visitor explores another strategy.",
  "RZdYTT": "Activated registrations",
  "EPxDEa": "Awaiting first login",
  "MFCbl3": "Sign-ins",
  "hrAQpD": "Alerts fired",
  "TpORFZ": "Could not load the overview",
  "+EKK8l": "Population",
  "g12Dke": "Growth",
  "+a+2ug": "Members",
  "l8wanU": "Joined",
  "CQOyVR": "Days tracked",
  "CPpsOf": "Trends",
  "nL6Jl0": "Retention",
  "eWzMDx": "Activated",
  "J0wSmC": "Acted in 7 days",
  "VjUyuG": "Cohorts",
  "Ao+O+Q": "Signed up",
  "agOXPD": "Size",
  "ja7XBf": "Install αβΓ✻1",
  "/Gmbfp": "Tap",
  "3pcopg": "then \"Add to Home Screen\"",
  "q3FTFW": "Add to your home screen for the full app experience",
  "ubmFc8": "Install",
  "Sc/QN5": "Notifications blocked — enable in Settings",
  "9Ruc/8": "Enabling…",
  "dZWgSQ": "Enable push alerts",
  "QIo3vC": "Capture the setup before you commit risk.",
  "iQ+Ird": "Why trade?",
  "B3Q5mz": "Trigger",
  "2IedGT": "Invalidation",
  "kcCzpD": "Expected path",
  "o9oWvO": "Write what unfolded once the position was live.",
  "eF7TQV": "What happened?",
  "KFbhjh": "Followed the plan?",
  "/O88mD": "Adjustments",
  "5nn4KD": "Emotions",
  "SuNbhB": "Turn the outcome into a cleaner next action.",
  "iaHymw": "Outcome",
  "M5ze/8": "What worked",
  "plz2Da": "What did not",
  "gfKKsY": "Next time",
  "rAMgEh": "Add option",
  "6O5P7o": "Option title",
  "AFhCIe": "Delete option",
  "cwfcI8": "Write what happened here",
  "ZF2HrZ": "Quick note",
  "jg0VR7": "Add quick note",
  "dDDZFq": "Record why, what changed, or what to remember.",
  "xYMPX8": "Delete note",
  "0LHTxP": "Review notes",
  "BmsYb3": "Review log",
  "pIPOc5": "Review entries are saved automatically in the journal.",
  "0kQziN": "Reminder title (alerts when the target price is reached)",
  "n816xf": "Reminder title (alerts on the expiry date)",
  "Et5m+a": "Reminder title (alerts 1 day before expiry)",
  "vLT+cB": "Reminder title (alerts {days} days before expiry)",
  "kFKkq8": "Reminder title (alerts at the selected date and time)",
  "rH7N0y": "Add reminder",
  "s8II5l": "Above",
  "GRJ4NR": "Below",
  "FYhx9Y": "Target price",
  "M56JXA": "Position expiry",
  "NU+Tp9": "Remind before expiry",
  "LllhGb": "On expiry",
  "NMrDl2": "1 day before",
  "jp6xlw": "2 days before",
  "WIcstJ": "3 days before",
  "oPB7iw": "5 days before",
  "XiWq/N": "7 days before",
  "PsYRHM": "Optional details",
  "tFFMkF": "Pause",
  "3y9DGg": "Resume",
  "pwkxHX": "Why you took it, and what would prove you wrong.",
  "ZbAsgg": "What moved, and what you did about it.",
  "rvTvnU": "The result, and one thing to keep or change.",
  "HFiPBh": "Write freely, or tap a prompt above.",
  "+mv46A": "Per month",
  "fRd3Oz": "Cancel anytime",
  "3MLT5m": "Per year",
  "bQB+7j": "About {price}/month · save {percent}%",
  "dC3u7Z": "Most popular",
  "bRkTvW": "Offer for subscribing within 3 days",
  "v/2PT/": "First subscription offer",
  "4mrhCR": "Layered strategy construction and tracking",
  "sQvErU": "Build layered strategies and manage option contracts.",
  "vBgQ/W": "3D payoff across price and time",
  "SFsjLy": "Volatility surfaces, smile and skew",
  "19FC4d": "Review and analysis",
  "Xlse6c": "Go deeper with the complete analysis toolkit.",
  "aE0A50": "Options, understood as",
  "0CLczI": "structure",
  "qYDijq": "An educational simulator and analytics tool for options traders. It exists so that anyone curious about options — from a first-time learner to an experienced trader testing a new structure — can build a strategy, see its risk profile, and understand the math behind it before any money is at stake.",
  "6WB03m": "Reading the name",
  "kLUUWf": "The name is written with Greek letters. Each one maps directly to a letter in the domain.",
  "wNlUn8": "alpha · lowercase",
  "q52MZB": "beta · lowercase",
  "kHHWYG": "Gamma · uppercase",
  "RTq3Yj": "Why the Greek letters",
  "yBIHRM": "α, β, Γ — along with Δ, Θ, ν — are the Greek letters traders use to describe how an options position behaves: sensitivity to price, to curvature, to time, to volatility. The name is a reminder of what we care about: the structure of risk, not the size of the win.",
  "+jAZf/": "The Greek letters in the logotype aren't decoration. Delta for direction, Gamma for curvature, Theta for time decay, Vega for volatility sensitivity. Every options position you will ever take has a reading in each of these dimensions.",
  "J46MY6": "Too often options are presented as outcomes (profit, loss, ‘+500% trade') instead of as structures you can understand. The letters in our name are a reminder of what we care about: making the underlying mechanics legible, so a trader's first question is ‘what's the shape of my risk?' — not ‘how much can I make?'",
  "gy4m8V": "What it is",
  "5IeQDZ": "A strategy simulator — build multi-leg positions, see payoff, Greeks, breakevens.",
  "mWZkux": "A learning environment — hand-written lessons on theta, spreads, flies, and risk.",
  "Wl81EY": "An analytics surface — backtests, equity curves, Sharpe and Sortino ratios, monthly heatmaps.",
  "hnIcFQ": "A trade journal — for logging decisions, notes, and outcomes you can learn from.",
  "Ea8obV": "What it is not",
  "4m8fg7": "Not a brokerage. We do not route orders to any exchange.",
  "ulwEvZ": "Not a fund. We do not accept deposits or manage money on your behalf.",
  "Ys/3BC": "Not an investment platform. Nothing in the product promises or implies returns.",
  "vLmakr": "Not affiliated with any cryptocurrency scheme, signal group, or Telegram / WhatsApp / WeChat solicitation that uses the letters ‘abg' or ‘αβΓ'.",
  "UuGg8R": "Who built it",
  "NbOoMm": "Built by a small team of traders and engineers who wanted the simulator and curriculum they wished they'd had when they were learning. We work in the open, ship small improvements often, and treat every misunderstanding a user has as our own bug to fix.",
  "Y92mVP": "Read the philosophy",
  "vL7XoS": "Important notice",
  "nRoyFi": "Safety & Scope",
  "5EyE6F": "Last updated · April 2026",
  "TEssE0": "An educational simulator and analytics tool. This page makes our scope explicit — because the letters ‘abg' / ‘αβΓ' are also used by unrelated schemes we are not part of, and we don't want anyone confused about what this product is.",
  "kWtj2V": "An educational options simulator for learners and experienced traders.",
  "24SkLu": "An analytics surface for backtesting historical strategies against past market data.",
  "ufiTvD": "A curriculum — hand-written courses on the Greeks, spreads, flies, and options risk.",
  "wVRDa9": "A trade journal for logging decisions and reflecting on outcomes.",
  "ziHhG6": "Not a brokerage. We do not route orders to any exchange or counterparty.",
  "yibXkM": "Not a fund. We do not accept deposits or manage money on anyone's behalf.",
  "5CJa6k": "Not a signal service. We do not tell anyone what to buy, when to buy it, or at what price.",
  "fvsiME": "Not an investment platform. Nothing in this product promises or implies returns.",
  "Rbmgep": "Not affiliated with any cryptocurrency project, Telegram group, WhatsApp channel, WeChat room, or Discord server that solicits deposits or promises profits using the letters ‘abg' or ‘αβΓ'. If you were directed to such a group by someone claiming to represent us: that is not us.",
  "Qlt8Wb": "We do not",
  "TVHHGg": "Accept deposits of any kind.",
  "2tO/6R": "Promise, imply, or guarantee any return on any strategy.",
  "11rVXI": "Cold-message users on social platforms to offer ‘VIP access' or ‘signal groups'.",
  "N6agSX": "Have affiliates authorised to collect money on our behalf.",
  "u2lCoU": "If you've been contacted",
  "fVgOUG": "Someone is using our name?",
  "irYx8B": "Screenshot the conversation and the account that contacted you, then email us. We will confirm whether the person is associated with us (they are almost certainly not), and we will list known imposter accounts publicly so other users can avoid them.",
  "vZd74i": "Email the safety team",
  "0SM/Ve": "Risk disclosure",
  "mLoMtg": "Options trading is complex and can result in the loss of more than the amount invested. Every decision you make with real capital is your own responsibility. Nothing in",
  "07U0ps": "— simulation, courses, analytics, or otherwise — is a recommendation to trade. Before trading options with real money, consult a licensed financial advisor in your jurisdiction.",
  "wGhqrf": "About us",
  "LbU6c8": "Education philosophy",
  "32rBNK": "Terms of Service",
  "c8LnNR": "Make options understandable for everyone.",
  "Yn1zfv": "A focused learning environment that helps you build judgement before you enter the market.",
  "3fW0YY": "Three pillars",
  "iOYsHZ": "Awareness before trading",
  "ursAWa": "Understand the rules, the risks, and the structure of a position before you enter the market.",
  "bN57w4": "See risk, don't amplify returns",
  "jHSbZC": "Options are not for gambling — they are for managing uncertainty. We help you see what a trade costs, not just what it might pay.",
  "kaNTJF": "Reduce the cost of being wrong",
  "DuitYg": "One fewer misread is worth more than one lucky win. Knowledge compounds; luck does not.",
  "5QiO1i": "Manifesto",
  "O/7+3q": "Options are not a tool for the few. They are a tool most people simply have not been taught to use.",
  "bwxagR": "is a focused learning environment for options awareness and risk understanding, built to help you develop a basic sense of judgement before you trade real capital.",
  "S5C+tL": "Start understanding options",
  "u3X7Ik": "Understand the risk first",
  "yDSQO8": "Replace luck with awareness",
  "R9an/c": "Expand stock context",
  "lf7wkB": "Collapse stock context",
  "gTWKP4": "Toggle market context",
  "vnoR5E": "Switch chart mode",
  "/OaaHw": "Chart time zone",
  "QqLawE": "Invalid symbol format",
  "H6RJID": "Too many discovery attempts. Slow down a moment.",
  "DljV7+": "We couldn't find data for {symbol}",
  "x3Jkca": "Search ticker…",
  "AufGsR": "No matches. Enter a valid symbol to add.",
  "hUL+tI": "Type a symbol to search.",
  "yFfDtT": "Add {symbol}",
  "rezLUu": "Looking up {symbol}…",
  "PSUtcs": "Spam or misleading promotion",
  "SOfYdT": "Harassment or hate",
  "iIAx22": "Harmful or illegal content",
  "v7H5PN": "Other concern",
  "QxAyiy": "Report post",
  "TQVOqM": "Reason for reporting",
  "xM5ArJ": "Our team will review this report. Your identity will not be shown to the author.",
  "xgAriz": "This post could not be reported. Please try again.",
  "X4dRES": "Submit report",
  "WLTizY": "Block user",
  "Qh6A+a": "Could not block this user. Please try again.",
  "l67Qtm": "You will no longer see each other's community posts or be able to follow each other. Existing follows will be removed. You can unblock them from the Discover menu.",
  "KW3uMH": "Blocking...",
  "Up5U7K": "Block",
  "JVxlmb": "People following me",
  "xJKibQ": "Could not load followers. Retry",
  "538G00": "No followers yet.",
  "1qfPw2": "Post options",
  "izWS4J": "Unfollow",
  "FRXOmD": "Reported",
  "nDejmx": "Unblock",
  "1ctlqi": "Could not unblock this user. Please try again.",
  "skNNbV": "Blocked users",
  "p3eIzE": "Unblocking does not restore previous follows.",
  "vqJ2Cy": "Could not load blocked users. Retry",
  "JUddXg": "No blocked users.",
  "JVwcs6": "Unsave post",
  "4WSbF7": "Save post",
  "v8o2Nm": "Could not save your action. Please try again.",
  "rGG6C5": "Could not record entry",
  "Ix1eQS": "Entry spot",
  "MF7Ymi": "Net estimate",
  "Kv8i2p": "Entry debit",
  "KfNcvR": "Entry credit",
  "dPPOTD": "Reminder title",
  "KgAlAZ": "Add note",
  "5+4RCa": "Enter an entry amount.",
  "aaiLWk": "Watch",
  "AcxDgz": "Activate",
  "jz8yDB": "Option leg",
  "q8T+VR": "Open leg actions",
  "tVHHUm": "Enable leg",
  "4Did0d": "Disable leg",
  "55md55": "Delete leg",
  "uqe58g": "Breakdown",
  "GgXq9Q": "Collapse all strategies",
  "xGK5Yf": "Expand all strategies",
  "yDJQ0F": "Add Strategy",
  "8XzeY5": "Market data available",
  "irrBrQ": "Loading market data…",
  "rflQ3H": "Open expiry calendar",
  "XeAWps": "Breakout",
  "LEubOZ": "Same payoff family, different option construction.",
  "uWWKZe": "Call/Put toggle",
  "s9/62P": "Collapse all leg editors",
  "otQRp2": "Expand all leg editors",
  "KpyF8v": "Open strategy actions",
  "2kdJjJ": "Enable strategy",
  "2k510C": "Disable strategy",
  "xiUnhw": "Duplicate strategy",
  "dNDw/G": "Hide advanced",
  "9NTFsx": "Edit parameters",
  "xx93Pk": "Separate legs",
  "YiU4iO": "Strategy quantity",
  "7gXPhB": "Qty",
  "zDV36j": "Variable cash flow",
  "qcpyb/": "This structure can be a debit or a credit depending on parameters, strike distance, and option prices. Net payment means debit; net collection means credit.",
  "LIxF3y": "Credit cash flow",
  "We/i1W": "Opening the position collects net premium, so cash flows in first. Profit usually comes from keeping that credit; risk depends on protection legs, naked shorts, and spread width.",
  "Pio7S3": "Debit cash flow",
  "2VANPF": "Opening the position requires a net premium payment, so cash flows out first. Max risk is usually based on that net debit, while max profit depends on the strategy structure.",
  "zETXS9": "Max risk",
  "Dc6tD1": "Add strategy to begin",
  "GSSEg4": "Payoff drag locked",
  "UsPknq": "Lock payoff drag",
  "Q6de0z": "Toggle payoff view scale",
  "Txq8th": "Undo strategy move",
  "ARn/6E": "Hide payoff summary",
  "nFYl3i": "Show payoff summary",
  "H53Wpt": "Multiple expiries · expiry estimate hidden",
  "UeUdzQ": "Expiry P&L",
  "1SoDnn": "Spot",
  "dewaOi": "No strategy expires on this date",
  "O76gjS": "Choose a marked expiry date",
  "wsRADk": "Current structure",
  "8TSY2E": "Plan start",
  "FKrKuf": "Shape the first strategy for this plan",
  "DJoyyo": "Start this plan with a concrete structure, then refine expiry, legs, and follow-through from there.",
  "B5dTDe": "Leg editing",
  "zg8/dK": "Strategy Picker",
  "RrCui3": "Summary",
  "ruY471": "Decay",
  "a6oaVu": "Delete strategy?",
  "a7sjI9": "This removes the strategy from the current simulation. This action cannot be undone.",
  "ddusVS": "Remove {ticker} workspace?",
  "fK/moZ": "This removes the workspace from the simulator. Saved strategies and positions will not be deleted.",
  "CKwxFw": "Remove workspace",
  "ZbB4iW": "Same expiry, one long call leg becomes a long call strategy.",
  "La02Ad": "Same expiry, one short put leg becomes a short put strategy.",
  "8B9wNk": "Same expiry, long call plus short call becomes a call spread.",
  "63C+To": "Same expiry, four legs with short options in the middle and long wings becomes an iron condor.",
  "3Dx8St": "Same expiry, short call and short put at the same strike with outside protection becomes an iron butterfly.",
  "G5dI7c": "Different expiries, same strike and same option type, one long and one short becomes a calendar spread.",
  "EKd/46": "Different strikes and different expiries, same option type, one long and one short becomes a diagonal spread.",
  "/k/3jB": "Two calendar groups, one call group and one put group, becomes a double calendar.",
  "oVHCWl": "Strategy recognition rules",
  "P9XgbG": "How strategies are recognized",
  "2RcYOT": "Terminology varies: call and put may also be called bullish and bearish, or subscription and redemption; long and short may also be called buy and sell.",
  "xC6/Ai": "Each leg is recognized from side, call or put, strike, expiry, and quantity.",
  "1fBIQ4": "Expiry dates",
  "j59G7j": "Quick jump",
  "QdUofP": "Follow market price",
  "QcjNQ/": "Stop following market price",
  "aZOPsZ": "Rename Strategy",
  "9VpqFd": "Name this strategy",
  "OIU/70": "Save Strategy",
  "Fj+X+3": "Strategy name...",
  "wNCblV": "Show payoff stage",
  "5yMehU": "Hide payoff stage",
  "qYYUGr": "Risk / reward",
  "QA1paM": "Simulation notes",
  "x/atQl": "This simulator is a scenario exploration tool, not an investment advice tool.",
  "mcxleS": "Outputs depend on model assumptions, delayed or incomplete market data, selected IV, time, prices, and manual inputs. Results can be inaccurate.",
  "/UizCK": "Current option pricing is incomplete, so current P&L is approximate. Expiry P&L uses the settlement price.",
  "epNjRr": "Greeks interact with each other: delta, gamma, theta, and vega change as price, time, and volatility move, so one reading cannot be treated as fixed.",
  "igHJav": "Options involve substantial risk. Do not use these simulations as the basis for investment decisions.",
  "OFJRb5": "credit",
  "kCckrX": "debit",
  "3oAPV2": "Exp max profit",
  "xH2LbA": "Open current P&L calculation",
  "+1wV10": "Current P&L calculation",
  "tqVx9+": "Current P&L = sum of all enabled leg P&L",
  "epEfUW": "Current return",
  "u2u58G": "Net premium amount",
  "q2eIh9": "Open expiry profit calculation",
  "AVd+xC": "Expiry profit calculation",
  "+6Slr9": "Expiry profit = net premium × quantity × $100",
  "p63vhH": "Expiry profit = maximum of all leg expiry P&L totals",
  "p1z5P5": "Maximum expiry P&L",
  "xHdj1x": "Premium-based return",
  "DavTn1": "Premium-based return = max profit ÷ |net premium amount|",
  "GEdPVY": "Risk-based return",
  "ntSWBx": "Risk-based return = max profit ÷ max risk",
  "p0zI0G": "Per leg",
  "g6ipyD": "Long leg P&L = (expiry intrinsic value − entry premium) × quantity × $100",
  "L9co0M": "Short leg P&L = (entry premium − expiry intrinsic value) × quantity × $100",
  "6W2ZmW": "Open max risk calculation",
  "XUY2vI": "Max risk calculation",
  "ZxyPEz": "Max risk = spread width × quantity × $100 − net premium amount",
  "UGgwfe": "Max risk = net debit premium × quantity × $100",
  "5B7K4Q": "Max risk = largest loss on the combined expiry payoff curve",
  "WQP2ut": "Open risk / reward explanation",
  "BKkRR/": "Risk / reward ratio",
  "lBPGKn": "Fees and slippage are not included.",
  "fYgsCE": "Clear selected strategies",
  "S8QoAg": "Select all visible strategies",
  "VNsN2Z": "Long Call",
  "fRvWNw": "Bullish · Profits above breakeven",
  "hzyvzb": "theoretically unlimited upside",
  "GGb4mP": "premium risk",
  "4f0M7H": "Short Call",
  "RviXXY": "Bearish income · Profits below strike",
  "HfWXsi": "theoretically premium capped",
  "TKLjVV": "theoretically unlimited upside risk",
  "cGtk7F": "Bearish · Profits below breakeven",
  "u4KT64": "theoretically large limited upside",
  "onXrid": "Short Put",
  "TFE0zL": "Bullish income · Profits above strike",
  "9CaQlF": "assigned-stock downside",
  "JRHX28": "Only this time",
  "UflpIz": "Set as preference default",
  "FibtbU": "Restore system default",
  "OqsfAQ": "Strategy shelf",
  "vyT33P": "Exit multi-select",
  "VNFzdA": "Enter multi-select",
  "zblqVV": "Use the square button to clear or select all visible routes. \"{count}\" selected.",
  "zxDhDV": "Use the square button to select all visible routes in the current filters.",
  "bBgyLq": "Stock Price",
  "ARGRLU": "Implied Volatility",
  "7o5wIx": "Time to Expiration",
  "/Koi6R": "Controls where the scenario sits between now and expiration. Moving it toward expiration shows how time decay changes the strategy; jumping to expiration shows the expiry payoff.",
  "3Vqaqo": "The underlying stock price used for this scenario. Moving it shows how the strategy profit or loss changes as price rises or falls.",
  "rEEoE5": "Implied volatility is the market's expected volatility used in option pricing. Moving it shows how volatility changes simulated profit or loss before expiration.",
  "pyfKzs": "Return to live price",
  "OMo3IK": "Return to live implied volatility",
  "G/yZLu": "Remove",
  "535i2y": "Decrease count",
  "gXeH2D": "Increase count",
  "BVOGIF": "Open editor",
  "Ui5ANs": "Undo this edit",
  "4jYCiP": "Decrease value",
  "FosG/W": "Increase value",
  "hEWFuM": "Buy at ask",
  "RthpHx": "ATM",
  "5ES07g": "Sell at bid",
  "YKIOP9": "Show Bid/Ask labels",
  "pN8oP2": "Show Sell/Buy labels",
  "48zn4v": "Bid",
  "D7cFlD": "Option chain",
  "sljfYe": "Delayed market data",
  "xrk6zg": "Updated",
  "CusOhC": "Close option chain",
  "ekPjBv": "No option chain is available for this ticker yet.",
  "fQFNOL": "Calls",
  "3CnRXM": "Puts",
  "u40kFh": "Jump to ATM",
  "JDqPbs": "All strikes",
  "LafLIR": "OI",
  "y867Vs": "Volume",
  "vXL/X1": "Could not save preference. Please try again.",
  "WoTb6U": "Remove leg",
  "blCQ5S": "selected legs",
  "wtvuvm": "Net credit",
  "yYT0mU": "Net debit",
  "j04HZg": "Add to current strategy",
  "PudL2i": "{count} strategy",
  "bqaYyQ": "Simulation workspace",
  "b7DoAL": "Switch simulation workspace",
  "wL8pmk": "Remove {ticker} workspace",
  "8nvhZ9": "Last",
  "rhSI1/": "Model",
  "o1TZ2s": "Edit leg expiry",
  "O8XlC6": "Current premium per contract",
  "0dMo8L": "Entry premium",
  "nQyxpz": "Reset premium",
  "r82eD8": "Legs",
  "PCMwKt": "Collapse strategy Greeks",
  "o0JYvv": "Expand strategy Greeks",
  "mk9OQu": "Leg",
  "VET/x9": "Use rainbow",
  "DemWZ8": "Custom payoff shaped by its active legs",
  "Eb8pjw": "Combined behavior of the active legs",
  "shXrKt": "Combined tail risk of the active legs",
  "4EfPob": "Compare how strike placement changes the payoff",
  "6xKZQd": "Observe time decay and volatility sensitivity",
  "WPGhnF": "Stress-test the structure near expiration",
  "sk3w9O": "Use one color for all strategies",
  "MswSOP": "Change strategy color",
  "fSQm0K": "Profit drivers",
  "teYMtl": "Main risks",
  "BE7W44": "Learning points",
  "4xtgTx": "Read the strategy lesson",
  "ST/WAh": "Old strategies were disabled",
  "eYTEFf": "This expiry date has reached the 6-strategy limit",
  "vsxI5f": "Old strategies over the 6-strategy limit were disabled. We recommend deleting them.",
  "KByOMa": "Delete at least one strategy to continue.",
  "b/P0+i": "Delete or disable at least one strategy to continue.",
  "6CybPN": "legs",
  "cfsCjO": "Collapse strategy details",
  "Ii0MuK": "Expand strategy details",
  "jM9qUI": "Near",
  "YCzPPB": "Far",
  "Taqr2e": "Far expiry",
  "FvZfKT": "Payoff preview needs complete quotes and IV for later expiries.",
  "3UBNqL": "Selected legs payoff",
  "8vIenI": "Estimated at first expiry",
  "8oG2ji": "Preview stock price",
  "fyFJ6K": "vs. spot",
  "OxAaln": "USD · 1 contract per leg · Midpoint estimate",
  "jM8gSj": "Open option chain",
  "FIMqSt": "Chain",
  "TxtDTD": "Close strategy panel",
  "Ngnq4K": "Anchor to the market",
  "G1poGQ": "Your strategy will be anchored to the market. During market hours that's the live price; outside market hours it's the most recent close. All strikes, payoffs, and calculations follow from the market price.",
  "x1DWtN": "Waiting for market price",
  "eJiZz9": "This is not a trade. Nothing is being bought or sold.",
  "taAeCh": "We are not a broker and we do not connect to any broker.",
  "C1GqY0": "This is an educational tool. You are exploring strategies on your own.",
  "JcmUf3": "The market price shown comes from recent data and may lag the live exchange.",
  "87M0uj": "Past results and simulations do not predict future outcomes.",
  "orvpWh": "Go back",
  "Zct5E1": "Anchor to market",
  "/A3g/O": "spread",
  "XuKi2x": "market IV",
  "JfDsQZ": "Edit leg",
  "frfRjz": "Reset Legs",
  "esmm2w": "Max P",
  "Rz3USJ": "Max L",
  "09BbRR": "No new messages",
  "XYsvl5": "Delete message",
  "v4Mlb8": "Message could not be deleted. Please try again.",
  "fsgo1a": "Are you sure you want to delete this message? This cannot be undone.",
  "S+o8nA": "Delete message?",
  "OYKAqF": "Quick start",
  "wQXAv+": "{step} of {total}",
  "zezuLf": "Choose a ticker workspace",
  "vy4o+D": "Choose a strategy",
  "We1y4G": "Add a workspace below and choose your ticker.",
  "ABDm1s": "Add a strategy below. You can edit its legs afterward.",
  "Kl2Mao": "Could not save your guide preference. Please retry.",
  "/4tOwT": "Skip",
  "KMvTTa": "Choose period",
  "7pXrnq": "Day",
  "sd2ieZ": "Week",
  "IFo1oo": "Year",
  "8L/qBP": "Strategy review",
  "ruVgHA": "Insights by strategy",
  "nSFlbh": "Review each strategy independently from total account performance.",
  "hCCWuZ": "Previous period",
  "I2z5s/": "Next period",
  "zriMHc": "Total profit",
  "iJGa+V": "Total loss",
  "Tj5OOs": "Average P&L",
  "0WJNP/": "Return",
  "179XvX": "Risk return",
  "Gb+H0H": "Strategy performance",
  "91RukZ": "Filter strategy performance by underlying",
  "K2A9LO": "All underlyings",
  "4HDD85": "No strategy results yet.",
  "gR2Nki": "{count} uses",
  "ntUAqx": "Strategy records",
  "bcbNYV": "{count} underlyings",
  "REPmkQ": "{count} results",
  "xr6MNz": "Strategy results could not be loaded.",
  "5HvJug": "No strategy records yet.",
  "4b7v6u": "No return rate",
  "5bTvdk": "Edit strategy record",
  "Vob6h4": "All day",
  "piVZo7": "Enter total P&L and either manual return or cost / max risk per contract.",
  "PCkXpo": "This strategy use could not be saved. Try again.",
  "5lBm4i": "Usage date",
  "PmxNCO": "Return method",
  "yOyjUj": "Manual return",
  "yIhdyQ": "Cost / max risk per contract",
  "2c55rc": "System return",
  "7jnhmW": "Matches system calculation",
  "R4U5+E": "Difference: {value} percentage points",
  "Z18Sal": "Strategy use recorded",
  "89GI54": "Record use",
  "BQRVjs": "Overall",
  "xK7rmd": "Insights",
  "IdOS2k": "Analysis page",
  "9XUYQt": "Import",
  "mOFG3K": "Start",
  "3JVa6k": "End",
  "hVd0t5": "Depth",
  "UHBWvP": "{count}d",
  "VAVAGE": "trade",
  "fM6GQY": "Expand floating summary",
  "t3hz64": "Minimize floating summary",
  "yvoT3+": "No trades yet",
  "7RUct4": "Import your Robinhood activity CSV to see total P&L, the trading calendar and performance analysis here.",
  "2uzHxT": "Import CSV",
  "gcYCT/": "{count} days",
  "2S35Pb": "{value}/day avg",
  "njz9LZ": "{count}d streak",
  "e/xwdG": "Analytics view",
  "/OVhC1": "EQUITY CURVE",
  "fF376U": "Current",
  "fG6gCw": "Best Win",
  "nXRE2N": "Worst Loss",
  "qoR2Kc": "Top Winners",
  "0qog7D": "Top Losers",
  "ii58xS": "Most Traded",
  "4YuB+L": "MONTHLY P&L",
  "YAPyM+": "P&L DISTRIBUTION",
  "QUlc3L": "DRAWDOWN",
  "3AWkGG": "By Day",
  "kYixXf": "{pct}% win",
  "y4cCLq": "By Underlying",
  "m0qwrb": "Show all {count}",
  "qyJtWy": "Show less",
  "r3/8SV": "Frequently used",
  "EZg1R6": "Gross profit",
  "zpD/0L": "Gross loss",
  "qO0CLS": "Daily P&L chart",
  "awORoU": "Monthly P&L",
  "DF3ZNU": "Monthly risk chart",
  "plPkUe": "Instrument risk-return chart",
  "bP90Np": "Daily P&L volatility",
  "+5EqeI": "Daily volatility",
  "bBjg5A": "Gross movement",
  "9ZrS92": "Downside",
  "E8Y4V6": "Monthly risk",
  "UMDxfE": "Instrument impact",
  "9/YgbO": "Action mix",
  "VGeLeR": "No data in this range.",
  "M0jCcC": "Unified trading performance",
  "Hv3fWK": "Monthly downside volatility",
  "47GLQV": "Instrument risk-return map",
  "W/V07i": "High-risk period action mix",
  "/qpG/9": "Back to analytics",
  "ADKsID": "Opened",
  "nDyaq/": "Running",
  "VdiJeK": "No transactions for {underlying} in this range",
  "r22s3o": "This strategy record could not be updated. Try again.",
  "j769oH": "This strategy record could not be deleted. Try again.",
  "sGQ2Ff": "Update the trade details or remove this record.",
  "DnX0aY": "Confirm delete",
  "YPDmud": "{start}–{end} of {total}",
  "OupIqH": "Buy upside exposure with a premium-defined loss, or sell that exposure and accept the obligation.",
  "ifg8Yt": "Long: buy one call. Short: sell one call. The same strike and expiration produce opposite option payoffs; covering a short call with stock changes the combined risk.",
  "hitmfO": "Buy a 100 call for 3: expiration breakeven 103, maximum loss 3, no finite upside profit cap. At 110 the profit is 7. Selling it reverses the 7 profit into a 7 loss.",
  "T0hkRO": "A bought call can lose its entire premium. An uncovered sold call has theoretically unlimited loss as the underlying rises; its maximum profit is the premium.",
  "+YzjqV": "A long call has positive delta, gamma and vega, and usually negative theta. Selling reverses those sensitivities. Time passing can offset a modest rise in the underlying.",
  "CFx3it": "A bullish forecast is not enough: the move must compensate for the price paid and happen in time. Confirm the long or short setting before reading the chart.",
  "JkP069": "Buy downside exposure or protection; selling a put takes the opposite risk.",
  "431t17": "Long: buy one put. Short: sell one put. For share-settled contracts, a put seller may have to buy the underlying at the strike.",
  "BNdW86": "Buy a 100 put for 3: expiration breakeven 97, maximum loss 3, maximum profit 97 if the underlying reaches zero. At 90 the profit is 7.",
  "UkVZlP": "A bought put risks its premium. A sold put can lose strike minus premium per unit if the underlying falls to zero; the collected premium is its maximum profit.",
  "yrqxhH": "A long put has negative delta, positive gamma and vega, and usually negative theta. A volatility drop can reduce its value even during a small underlying decline.",
  "aIlHmR": "Protection has a cost and a deadline. A put's gains are large but bounded by the underlying's zero price floor.",
  "ZKc6CF": "Exchange some stock upside for option premium while retaining stock downside.",
  "n13Cu0": "Hold the underlying and sell a call against the corresponding number of shares. For a 100-share contract, one short call needs 100 covering shares.",
  "Zbk0SM": "Buy stock at 100 and sell a 105 call for 2. Expiration breakeven is 98; maximum combined profit is 7 at or above 105. At zero, the combined loss is 98 per share.",
  "aL65fL": "The premium only cushions the stock loss. Shares can be called away, and early assignment may occur. A short call without the shares is not covered.",
  "kM9nvG": "Stock adds positive delta. The sold call reduces that delta and adds negative gamma and vega, usually with positive theta.",
  "vg4fnB": "Evaluate the shares and option together. The options-leg list alone does not prove that you own the shares needed to cover the position.",
  "B7+rau": "Receive premium while reserving cash to buy the underlying if assigned.",
  "cLRBuo": "Sell one put and reserve the cash required to purchase the contract's underlying quantity at the strike.",
  "R/gQw3": "Sell a 95 put for 2 and reserve 95 per underlying unit. Maximum expiration profit is 2; breakeven is 93. If the underlying reaches zero, the loss is 93 per unit.",
  "BnF3Ta": "Assignment can make you buy well above market value. Cash collateral funds the obligation; it does not prevent losses.",
  "VDPqUh": "A short put has positive delta, negative gamma and vega, and usually positive theta. A sharp decline with rising IV can hurt both price and volatility exposures.",
  "STkqoK": "Only call the position cash secured when the required cash is actually available. Model the result of owning the assigned shares.",
  "e61oeW": "Reduce the cost of a bullish call by giving up gains above a higher strike.",
  "LlJ2em": "Buy the lower-strike call and sell the higher-strike call, with equal quantity and the same expiration.",
  "lacWLV": "Buy the 100 call and sell the 105 call for a net debit of 2. Breakeven is 102. Maximum expiration profit is 3 at or above 105; maximum loss is 2 at or below 100.",
  "U2SSlX": "For an intact same-expiration spread, the debit is the maximum expiration loss and strike width minus debit is the maximum profit.",
  "sKkxpW": "Net delta is positive. The legs partly offset gamma, theta and vega; their net signs can change as price crosses the spread.",
  "G2JUzO": "A higher underlying price stops adding expiration profit above the short strike. Assignment can create stock exposure if the legs are handled separately.",
  "3iob3p": "Pay less for a bearish put by capping gains below a lower strike.",
  "HPabQm": "Buy the higher-strike put and sell the lower-strike put, with equal quantity and the same expiration.",
  "GB3LJS": "Buy the 100 put and sell the 95 put for 2. Breakeven is 98. Maximum expiration profit is 3 at or below 95; maximum loss is 2 at or above 100.",
  "mu5sM7": "The debit is the maximum expiration loss for the intact spread. Maximum profit is strike width minus debit.",
  "SKe32X": "Net delta is negative. Time and volatility effects partly offset across the legs, with net theta and vega depending on price and time remaining.",
  "O4ab51": "A dramatic crash below the short strike does not add expiration profit. The cheaper entry has traded away that extra downside participation.",
  "wlWItf": "Collect premium for a price floor view, with a lower put limiting the loss.",
  "cQo4qh": "Sell the higher-strike put and buy the lower-strike put at the same expiration and quantity.",
  "nxbpAV": "Sell the 100 put and buy the 95 put for a net credit of 2. Breakeven is 98. Maximum expiration profit is 2 at or above 100; maximum loss is 3 at or below 95.",
  "ZO4QNR": "Maximum expiration loss is strike width minus credit. The credit is the maximum profit, not the amount at risk.",
  "urNFVi": "Net delta is positive. Near the short put, positive theta and negative gamma often dominate, but Greek signs change across the price range.",
  "PxjyoF": "A high probability of retaining a small credit can coexist with a much larger loss. Check both outcome size and assignment obligations.",
  "qXLJbo": "Collect premium for a price ceiling view, with a higher call limiting the loss.",
  "DtTi8N": "Sell the lower-strike call and buy the higher-strike call at the same expiration and quantity.",
  "YPuvmQ": "Sell the 100 call and buy the 105 call for a credit of 2. Breakeven is 102. Maximum expiration profit is 2 at or below 100; maximum loss is 3 at or above 105.",
  "r6ub9G": "Maximum expiration loss is strike width minus credit for the intact spread. Closing or exercising one leg changes that bound.",
  "OMKl/2": "Net delta is negative. Time passing can help around the profitable region, while an upward move can quickly change the net delta through gamma.",
  "Zc92v8": "Bearish does not mean a decline is required: the position can profit if price stays below the short strike. The actual entry credit determines the breakeven.",
  "o7Hfqc": "Sell a trading range and buy protection beyond both edges.",
  "HETCGT": "Standard short version: buy a low put, sell a higher put, sell a still-higher call and buy a high call. All legs share an expiration. Reversing all sides creates the long version.",
  "d47Y66": "Buy the 90 put, sell the 95 put, sell the 105 call and buy the 110 call for a credit of 2. Maximum profit is 2 between 95 and 105; maximum loss is 3 outside 90 to 110. Breakevens are 93 and 107.",
  "389DqI": "For equal wings, maximum expiration loss is wing width minus credit. For unequal wings, check the wider side. The reverse structure profits outside the center instead.",
  "R+4vCr": "Around its center, the short version is often positive theta, negative gamma and negative vega. Delta moves away from neutral as the underlying approaches either wing.",
  "Zi30VD": "The quiet center is not a promise of low risk. A fast move or volatility expansion can produce a loss before either expiration breakeven is reached.",
  "ABo40h": "Concentrate a short-premium position around one target strike.",
  "wbfcP1": "Standard short version: sell a call and put at the center, buy a higher call and a lower put for protection. Reverse every side for a long iron butterfly.",
  "r9lyjn": "Sell the 100 call and put, buy the 95 put and 105 call, and receive 3. Maximum expiration profit is 3 at exactly 100; maximum loss is 2 beyond the wings. Breakevens are 97 and 103.",
  "1YnkEa": "For equal wings, maximum expiration loss is wing width minus credit. Maximum profit occurs at one price, not across a broad plateau.",
  "hOitYG": "Near the center, the short version often has positive theta and negative gamma and vega. Near expiration, small price moves can strongly change delta.",
  "WaI2om": "Do not confuse a narrow theoretical peak with an easy exit price. Transaction costs, assignment and moves around the center matter.",
  "WGk8eA": "Use a 1:2:1 structure to target a central expiration price.",
  "mBVJ3+": "Long butterfly: buy the low and high strikes and sell twice as many at the middle strike, all calls or all puts, at one expiration. Equal wings create a symmetric tent.",
  "yl5UoK": "Buy the 95 call, sell two 100 calls and buy the 105 call for a debit of 1. Maximum profit is 4 at 100; maximum loss is 1 outside the wings. Breakevens are 96 and 104.",
  "Ow2Gjw": "A long equal-wing butterfly risks the debit. Reversing the legs creates a short butterfly whose maximum loss is concentrated at the center.",
  "p7W9W8": "Near the center, a long butterfly can have positive theta and negative vega despite being bought for a debit. Greek signs vary near and outside the wings.",
  "Tcz8cA": "Long describes owning the structure, not having positive gamma everywhere. Confirm the side setting and inspect the actual legs.",
  "FKIyan": "Move risk toward one side by using unequal widths.",
  "9CoAPT": "ABG uses four legs: buy an anchor option, sell two options at separately adjustable strikes, then buy a farther wing. Matching the two short strikes gives the familiar 1:2:1 broken-wing butterfly.",
  "t4ubMg": "Buy the 100 call, sell the 105 and 110 calls, buy the 118 call, and pay 1. The expiration plateau from 105 to 110 earns 4. Below 100 the loss is 1; above 118 the loss is 4. Breakevens are 101 and 114.",
  "UVtIHD": "Unequal wing widths produce different tail losses. Compute both sides; the entry debit alone need not be the maximum loss.",
  "W/d7UO": "Delta and the location of theta and gamma exposure become asymmetric. Shifting short strikes also changes the peak into a plateau or changes its width.",
  "zJhQaG": "The name alone does not determine the shape. In ABG, read both short strikes and both outer strikes before assuming a textbook butterfly.",
  "uz3Bl8": "Broaden a butterfly's target into an expiration profit plateau.",
  "8evuwR": "Buy the lowest and highest strikes and sell the two inner strikes, using only calls or only puts at one expiration. Equal outer widths produce equal tail losses.",
  "Dvv3Oz": "Buy the 90 call, sell the 95 and 105 calls, buy the 110 call, and pay 2. Maximum expiration profit is 3 between 95 and 105; maximum loss is 2 outside the wings. Breakevens are 92 and 108.",
  "/RZGMw": "For equal outer widths, the long condor's maximum expiration loss is the debit, and maximum profit is one outer width minus debit.",
  "s5zIRd": "Around the central plateau, time decay can help as expiration approaches. Net delta, gamma and vega change around each boundary.",
  "OTHV7l": "A same-type condor and an iron condor can have similar shapes but different legs and entry cash flows. Identify the construction, not just the name.",
  "VcZkvB": "Reverse a same-type condor to benefit from finishing outside its wings.",
  "madbjF": "Sell the lowest and highest strikes and buy the two inner strikes, using only calls or only puts at one expiration.",
  "tKy6ze": "Sell the 90 and 110 calls, buy the 95 and 105 calls, and receive 2. Maximum expiration profit is 2 outside the outer strikes; maximum loss is 3 between 95 and 105. Breakevens are 92 and 108.",
  "vWq5iw": "The central region is the loss plateau. Maximum loss is one outer width minus credit for equal-width wings.",
  "b3PzNI": "Near the center, the position often benefits from volatility expansion and suffers from time passing. Directional exposure changes as price leaves the center.",
  "+8W6O6": "ABG's Short Condor is an inverted all-call or all-put condor. Some references use that name for an iron condor, so always compare the legs.",
  "cOvaFW": "Combine a naked put with a call credit spread for asymmetric premium exposure.",
  "DaHhnq": "Standard: sell a lower put, sell a higher call and buy a still-higher call. The reverse version uses a naked call and a put credit spread.",
  "ew6v10": "Sell the 95 put and the 105 call, buy the 110 call, and collect 6. Maximum expiration profit is 6 between 95 and 105. Above 110 the profit is 1; downside breakeven is 89, with a loss of 89 if price reaches zero.",
  "unPQiD": "Only a total credit at least as large as the call-spread width removes the standard version's expiration upside loss. The naked put still has large downside risk. The reverse version has uncovered-call upside risk.",
  "DFs++f": "The standard version is commonly positive theta and negative vega and gamma around its profitable range, with bullish directional exposure from the put.",
  "hZ/YRQ": "The example credit is hypothetical. A preset does not guarantee enough credit to remove one tail loss; compare the actual credit with the protected spread width.",
  "QzI+F8": "Buy more options than you sell to seek a large directional move.",
  "N2tCaO": "Call version: sell one lower-strike call and buy two higher-strike calls. Put version: sell one higher-strike put and buy two lower-strike puts.",
  "Fh3p6J": "Sell the 100 call and buy two 105 calls for a credit of 1. Expiration profit is 1 below 100, the maximum loss is 4 at 105, and breakevens are 101 and 109. Upside profit above 109 is uncapped.",
  "y5W4eB": "A moderate move toward the doubled long strike can be worse than no move. The call version has unlimited upside profit; the put version's downside profit is bounded by zero.",
  "ZrdbUt": "The extra long options can create positive gamma and vega, but net exposures vary by price. Time decay can deepen the valley near the long strikes.",
  "ZnHdGB": "Receiving a credit does not make the position risk free. Identify the loss valley and how far price must travel to escape it.",
  "OzTyY7": "Sell more options than you buy to target a moderate move, accepting an exposed tail.",
  "zRBntP": "Call version: buy one lower call and sell two higher calls. Put version: buy one higher put and sell two lower puts.",
  "KDwuId": "Buy the 100 call and sell two 105 calls for a credit of 1. Maximum expiration profit is 6 at 105. Above 111 the position loses, with no finite upside loss limit. At or below 100 it retains 1.",
  "tE3POI": "The extra short call is uncovered. In the put version, losses grow during a deep decline and are bounded only by the underlying reaching zero.",
  "0wMsdG": "Near the doubled short strike, gamma and vega can be negative and theta positive. Beyond it, a favorable initial direction can turn into harmful exposure.",
  "HH9xXM": "A ratio spread is not a defined-risk vertical. Count the quantities as well as the number of different strikes.",
  "zx5Zt7": "Target a moderate rise while selling an additional call to fund entry.",
  "ss1E2b": "Buy one lower-strike call, sell one middle-strike call and sell one higher-strike call at a common expiration.",
  "n9DlDT": "Buy the 100 call, sell the 105 and 110 calls, and pay 1. Maximum expiration profit is 4 from 105 to 110. Breakevens are 101 and 114; losses grow without limit above 114.",
  "tIrl/a": "One call remains uncovered in the upside tail. At or below the lowest strike the loss equals the debit, but that is not the maximum loss.",
  "p9SurY": "Delta can start bullish and turn bearish after a large rise. The two short calls often create negative gamma around the upper strikes.",
  "EYMTYl": "Bull in the name does not mean every rise helps. The extra short call makes a rally beyond the target dangerous.",
  "ooMITQ": "Sell a lower call and buy two higher calls, creating a loss valley before upside participation.",
  "JIKYT4": "Sell one lower-strike call and buy one call at each of two higher strikes, all at the same expiration.",
  "FqvPpm": "Sell the 100 call, buy the 105 and 110 calls, and receive 1. Maximum expiration loss is 4 from 105 to 110. Breakevens are 101 and 114; above 114 the upside profit is uncapped.",
  "HQR2pH": "The central valley is the main expiration loss. The initial credit, if any, protects the quiet downside but not the region between the long strikes.",
  "/axBar": "The position can begin with bearish exposure and become bullish on a large rally. Gamma and vega depend on the relative weights of the three strikes.",
  "P71uFD": "The name describes the initial setup, not all outcomes. Both a quiet market and a sufficiently large rally can outperform a moderate rise.",
  "IneWt/": "Sell a higher put and buy two lower puts, creating a valley before crash participation.",
  "DL6H0T": "Sell one higher-strike put and buy one put at each of two lower strikes at the same expiration.",
  "2q8JE4": "Sell the 100 put, buy the 95 and 90 puts, and receive 1. Maximum expiration loss is 4 from 90 to 95. Breakevens are 99 and 86; at zero the maximum profit is 86.",
  "8nK0NZ": "A moderate decline into the long strikes can cause the maximum loss, while a much deeper decline benefits the extra long put.",
  "8abvaa": "Directional exposure may flip from bullish to bearish as price falls. Time and volatility affect the loss valley as well as the tail.",
  "JGL58P": "Crash protection is not protection against every decline. Check the price interval where the structure still loses.",
  "PkyZG1": "Target a moderate decline while selling an additional lower put.",
  "E1wJcP": "Buy one higher-strike put and sell one put at each of two lower strikes at a common expiration.",
  "rm4Htp": "Buy the 100 put, sell the 95 and 90 puts, and pay 1. Maximum expiration profit is 4 from 90 to 95. Breakevens are 99 and 86; at zero the loss is 86.",
  "JewXfd": "The extra short put creates substantial downside exposure. The debit is only the upside-tail loss, not the maximum loss.",
  "i2cejU": "The position can start bearish and turn bullish after a large decline. Negative gamma near the short puts can accelerate the change.",
  "Us2nh6": "A deeper fall is not always better for a bearish-named strategy. The uncovered put reverses the payoff beyond the lower target.",
  "l5KxAv": "Combine a call and put to create approximately linear directional exposure.",
  "FkOmjZ": "Long synthetic: buy a call and sell a put at the same strike and expiration. Short synthetic: reverse both legs.",
  "0R6U3t": "Buy the 100 call and sell the 100 put for a net debit of 1. Expiration profit is underlying minus 101. At 110 the profit is 9; at zero the loss is 101. Reversing the trade reverses its payoff.",
  "MaeEWP": "A low net premium can conceal stock-like exposure. The long version has large downside loss; the short version has unlimited upside loss.",
  "9vMTuP": "In an ideal same-strike European model, call and put gamma and vega cancel. Delta is close to +1 or -1 per unit; financing, dividends and exercise features still matter.",
  "Yxbi+Z": "Synthetic does not mean low risk or identical operational behavior to a futures contract. There are two options with their own settlement obligations.",
  "gzmEWL": "Use different call and put strikes for directional exposure with a central flat region.",
  "qCkWEu": "Long combo: buy an out-of-the-money call and sell an out-of-the-money put. Short combo: reverse both legs at the same expiration.",
  "SWWeis": "Buy the 105 call and sell the 95 put for a net debit of 1. Between 95 and 105 the expiration loss is 1. Breakeven is 106; upside profit is uncapped and the loss at zero is 96.",
  "lpvx7T": "The sold put exposes the long combo to a large decline. Reversing the combination leaves an uncovered short call with unlimited upside risk.",
  "1bpbOC": "Unlike a same-strike synthetic, the two options' gamma and vega do not generally cancel. Net exposure changes as price approaches either strike.",
  "GquDRZ": "The gap between strikes makes the payoff different from stock or a same-strike synthetic. Include the entry cash flow when locating breakeven.",
  "LPmAJ0": "Trade the size of a move around one strike rather than choosing only its direction.",
  "Gx43kE": "Buy a call and put at the same strike and expiration for a long straddle; sell both for a short straddle. ABG's default is the short version.",
  "tRzqcg": "For the long version, buy the 100 call and put for a total of 6. Maximum expiration loss is 6 at 100; breakevens are 94 and 106. At 112 the profit is 6. Selling both reverses the payoff.",
  "kf2Pu5": "A long straddle risks its premium. A short straddle has unlimited upside loss and a large downside loss, while its maximum profit is the credit.",
  "TgISMx": "The long version has positive gamma and vega and usually negative theta. The short version reverses these signs. Delta near zero does not remove movement risk.",
  "s77/wt": "Large price movement alone does not guarantee a profit for the buyer: compare it with the premium paid and any IV decline. Compare the actual option sides with the illustrated example.",
  "uLPhJ+": "Move the call and put apart to change the cost and the required move.",
  "/dM/z9": "Long: buy a lower-strike put and a higher-strike call at the same expiration. Short: sell both. ABG's default is the short version.",
  "VJ35oN": "Buy the 95 put and 105 call for 4. Maximum expiration loss is 4 between 95 and 105; breakevens are 91 and 109. Selling both retains 4 in the center but exposes both tails.",
  "WbMNt/": "The long version risks the total premium. The short version's upside loss is unlimited and its downside loss can be substantial.",
  "ywQ5mP": "A bought strangle has positive gamma and vega and usually negative theta. Compared with a similar straddle, farther strikes generally cost less but require a larger move to break even.",
  "Co1Z0D": "A wider profitable range for the seller does not cap tail losses. Farther-out strikes may also be less liquid.",
  "bP3q2B": "Buy movement exposure with extra weight on a downside move.",
  "7dBTyv": "Buy one call and two puts at the same strike and expiration.",
  "63DRck": "Buy one 100 call and two 100 puts for a total of 9. Maximum expiration loss is 9 at 100. Breakevens are 95.5 and 109. At 90 the profit is 11; at 110 it is 1.",
  "qPGnha": "All three bought options can lose the total premium. Upside profit is uncapped; downside profit is bounded by the underlying reaching zero.",
  "0zPh/b": "Positive gamma and vega come from all three legs. Extra puts add bearish weight, while the total premium increases the usual time-decay burden.",
  "hfk04Z": "This is not simply a cheap bearish trade. The extra option increases cost and the amount of movement needed to recover it.",
  "DM7Wu3": "Buy movement exposure with extra weight on an upside move.",
  "N8XJwe": "Buy two calls and one put at the same strike and expiration.",
  "VzG2yu": "Buy two 100 calls and one 100 put for 9. Maximum expiration loss is 9 at 100. Breakevens are 91 and 104.5. At 110 the profit is 11; at 90 it is 1.",
  "dCISfA": "The whole premium can be lost near the common strike. Upside profit is uncapped, while downside profit stops growing once the underlying reaches zero.",
  "aruSUY": "The bought options supply positive gamma and vega. Extra calls add bullish weight; theta is usually negative.",
  "PnssQl": "Compare the extra upside participation with the extra premium. The asymmetric quantities matter as much as the common strike.",
  "50hD5f": "Combine an in-the-money call and put, embedding intrinsic value in the entry price.",
  "j0QtT0": "Long guts: buy a lower-strike call and a higher-strike put at one expiration. Short guts: sell both. The strikes overlap rather than leave a gap.",
  "OMRUwt": "Buy the 95 call and 105 put for 13. Their minimum combined expiration value is 10 between the strikes, so maximum loss is 3. Breakevens are 92 and 108; at 110 the profit is 2.",
  "PueJci": "For long guts, maximum expiration loss is debit minus the strike gap. Short guts has unlimited upside loss and large downside exposure.",
  "N1VyN7": "The long version has positive gamma and vega and usually negative theta. Its large premium includes intrinsic value and should not be confused with all-at-risk time value.",
  "/OAOqN": "In-the-money short options may be assigned early. The strike gap explains why the long version's maximum loss is smaller than the gross premium.",
  "aMFcQo": "Trade the difference between near-term and longer-term option value.",
  "BlCV+X": "Sell a nearer-expiration option and buy a later-expiration option of the same type. Equal strikes make a calendar; different strikes make a diagonal.",
  "UlS9lO": "Sell a near-term 100 call for 2 and buy a later 100 call for 5: debit 3. At the first expiration with price at 100, the short call has no intrinsic value. If the remaining call is then worth 4, the position profit is 1; its value is not predetermined.",
  "2kQ/QB": "A conventional same-strike long calendar generally risks its debit if managed as a spread, but there is no single fixed first-expiration maximum profit or breakeven. Diagonals and assignment require separate analysis.",
  "S4dyyz": "The long calendar often has positive vega and positive theta near the strike, but both depend on price and each expiration's IV. The two maturities need not move together.",
  "2he0U8": "Do not set both legs' time value to zero at the first expiration. The later option is still alive; model its remaining time, IV and any resulting stock position.",
  "xldPBp": "Place two time spreads around different price targets.",
  "6pOg5D": "Sell a near-term put and call, and buy later-expiration counterparts. Matching each pair's strikes creates a double calendar; shifting later strikes creates double diagonals.",
  "bihyAJ": "Build calendars at put strike 95 and call strike 105 for a combined debit of 4. At the first expiration, if the short options expire worthless and the later options are worth 5 in total, profit is 1. Different remaining values produce different outcomes.",
  "w3ZEPW": "First-expiration maximum profit and breakevens depend on remaining option values. Separate assignment, skewed strikes and leg management can add exposure beyond a simple debit picture.",
  "LCNv95": "Two time spreads distribute exposure around two strikes, but do not make theta uniformly positive. Near and far IV, skew and a move beyond either target all matter.",
  "//100j": "Two peaks are not a guaranteed profitable range. Inspect both expirations independently and plan what remains after the short options settle.",
  "UbB/KS": "Build a payoff from individual legs instead of relying on a strategy name.",
  "9r06tj": "Choose each leg's type, side, quantity, strike and expiration. Add the signed value of all options and any stock exposure, then include the entry cash flow.",
  "7e2ouY": "One bought 100 call plus one sold 105 call, at one expiration and a net debit of 2, recreates a bull call spread: maximum loss 2, maximum profit 3 and expiration breakeven 102.",
  "JBz+kx": "There is no universal maximum loss for a custom structure. Extra short quantity, different expirations or disabled protective legs can change a capped loss into an exposed tail.",
  "I0BU4G": "Net Greeks are signed sums with quantities. Small net delta does not imply small gamma, theta or vega, and offsets can disappear as the market moves.",
  "DXFbWj": "Check active legs and quantities before trusting a familiar-looking chart. A renamed or edited structure can behave differently from its original template.",
  "BVHMie": "{ticker} already has {limit} saved strategies. Remove one before saving another.",
  "BiB/BX": "You already have {limit} saved strategies. Remove one before saving another.",
  "vhPJcA": "Cash Secured Put",
  "BAIs+v": "Bull Put Spread",
  "yYnHyH": "Bear Call Spread",
  "EZo0jy": "Iron Fly",
  "EafK35": "Butterfly",
  "mndiAJ": "Long Condor",
  "pC/mCh": "Short Condor",
  "A/jDOX": "Ratio Backspread",
  "LRUyIp": "Ratio Spread",
  "S0rkLz": "Bull Call Ladder",
  "Q70WOv": "Bear Call Ladder",
  "LxGacl": "Bull Put Ladder",
  "LspYOE": "Bear Put Ladder",
  "7sjUNb": "Synthetic Future",
  "GVauyJ": "Combo",
  "COs1u/": "Guts",
  "AdnNe+": "Double Time Spread",
  "inBVoA": "New Strategy",
  "btOI+Z": "New Tab",
  "WNqryT": "Single Leg",
  "aPQRlz": "Covered",
  "D3gsD+": "Vertical Spreads",
  "f4M5gO": "Multi-Leg",
  "EAwHkJ": "Ratio / Ladder",
  "7iztjK": "Synthetic",
  "JjhYeA": "Time-Based",
  "yjzE8I": "theoretically capped above short call",
  "VsAMpv": "stock downside",
  "Vq5PyS": "width minus net debit",
  "yUABey": "net debit",
  "n3Co/5": "net credit",
  "PJ1dBr": "width minus credit",
  "24HXKj": "one-side spread width minus credit",
  "LYGUlD": "wing width minus credit",
  "7rBe4+": "wing width minus net debit",
  "n+Cz2z": "short-body profit peak",
  "XJj5d9": "wider-wing tail risk",
  "KKENWN": "middle-body width minus net debit",
  "F8rmdf": "naked put downside risk",
  "XqyKcj": "breakout-direction profit",
  "X31/VM": "peak loss between short and long legs",
  "dW+zxW": "profit peak near short legs",
  "1iTwDl": "extra naked-short tail risk",
  "VS/Ihf": "profit peak near first short call",
  "45brT3": "naked upside call risk",
  "eoaNBV": "keep net credit below short call",
  "AEjzZb": "loss zone between short and long calls",
  "wivuPI": "keep net credit above short put",
  "HixThU": "loss zone between short and long puts",
  "YukVUC": "profit peak near first short put",
  "z3z5lZ": "naked downside put risk",
  "/HSKER": "directional linear profit",
  "5O/sHw": "opposite linear loss",
  "Y4orcp": "split-strike directional profit",
  "OgQnrO": "large-move profit with downside tilt",
  "dLifQL": "large-move profit with upside tilt",
  "bQTroT": "large-move profit",
  "0ptZoB": "front expires while back keeps value",
  "35wBrm": "either target holds back-month value after front expiry",
  "hhUUcA": "two-sided naked short risk",
  "dUi081": "Build a custom single-leg structure in any direction",
  "kNo9Ur": "Default debit",
  "VRJBzY": "Default credit",
  "EJXzwi": "Debit/Credit",
  "ud47iB": "Usually debit",
  "l2cWpA": "Usually credit",
  "8MHCc/": "Custom flow",
  "yj3Ek7": "Long stock · Profits below short call",
  "zq/VPt": "Bullish entry · Profits above short put",
  "3go0FC": "Bullish · Profits above upper short leg",
  "iDg/un": "Bearish · Profits below lower short leg",
  "lHYKP1": "Mildly bullish · Profits above short put",
  "0dHz6I": "Mildly bearish · Profits below short call",
  "Zn6aWZ": "Range-bound · Profits between short strikes",
  "BT6fmR": "Near ATM · Profits near center strike",
  "oqRva+": "Pinning · Profits near center strike",
  "aJ8KXm": "Skewed pin · Profits near short body",
  "YWH1k0": "Neutral range · Profits inside middle range",
  "WmZDhK": "Range breakout · Profits outside middle body",
  "tRkOea": "Bullish income · Profits above short put and below call spread",
  "AgBPp6": "Breakout · Profits on a large move",
  "HdAv0u": "Near short legs · Profits near short-leg area",
  "lrvcmZ": "Moderate bullish · Profits on a moderate rise",
  "RqIcf6": "Bearish · Profits lower or below short leg",
  "Puavpz": "Bullish · Profits higher or above short leg",
  "1KymZh": "Moderate bearish · Profits on a moderate drop",
  "IMd6jS": "Long/short toggle · Profits when direction is right",
  "To5w2b": "Bearish volatility · Profits from a large move, especially down",
  "UAxQ4R": "Bullish volatility · Profits from a large move, especially up",
  "IAOgey": "Volatility · Profits from a large move",
  "Nlbz9u": "Time decay · Profits when near expiry decays faster near target",
  "NhydAG": "Two-sided time decay · Profits near either target zone",
  "3U2JDX": "Low volatility · Profits near ATM",
  "I0Evzm": "Wide low volatility · Profits between legs",
  "X9lQXE": "**Side toggle**: long (bullish bet, theoretically unlimited upside) or short (collect premium, naked = theoretically unlimited risk).",
  "UJKhEJ": "**Side toggle**: long (bearish bet, large downside profit) or short (collect premium, large risk if assigned).",
  "orqgbR": "**Side toggle**: flip between short (sell the body, collect credit) and long (buy the body, pay debit).",
  "eBViVv": "**Side toggle**: flip between short (sell ATM, buy wings) and long (buy ATM, sell wings).",
  "mUDzZH": "**Side toggle**: long butterfly (buy wings) or short butterfly (sell wings).",
  "HmyTOF": "**Side toggle**: long synthetic (bullish) or short synthetic (bearish).",
  "YOYjdR": "**Side toggle**: long combo (buy both) or short combo (sell both).",
  "9f8+TX": "**Side toggle**: long guts (buy both) or short guts (sell both).",
  "jzrxdq": "**Side toggle**: long straddle (buy both, pay debit) or short straddle (sell both, collect credit).",
  "uNYc8q": "**Side toggle**: long strangle (buy both) or short strangle (sell both).",
  "/060cE": "Wing Width",
  "MQ02gW": "Skew",
  "0EezXf": "Put Skew",
  "HpX0Tp": "Call Skew",
  "hUQV9B": "Short 1 Offset",
  "BTFWpP": "Short 2 Offset",
  "Kg6ptZ": "Long Wing Offset",
  "+VExbc": "Put Short",
  "Wcliju": "Put Long",
  "YPIa+q": "Call Short",
  "l4M3QP": "Call Long",
  "tSGyio": "Call Offset",
  "JEocny": "Put Offset",
  "rEI51g": "Strike Offset",
  "+c77SN": "Long Offset",
  "li9/qa": "Short Offset",
  "toDIbF": "Front DTE",
  "qQRKaD": "Back DTE",
  "R9e9So": "Lower Body",
  "5vVtJV": "Upper Body",
  "+A3wWe": "Long 1 Offset",
  "yYCNM0": "Long 2 Offset",
  "L6fdl4": "Naked Leg Offset",
  "4pm/91": "Spread Short Offset",
  "Q6xaHI": "Spread Long Offset",
  "/TDl2v": "Bias",
  "RiGLab": "Strike Offset — signed distance from spot. Negative = below spot, positive = above spot.",
  "0GEKu4": "Long Offset — position of the bought leg relative to spot or the strategy center.",
  "tkN/X7": "Short Offset — position of the sold leg relative to spot or the paired long leg.",
  "6Fz0e2": "Call Offset — distance from spot to the call strike. Higher = farther above spot.",
  "TPcyBZ": "Put Offset — distance from spot to the put strike. Higher = farther below spot.",
  "IYKW2A": "Wing Width — distance from the center/body to the outer wings. Wider = more potential profit, but weaker protection or higher cost.",
  "0Ov/mE": "Lower Body — distance from the center to the lower inner strike.",
  "/Boq/3": "Upper Body — distance from the center to the upper inner strike.",
  "/yMgas": "Skew — shifts the center strike away from at-the-money. Negative = lower, positive = higher.",
  "92y9KN": "Put Skew — shifts the put-side back-month strike. Negative = lower, positive = higher.",
  "DtI+Id": "Call Skew — shifts the call-side back-month strike. Negative = lower, positive = higher.",
  "DMBKyE": "Put Short — distance below spot for the short put strike.",
  "wNkFMN": "Put Long — distance below spot for the protective long put strike.",
  "3WWSTo": "Call Short — distance above spot for the short call strike.",
  "cZGjP1": "Call Long — distance above spot for the protective long call strike.",
  "+oqPh9": "Short 1 Offset — distance from the center to the first short leg.",
  "pQVJVu": "Short 2 Offset — distance from the center to the second short leg.",
  "MREoUc": "Long Wing Offset — distance from the center to the long wing.",
  "wGSwwY": "Short 1 Offset — position of the first sold leg relative to the strategy center.",
  "Rx8RDW": "Short 2 Offset — position of the second sold leg relative to the strategy center.",
  "rhx25O": "Long 1 Offset — position of the first bought leg relative to the strategy center.",
  "T7tNXP": "Long 2 Offset — position of the second bought leg relative to the strategy center.",
  "qCNMk4": "Naked Leg Offset — distance from spot to the uncovered sold option leg.",
  "phcJV/": "Spread Short Offset — distance from spot to the short leg of the spread.",
  "QjP8u5": "Spread Long Offset — distance from spot to the protective long leg of the spread.",
  "HKSKPv": "Front DTE — days to expiration for the near-term leg.",
  "hxSMgr": "Back DTE — days to expiration for the later-term leg.",
  "h7uy/0": "Strike Offset — current side: {side}. Negative = below spot, positive = above spot.",
  "C5ZbDk": "Wing Width — current side: Long iron fly. Outer wings are sold; wider wings give large moves more room but usually change the debit paid.",
  "5WTPuB": "Wing Width — current side: Short iron fly. Outer wings are bought for protection; wider wings increase possible credit but weaken protection.",
  "2SFky2": "Skew — current side: {side}. Negative shifts the iron fly center lower; positive shifts it higher.",
  "lYwHhh": "Wing Width — current side: Long butterfly. Wider wings broaden the target zone but usually increase cost.",
  "CxolEe": "Wing Width — current side: Short butterfly. Wider wings broaden the risk zone and change the credit received.",
  "4ymm00": "Put Short — current side: {side}. This inner put leg is currently {legSide}.",
  "J6M+7z": "Call Short — current side: {side}. This inner call leg is currently {legSide}.",
  "eagx3p": "Put Long — current side: {side}. This outer put leg is currently {legSide}.",
  "AqTbbD": "Call Long — current side: {side}. This outer call leg is currently {legSide}.",
  "kjZqR8": "Short 1 Offset — current direction: {direction}. Moves the first short leg toward that side.",
  "9/Y8tC": "Short 2 Offset — current direction: {direction}. Moves the second short leg farther on that side.",
  "12asnA": "Long Wing Offset — current direction: {direction}. Extends the wider protective wing on that side.",
  "ea44hg": "Naked Leg Offset — current direction: {direction}. Controls the uncovered short option leg.",
  "xO28E7": "Spread Short Offset — current direction: {direction}. Controls the short leg of the defined-risk spread.",
  "lKLApR": "Spread Long Offset — current direction: {direction}. Controls the protective long leg of the spread.",
  "gFo0YN": "Long Offset — current type: {optionType}. Controls the bought {optionType} leg.",
  "RDthON": "Short Offset — current type: {optionType}. Controls the sold {optionType} leg.",
  "UkGTjM": "Strike Offset — current type: {optionType}. Negative = below spot, positive = above spot.",
  "24zZ5W": "Skew — current type: {optionType}. Positive moves the back-month leg toward at-the-money; negative moves it away.",
  "CxJoai": "Call Offset — current side: {side}. Controls the {side} call leg distance from spot.",
  "YuyjAw": "Put Offset — current side: {side}. Controls the {side} put leg distance from spot.",
  "kR9dEl": "Put Skew — positive moves the back-month put toward at-the-money; negative moves it away.",
  "ujXZ/g": "Call Skew — positive moves the back-month call toward at-the-money; negative moves it away.",
  "veDZ8/": "Consumer Price Index",
  "fCGF+k": "Nonfarm Payrolls",
  "vWKXdA": "Federal Reserve Rate Decision",
  "OPqL8X": "Producer Price Index",
  "MnsFMC": "Weekly Unemployment Claims",
  "UQ9JP3": "Spot (S)",
  "uhQRhf": "Strike (K)",
  "9h+1kW": "Moneyness (m)",
  "Sq7vTV": "IV (σ)",
  "VtTdd+": "DTE (T)",
  "/+RN4D": "Premium (V)",
  "ZTNRlu": "New Year's Day",
  "OHVKBE": "New Year's Day (observed)",
  "CUtJjT": "Martin Luther King Jr. Day",
  "dGj8P2": "Presidents' Day",
  "Xilayx": "Good Friday",
  "dwDYvG": "Memorial Day",
  "KeXvKY": "Juneteenth",
  "HUl+d1": "Juneteenth (observed)",
  "JADIlZ": "Independence Day",
  "hMH9z7": "Independence Day (observed)",
  "7gB8c9": "Labor Day",
  "AuH0Nu": "Thanksgiving",
  "Zr6Dvg": "Christmas",
  "3bWdwJ": "Christmas (observed)",
  "+NmCFj": "Page views",
  "Z3EDd9": "Sessions",
  "CrJOJJ": "Referrals",
  "TzhzIH": "Creators",
  "f+sh2j": "Administration",
  "HtN6s8": "Journal entries",
  "ofHC1Q": "Imports",
  "UAJe/C": "Product interactions",
  "mU9gmg": "Viewed learning page",
  "L75jXl": "Purchase page",
  "0TKzvD": "Simulator",
  "vEF59U": "Guide",
  "ywDLaG": "Backtest",
  "77MbQy": "Signed in",
  "lbpe3v": "Signed out",
  "KQvWvD": "Deleted",
  "NZ3zNR": "Visited",
  "bhEK7m": "Updated customer",
  "zqD/ym": "Deleted customer",
  "ZH86SI": "Invited customer",
  "HOtWVl": "Recorded creator payout",
  "X/n0XY": "Sent login email",
  "nZCsq4": "Added customer follow-up",
  "SJl0MA": "Updated customer follow-up",
  "Yj5wok": "Import failed",
  "a1UOjm": "{count} transactions imported",
  "7GfSfn": "Calls, puts, buyers and sellers",
  "Y59dAk": "A call gives you the right to buy.\nA put gives you the right to sell.\nBuyers pay for the choice.\nSellers receive money for taking the obligation.",
  "uyL+Ww": "A call gives its buyer the right to buy the underlying at the strike price. A put gives its buyer the right to sell. The buyer pays a premium; the seller receives it and takes the corresponding obligation if assigned. Cash-settled options settle the value in cash instead of delivering shares.",
  "tTxuro": "Pay 3 for the right to buy at 100. If the price is 110 at expiration, the right is worth 10: profit = 10 - 3 = 7 per unit, before costs.",
  "44y5By": "An option buyer can lose the full premium. A seller can lose much more than the premium received.",
  "xUn3rM": "Strike price and expiration",
  "60sOVb": "The strike is the contract's buy or sell price.\nExpiration is when the right ends.",
  "ArYJa/": "The strike is the contract price, not the current market price. Expiration limits the life of the right. A call is in the money when the underlying is above its strike; a put is in the money when it is below. In the money does not necessarily mean profitable after the premium.",
  "DJwDMa": "Pay 5 for a 100 call. At expiration with price 102, it is worth 2: a loss of 3 per unit before costs. Price must reach 105 to break even.",
  "hN8Ptz": "Getting the direction right is not enough. The move must happen before the option expires and cover what you paid.",
  "fxc6IF": "Premium, intrinsic value and time value",
  "pdzl9f": "The premium is the option's price: its exercise value today plus any extra value for the time remaining.",
  "29xQyw": "Intrinsic value is the amount an option is in the money. Extrinsic value is the rest of its price and reflects remaining uncertainty, time and financing effects. Implied volatility is the volatility input consistent with an option's market price; it is not a forecast guaranteed to come true.",
  "7J7sd4": "A 100 call costs 5 when the underlying is 103. Its exercise value is 3; the extra 2 is time value. At expiration with price still 103, it is worth 3.",
  "UIc/D0": "An unchanged underlying price does not mean an unchanged option price. Time value disappears at expiration.",
  "d3EsQM": "Read an expiration payoff",
  "tmX8Q6": "Expiration profit equals what the position is worth at expiration, minus what you paid, or plus what you received.",
  "dd/LXF": "For a bought call, expiration profit per unit is max(underlying minus strike, 0) minus premium. For a bought put, it is max(strike minus underlying, 0) minus premium. Reverse the sign for a sold option, multiply by quantity, and add every leg. Stock positions contribute their own price change.",
  "HNkTm0": "Buy a 100 call and sell a 105 call for a total cost of 2. At expiration: price 100 means a loss of 2; price 102 breaks even; price 105 or higher earns 3 per unit, before costs.",
  "KMGp3F": "Expiration profit is different from today's position value. Multiply per-unit amounts by the contract size and quantity.",
  "M2ZZ4j": "Risk, assignment and settlement",
  "S0Z+x6": "Selling an option creates an obligation. Assignment means the seller must fulfill it.",
  "QPNhOW": "A short American-style option can be assigned before expiration. A protective long option does not automatically exercise just because the short leg is assigned. Cash settlement, share delivery, trading hours and exercise rules differ by product. Margin is collateral, not a maximum loss estimate.",
  "gN+mLS": "Sell a share-settled 100 put. If assigned when the market price is 70, you must still buy at 100: a 30-per-share loss before the premium and costs.",
  "cTMnIH": "Margin is a deposit, not your maximum loss. Check whether the contract settles in shares or cash.",
  "BDfESy": "The size of the price change",
  "BtE1qb": "Calls: the same stock-price move changes the option price more far above the strike, and less far below it.\nPuts: a rising stock price usually lowers the option price; a falling stock price usually raises it.",
  "RRseuU": "How much does the option value change when the underlying moves by one unit?",
  "UMcNDu": "Delta measures local exposure to the underlying price. A bought call has positive delta; a bought put has negative delta. Selling reverses the sign. Add the signed delta of every leg, with quantities, to read the combination's exposure.",
  "ST8IDo": "Example: delta +0.50 means a price rise of 1 adds about 0.50 to the option's value per unit.",
  "AhMRBz": "Delta is not a return percentage or a guaranteed probability of profit. It changes with price, time and volatility. A delta-neutral position can still have substantial gamma and volatility risk.",
  "WS8064": "Delta's accelerator",
  "jv7cwP": "Near the strike and close to expiration, the same stock-price move usually causes a larger change in delta.\nFar from the strike, the change in delta is usually smaller.",
  "ZP3/iH": "For a one-unit rise in the underlying, approximately how much does delta change?",
  "sCgtPB": "Gamma measures the change in delta for a one-unit underlying move. Bought vanilla calls and puts have positive gamma; sold options have negative gamma. Near-the-money gamma can become large close to expiration, so a small move can rapidly change directional exposure.",
  "SIZXyl": "Example: delta 0.50 and gamma 0.04. After a price rise of 1, delta is about 0.54. This is the new delta, not the profit.",
  "O7iIpD": "Positive gamma helps a position adapt to a large move, but long options usually pay for that convexity through time decay. Negative gamma can overwhelm a day's positive theta.",
  "wugPXb": "The speed of time decay",
  "me0X6x": "Bought options usually lose value as time passes. Near the strike, daily decay typically speeds up as expiration approaches.\nFar from the strike, the daily loss is often smaller. The daily amount is not fixed.",
  "ZzqFIV": "How does the option value change as one day passes?",
  "5P1Ugu": "Theta estimates the local effect of time passing with price, volatility and other inputs fixed. Bought options usually have negative theta; short positions often have positive theta. A spread's net theta depends on where the underlying is relative to its strikes.",
  "NB50AF": "Example: theta -0.08 means one day passing reduces the option's value by about 0.08 per unit.",
  "C+R2pN": "Do not multiply today's theta by all remaining days to predict the final result. Time decay is not constant, and positive theta is compensation for other risks rather than a daily interest payment.",
  "AW8s1f": "Sensitivity to expected price swings",
  "PaEsdS": "Expecting larger swings usually makes ordinary options more expensive; higher vega means a larger response to the same volatility change.\nSensitivity is usually greater with more time remaining, and weaker near expiration.",
  "3eGHie": "How does the option value change when implied volatility rises by one percentage point?",
  "MVjrrk": "Vega measures exposure to implied volatility. Bought vanilla options have positive vega; sold options have negative vega. In a combination, each strike and expiration can have a different implied volatility, so one net number cannot capture every volatility-surface move.",
  "vyqzYR": "Example: vega 0.12 means IV rising from 20% to 21% adds about 0.12 per unit. That is one percentage point.",
  "nIqrMR": "An option can lose value after a correctly predicted price move if implied volatility falls enough. Calendars require attention to the separate volatility of each expiration.",
  "e4UhvA": "Rho",
  "eXKj0T": "Interest-rate sensitivity",
  "aLORUc": "When rates rise, calls generally become more expensive and puts cheaper.\nThe effect is usually larger with more time remaining, and smaller near expiration.",
  "87Hjz3": "How does the option value change when the risk-free interest rate used in pricing rises by one percentage point?",
  "TA0hGI": "Rho measures sensitivity to the risk-free interest-rate input. In a standard European option model, bought calls have positive rho and bought puts have negative rho. Longer-dated options generally have more interest-rate exposure.",
  "jigGk3": "Example: rho 0.04 means the rate rising from 4% to 5% adds about 0.04 to the option's value per unit.",
  "QTAib9": "Interest rates are one input among several. An actual rate announcement can also move the underlying and implied volatility, so its total effect is not described by rho alone.",
  "Nb+iu7": "Complete this check to receive your login PIN.",
  "1NTfJP": "Pay a premium to buy one call option.",
  "0jTBSK": "Expect the stock to rise before expiration; participate in that rise with a limited initial cost.",
  "rwDBoG": "Maximum loss: the premium paid.\nMaximum profit: theoretically unlimited, because the stock price has no fixed upper limit.",
  "IyaEgY": "A rising stock price and rising implied volatility generally help.\nTime passing generally hurts, with other factors unchanged.",
  "uPBmvR": "Getting the direction right may still lose money. The breakeven shown is for expiration; selling earlier also depends on remaining time and implied volatility. Holding through expiration can lead to automatic exercise.",
  "jNSorb": "Pay a premium to buy one put option.",
  "lKVEtl": "Expect the stock to fall before expiration, or use the put to protect an existing stock position.",
  "Gc747z": "The option can lose the entire premium paid. Its maximum profit is the strike minus premium, reached if the stock is zero at expiration.",
  "bIljXn": "A falling stock price and rising implied volatility generally help.\nTime passing generally hurts, with other factors unchanged.",
  "24hlLf": "A small stock-price fall may not cover the premium and time decay. Expiration breakeven is not a fixed exit price before expiration; holding through expiration can lead to automatic exercise.",
  "b5YD3k": "Sell one call without holding stock or another option to cover it.",
  "yLW76h": "Expect the stock to stay below the strike at expiration and keep the premium received.",
  "TVMAmL": "Maximum profit is the premium received. Loss is theoretically unlimited if the stock keeps rising.",
  "qsF360": "A rising stock price or rising implied volatility generally hurts.\nTime passing generally helps, with other factors unchanged.",
  "uGtd+R": "Receiving premium does not mean the trade is profitable. An American-style short call can be assigned early, creating a stock-delivery obligation; margin requirements can rise.",
  "bSYvdv": "Sell one put and take the obligation to buy the underlying if assigned.",
  "n5QwNC": "Expect the stock to stay above the strike at expiration and keep the premium received.",
  "vlCgJW": "Maximum profit is the premium received. If the stock falls to zero, the loss is the strike minus premium per underlying unit.",
  "5SdyRu": "A falling stock price or rising implied volatility generally hurts.\nTime passing generally helps, with other factors unchanged.",
  "kNOKbq": "Assignment can require buying stock well above its market price. Margin is not the maximum loss; calling the position cash secured requires reserving the purchase cash.",
  "YBC5VF": "Short Iron Condor",
  "rn+3KN": "Long Iron Condor",
  "PhNAow": "{name} ({index})",
  "ttXUMO": "小红书",
  "Gfix8D": "B站",
  "zuA3Bg": "YouTube",
  "39PtLD": "Instagram",
  "TFfDPW": "Prospect",
  "6O9OMe": "Contacted",
  "C2iTEH": "Paused",
  "TP/cMX": "Ended",
  "vfdQ6k": "Why options aren't gambling",
  "VbqhS7": "What 'theta' actually means in 90 seconds",
  "/FswN9": "Calls vs puts, explained without jargon",
  "xClpEB": "Why option prices move when the stock doesn't",
  "LgaCIc": "The one risk metric every beginner should know",
  "32iyB5": "What 'in the money' really means",
  "Qms25m": "Why most beginners lose money on options",
  "MDXUo6": "The cheapest mistake new options traders make",
  "++eaNE": "Vertical spreads, in plain English",
  "tfmZ+h": "Why selling premium is not 'free money'",
  "cQzGhs": "Iron condors aren't actually safe — here's why",
  "RTPYk4": "How to read a payoff diagram in 30 seconds",
  "sAImSf": "The hidden cost of legging into a spread",
  "WKFSmd": "When to take profit on a credit spread",
  "tbwHsB": "Why gamma matters more than delta near expiry",
  "bddbJz": "The case for and against 0DTE",
  "EhDe6R": "Vega risk: the Greek nobody respects",
  "rxQ8ka": "Why your iron fly works in low VIX and dies in high VIX",
  "NknKSL": "Pin risk on expiration, demystified",
  "PbMXwi": "Reading the term structure of volatility",
  "XZssxz": "When the skew tells you something the price doesn't",
  "f+tUCU": "How dealer hedging shapes intraday SPX moves",
  "FJyeyH": "Why theta decay isn't linear",
  "cNp5pS": "The math behind expected move vs implied move",
  "xkFLHQ": "Portfolio gamma exposure in a multi-leg book",
  "EAkPNG": "Calendar spreads as a pure vega trade",
  "1DKyjw": "When ratio spreads beat verticals",
  "Nfl8Ww": "Skew arbitrage: what retail can and can't do",
  "KBZGGd": "Building a delta-neutral book that survives a gap",
  "+ow4kj": "The hidden tail risk in short-premium structures",
  "iHFKZ/": "Why your Sharpe lies on theta strategies",
  "R7dsI0": "Margin efficiency across structures, ranked",
  "2ARw45": "How to read the ABG payoff curve",
  "AcQXvH": "Why we built the joystick instead of strike inputs",
  "r631Xy": "Generating an iron fly in 10 seconds with ABG",
  "kgHEuy": "How ABG's analytics page helps you size positions",
  "lvuX8f": "Setting smart alerts that actually fire",
  "aWcWRL": "Walking through a backtest on ABG",
  "4q53kx": "How to use ABG's regime detection",
  "/4MjPl": "The fastest way to plan tomorrow's trade in ABG",
  "KSuw4M": "Options are about structure, not prediction",
  "5AoqPb": "Why most options content on the internet is bad",
  "pbAG1O": "The single chart every options trader should learn to read",
  "4L8JL7": "What 0DTE actually does to your risk",
  "0VkRie": "The strategy nobody teaches but everyone trades",
  "Zh7IP2": "Why VIX doesn't tell you what you think it does",
  "hDH2vx": "How traders actually think about risk",
  "5sQXbo": "The myth of 'safe' option strategies",
  "hrh0Gw": "[a specific post you wrote]",
  "C0w/rb": "your-handle",
  "9Bdywh": "For creators you already know",
  "2nQgvn": "Hi {name},\n\nI have been following you on {platform} and enjoyed your post about {topic}.\n\nI am working with ABG ONE, an options strategy and backtesting tool. Would you be interested in a creator partnership?\n\nYou and your fans can subscribe for $98/year instead of $168. Your referral link is getabg.one/{slug}, and qualifying fan purchases earn you {commission}% commission. Self-purchases and refunded orders do not earn commission.\n\nHappy to share more details if you are interested!",
  "MR6Iqp": "Detailed",
  "f+Y10W": "For a more formal introduction",
  "+TPulf": "Hi {name},\n\nI am @abg_one and also create content about US stocks and options. Your post about {topic} caught my attention.\n\nABG ONE is an options strategy and backtesting tool, and we are inviting creators on {platform} to partner with us.\n\nThe partnership includes:\n1. A $98 annual subscription price for both you and your fans, compared with the regular $168. Membership is purchased separately.\n2. Your own referral link: getabg.one/{slug}.\n3. {commission}% commission on qualifying fan purchases. Self-purchases and refunded orders do not earn commission.\n4. A dashboard to track conversions, commissions, and payouts.\n\nWe welcome honest feedback and authentic content. If you are interested, I can share the product demo and partnership details.\n\nLooking forward to hearing from you!",
  "++CQB/": "Casual",
  "eCJ2h8": "For a lighter first approach",
  "TlSuVf": "Hi {name}!\n\nI also create content about US stocks and options, and enjoyed your post about {topic}.\n\nWould you be interested in partnering with ABG ONE, an options strategy and backtesting tool? You and your fans get the $98 annual price instead of $168. Qualifying fan purchases through getabg.one/{slug} earn you {commission}% commission; self-purchases and refunds are excluded.\n\nHappy to send details if you are interested!",
  "Neixc3": "Quarter",
  "cEkPVx": "Monthly add",
  "uT4OlP": "Fee",
  "Mu4Zak": "Current amount",
  "SRhWkB": "Principal",
  "KU8hIn": "Daily profit",
  "Fp0TV5": "Daily %",
  "4l5eSH": "Annual %",
  "tA69X4": "Upside annual %",
  "9v+Ku+": "Stress annual %",
  "AwzkSM": "Tax",
  "ACdOVs": "Daily rate",
  "viJDaR": "Annual rate",
  "KPNNwC": "Principal × (1 + daily %) ^ days = result",
  "ZAcA/p": "Current amount + daily profit × days = result",
  "oFGEHX": "Principal × risk return range ^ years = stress to upside",
  "oBtvL1": "Monthly compounding + monthly adds - tax on gains - fee drag = account balance",
  "/dghlY": "Daily amount",
  "gBDHc8": "Preference",
  "JKwQVq": "Full plan",
  "qfphmq": "Account balance",
  "4sbRjG": "Estimated total",
  "111iCD": "Compounded result",
  "IaE50n": "Capital",
  "rzbYbE": "Target",
  "Pru4XK": "Growth pace",
  "d57f4E": "year",
  "TxzXTj": "Target balance",
  "g+82aF": "Low case",
  "HW6TEk": "High case",
  "B7hDsY": "Spread",
  "B1W/gW": "Total invested",
  "EtNEo8": "Taxes and fees",
  "DuPR6M": "Added total",
  "otpFqZ": "Simple growth",
  "jIQfri": "Compound lift",
  "SHVbsj": "Daily return rate",
  "tvJaK7": "Daily profit amount",
  "4dL5F5": "Starting principal",
  "zbSUYV": "per day",
  "ZxJs61": "Plan completed",
  "3KPDRD": "Plan progress",
  "NiE9MV": "{count} times remaining",
  "KSQJ7U": "times",
  "2wHwuR": "Current profit",
  "E/Kkr0": "Complete this step",
  "YuCFAO": "Day {count}",
  "uurNRY": "Completed {count} times",
  "RGAAlJ": "Amount after {count} days",
  "VTuB5J": "Target profit",
  "UieAfL": "Target return",
  "IMf/rJ": "Cumulative return",
  "5GX1/c": "/ day",
  "DlhY7e": "Projected balance",
  "PVfXey": "Update current target",
  "UyGvrt": "Toggle formula and details",
  "vubFDg": "Formula and details",
  "ZBALng": "Current plan",
  "wut5a4": "Set the amount, choose a return range, and review the outcome below.",
  "TwULfc": "Fill in your contribution plan, growth pace, and drag assumptions.",
  "gQDjJL": "Enter the core inputs below and read the result in the review panel.",
  "LmULx9": "Conservative",
  "r0q/a1": "Balanced",
  "qMN4Hi": "Risk range",
  "Gv2IsN": "Capital base",
  "ZqD/9m": "1. Invest",
  "EwwhwW": "Set the starting amount and your recurring add.",
  "NroCc6": "2. Grow",
  "4nDMs1": "Choose the return assumption and the time window.",
  "HC8xUj": "Friction",
  "3uZSpt": "3. Subtract drag",
  "j7hpnr": "Adjust for taxes and annual costs that slow compounding.",
  "26J+tl": "Real result",
  "Acu9vt": "4. Real result",
  "Ptd9Fx": "Projected account value after monthly adds, growth, taxes, and fees.",
  "1pAREv": "Future value after the chosen period.",
  "WNOZk6": "Total gain and compound lift versus simple growth.",
  "0oSfpG": "Compound adds",
  "cZKGLj": "Expected range",
  "0Cfd9+": "Stress case to upside case over the selected period.",
  "w/Ei8V": "Contribution plan",
  "ZL6k3I": "Starting capital plus accumulated monthly additions.",
  "4Op0mv": "Ending value after growth, taxes, and fees.",
  "UpmMpb": "Estimated drag from annual costs and taxes on gains.",
  "eOjdJQ": "Result chart",
  "s/5n4U": "Future value",
  "huQbAJ": "versus simple addition",
  "WFbMvF": "Rate path",
  "TwpPGt": "Stress case",
  "KvvPIn": "Upside case",
  "UaUhfx": "Result breakdown",
  "qfpvhg": "Principal + accumulated monthly additions",
  "w/Fdf3": "Final amount including principal, additions, and net gain",
  "8dB4oX": "Friction drag",
  "zrtYq4": "Growth lost to taxes and fees",
  "xixtRJ": "Real result - total invested",
  "J13tmw": "Use the top keys to switch between Daily, Preference, Standard, and Advanced. Edit the cards directly to change each mode's values.",
  "p8z+Tw": "A long call option gives the holder which right?",
  "r8sXSe": "The right, but not the obligation, to buy the underlying at the strike price",
  "HkaKfs": "The obligation to buy the underlying at the strike price",
  "Zr7vSc": "The right, but not the obligation, to sell the underlying at the strike price",
  "XollnM": "The obligation to sell the underlying at the strike price",
  "R9pUXF": "A call holder controls a right to buy. The seller has the corresponding obligation if assigned.",
  "sJdEUc": "A long put option gives the holder which right?",
  "agCYGR": "A put holder controls a right to sell. The put writer may be assigned and required to buy.",
  "ieCW9m": "Which formula describes a call option's intrinsic value at expiration?",
  "4rXYGk": "max(underlying price - strike price, 0)",
  "yPJKRI": "max(strike price - underlying price, 0)",
  "qnRlaM": "option premium - time value",
  "Z6lbD7": "underlying price + strike price",
  "m5w98g": "A call is in the money when the underlying is above the strike. Intrinsic value cannot be negative.",
  "8dfXCg": "Which formula describes a put option's intrinsic value at expiration?",
  "N2iatI": "option premium + strike price",
  "dGAs0Q": "underlying price - option premium",
  "jHiKFs": "A put is in the money when the underlying is below the strike. Intrinsic value cannot be negative.",
  "Rw59/r": "Time value is best described as which part of an option price?",
  "Ti+nXJ": "The option premium above intrinsic value",
  "h/uehJ": "The guaranteed profit at expiration",
  "/YX34k": "The strike price minus the premium",
  "1PVBkn": "The broker's commission embedded in the quote",
  "TpxZ5h": "Option premium can be separated into intrinsic value and time value. Time value reflects remaining uncertainty.",
  "vNNLap": "What is the breakeven price for a long call at expiration?",
  "CoyymK": "strike price + premium paid",
  "xqBpsH": "strike price - premium paid",
  "sJnUwP": "premium paid - strike price",
  "Ywalns": "underlying price - strike price",
  "BpzpsR": "A long call must recover the premium paid before it breaks even at expiration.",
  "tVP8qh": "What is the breakeven price for a long put at expiration?",
  "Y6fpjX": "underlying price + premium paid",
  "RJ7S9H": "A long put needs the underlying to fall below strike by the amount of premium paid.",
  "6pa5qG": "An out-of-the-money option usually has how much intrinsic value?",
  "JaHxPk": "Zero",
  "CnZWCp": "Exactly half of its premium",
  "3IH3Jq": "Exactly equal to its time value",
  "xTYEBv": "A negative amount",
  "UYQuxJ": "Out-of-the-money options have no intrinsic value. Their premium is time value before expiration.",
  "3Qwa8k": "When is a call option in the money?",
  "IfsTgf": "When the underlying price is above the strike price",
  "Xs42k6": "When the underlying price is below the strike price",
  "J6ibgj": "When the premium is zero",
  "x7u1X5": "When the option has no time value",
  "O9KQTO": "A call has intrinsic value when the underlying can be bought below market through the strike.",
  "qBN9cZ": "When is a put option in the money?",
  "Ti7STP": "When the option has no bid",
  "+zVWjy": "When the contract is newly listed",
  "kBb73c": "A put has intrinsic value when the holder can sell above the current market price.",
  "Tp7dEM": "An at-the-money option is closest to which condition?",
  "mwTqo4": "The underlying price is near the strike price",
  "PBOT9O": "The option has already expired",
  "FGSuf7": "The option has no premium",
  "ZsUiHy": "The strike price is always zero",
  "hKIYh9": "At the money means the strike is near the current underlying price.",
  "YZoYNq": "What does option premium mean?",
  "yfDrxX": "The market price paid or received for the option contract",
  "/AzzHb": "The strike price of the option contract",
  "BC48si": "The number of shares controlled by a stock index",
  "4MaiPR": "The guaranteed profit from the trade",
  "K7A6D0": "Premium is the option's price. Buyers pay it and sellers receive it before commissions and fees.",
  "RepBfg": "For a standard listed U.S. equity option, one contract usually controls how many shares?",
  "9/svvE": "100 shares",
  "GhETif": "1 share",
  "Kd/ANn": "10 shares",
  "BEqlMW": "1,000 shares",
  "B2Iut+": "Most standard listed equity options use a 100-share multiplier, though adjusted contracts can differ.",
  "clggJl": "Expiration date is best described as what?",
  "C77WqZ": "The date after which the option no longer exists",
  "5Cl5zu": "The date the underlying company reports earnings",
  "t7jWOd": "The date the broker calculates commission",
  "T71nCJ": "The date the strike price changes automatically",
  "kCaz1M": "After expiration, the option contract either settles, is exercised, or expires worthless according to its terms.",
  "HPdXUB": "The strike price is the price at which what can happen?",
  "eNgunW": "The underlying can be bought or sold if the option is exercised",
  "Z6gXhL": "The option premium is always refunded",
  "TUeD3e": "The broker must close the position",
  "3uxbHc": "The stock exchange sets the daily high",
  "Sjyh8L": "The strike is the contract price used for buying or selling the underlying through exercise.",
  "4+TDij": "What is the maximum loss for a long call at expiration?",
  "SyoW8B": "Unlimited loss",
  "YPr9B9": "The strike price plus premium",
  "Y6YYOZ": "The full value of the underlying",
  "b5JlKo": "A long call buyer can choose not to exercise, so the expiration loss is limited to the premium paid.",
  "w6c5i+": "What is the maximum loss for a long put at expiration?",
  "Xc8e9a": "The strike price minus premium",
  "hpUY07": "The underlying price plus premium",
  "44cTu9": "A long put buyer's worst expiration outcome is losing the premium paid.",
  "Ngys84": "A naked short call has which general risk profile?",
  "rTaUGB": "Potentially unlimited loss if the underlying rises sharply",
  "FvZOHg": "Maximum loss limited to zero",
  "XjI0Pk": "No assignment risk",
  "nEmdKE": "Guaranteed profit if held to expiration",
  "TWW7Oi": "A short call can lose more as the underlying rises because the seller may have to deliver at the strike.",
  "uWAgVj": "A naked short put has which main downside risk?",
  "6CsUuc": "The underlying can fall far below the strike price",
  "RDn50X": "The underlying can rise without limit",
  "WNUkKD": "The option buyer can demand a higher strike",
  "iQnfc7": "The contract multiplier becomes negative",
  "ADqMdd": "A short put seller may be required to buy the underlying at the strike even after a large decline.",
  "dT5kOK": "At expiration, a long call's gross payoff is which formula?",
  "kL8Q1F": "premium paid + strike price",
  "Cu8vNz": "A call payoff equals the amount the underlying is above the strike, floored at zero.",
  "7GGV8d": "At expiration, a long put's gross payoff is which formula?",
  "zX1DZu": "A put payoff equals the amount the strike is above the underlying, floored at zero.",
  "wlcZrg": "For a long call at expiration, net profit equals payoff minus what?",
  "iOoylJ": "The strike price twice",
  "AP8plv": "The full underlying price",
  "x7s1VY": "The bid-ask midpoint",
  "EHo6Ch": "Net profit accounts for the initial premium paid to enter the long call.",
  "0YyldD": "For a long put at expiration, net profit equals payoff minus what?",
  "rdWKQa": "The strike price plus the underlying price",
  "NOGmHM": "The option's open interest",
  "rzJ2Xy": "The daily volume",
  "+6Ofbh": "A long put must first recover the premium paid before it becomes profitable.",
  "BgJVaU": "A call expires worthless when which condition holds?",
  "cOJzY8": "The underlying price is at or below the strike price",
  "bLJxN5": "The underlying price is above the strike price",
  "5C2N1y": "The option has high volume",
  "3wefRo": "The bid-ask spread is narrow",
  "ohKV2P": "At expiration, a call has no exercise value unless the underlying is above the strike.",
  "53yYGu": "A put expires worthless when which condition holds?",
  "iiBEKO": "The underlying price is at or above the strike price",
  "wSdEfs": "The underlying price is below the strike price",
  "p2F83m": "The option has high implied volatility",
  "c/A1XG": "The option has a wide spread",
  "YBt376": "At expiration, a put has no exercise value unless the underlying is below the strike.",
  "e43wLc": "All else equal, what usually happens to an option's time value as expiration approaches?",
  "kDFYMw": "It decreases",
  "L5H8ow": "It must increase",
  "qLMi7h": "It becomes intrinsic value automatically",
  "hg6x2F": "It becomes the strike price",
  "GMm0cm": "Time value generally decays as there is less time left for the underlying to move favorably.",
  "dAqB3D": "At expiration, how much time value remains in an option?",
  "4d+8xq": "The full premium",
  "OvMDdi": "The strike price",
  "HuCtj2": "The contract multiplier",
  "S3yPoo": "At expiration, option value is determined by settlement or exercise value, not remaining time.",
  "b5xmt5": "The bid-ask spread is best described as what?",
  "UHG779": "The difference between the highest buyer price and lowest seller price",
  "hv+B9s": "The difference between strike price and expiration date",
  "eCwOGr": "The guaranteed profit in a spread",
  "6yO8gD": "The difference between call value and put value",
  "zAsNJ6": "The spread is the gap between where buyers are bidding and sellers are offering.",
  "NmcAIp": "Why does option liquidity matter to a trader?",
  "MiOsQM": "Poor liquidity can make entries and exits more expensive",
  "8IDmAr": "Liquidity removes all market risk",
  "H+uHTE": "Liquidity guarantees exercise will be profitable",
  "xUCvdd": "Liquidity changes the contract multiplier",
  "Qs/n/d": "Thin markets often have wider spreads and less reliable fills, increasing trading costs.",
  "j4qTaw": "Open interest measures what?",
  "768IJv": "The number of outstanding option contracts that remain open",
  "Nd7Y1s": "The number of trades made today only",
  "GkiIvV": "The interest rate charged by the broker",
  "xemegc": "The dividend yield of the underlying",
  "ShPJI1": "Open interest counts contracts that have been opened and not yet closed, exercised, or expired.",
  "vXBXAG": "Option volume usually refers to what?",
  "SUreWy": "The number of contracts traded during a period",
  "GWBWSM": "The number of contracts still open after the close",
  "nSxIMl": "The option's theoretical value",
  "GB4Lc2": "The contract's expiration cycle",
  "BrBO26": "Volume measures trading activity over a period, while open interest measures remaining open contracts.",
  "F1tCF5": "American-style options can generally be exercised when?",
  "1yuI24": "Any time before expiration, subject to contract rules",
  "CmlUXG": "Only at expiration",
  "ospK6h": "Only after expiration",
  "xEzPH0": "Only when implied volatility is zero",
  "elS+KS": "American-style contracts allow exercise before expiration, unlike European-style contracts.",
  "RTeRHN": "European-style options can generally be exercised when?",
  "1aBcOs": "Any time before expiration",
  "+/2Tna": "Only when the option is out of the money",
  "yODrWj": "Only when the option has no time value",
  "z1/3iT": "European-style exercise is limited to expiration, though the option can usually be traded before then.",
  "J3eAog": "Physical settlement usually means what after exercise?",
  "yWo9Ua": "Shares or the underlying asset are delivered",
  "ZIzDA4": "Only cash is exchanged with no asset delivery",
  "wtRBX9": "The option premium is refunded",
  "NgX5uw": "The strike price is cancelled",
  "ybB05q": "Physical settlement involves delivery of the underlying asset according to the contract terms.",
  "9Vd+QF": "Cash settlement usually means what at settlement?",
  "37x8i6": "A cash amount is exchanged instead of delivering the underlying",
  "5nIIiF": "The trader receives the original premium back",
  "JhpE+3": "The broker cancels both sides of the trade",
  "VRYD01": "The option becomes a stock position automatically",
  "bqiAGH": "Cash-settled options settle the contract's value in cash rather than delivering shares or assets.",
  "+ahLiH": "Exercise means the option holder chooses to do what?",
  "RGw0yZ": "Use the contract right to buy or sell at the strike price",
  "hCAIUZ": "Cancel the option with no settlement",
  "3kh+qC": "Change the expiration date",
  "ZYgv4C": "Move the strike to the current market price",
  "pwdo85": "Exercise is the holder's use of the contractual right embedded in the option.",
  "I7PLbp": "Assignment means the option seller is required to do what?",
  "TG8G7H": "Fulfill the contract after the holder exercises",
  "EfPNmt": "Choose a new strike price",
  "LLCtP8": "Receive an extra premium from the exchange",
  "jMA3Zi": "Cancel the option before expiration",
  "841veV": "When assigned, the option writer must meet the obligation created by the exercised contract.",
  "EydITW": "Buy to open usually means what?",
  "bZlwHV": "Starting a new long option position",
  "xpdTft": "Closing an existing long option position",
  "ywaKmx": "Starting a new short stock position",
  "crTjjt": "Exercising an option immediately",
  "DFfu4e": "Buying to open creates a new long option position in the account.",
  "D6OAkA": "Sell to open usually means what?",
  "Y0A0qb": "Starting a new short option position",
  "CE+Eoj": "Closing an existing short option position",
  "/M93ZC": "Buying shares at the strike",
  "PL4f9b": "Exercising a long option",
  "qGW83/": "Selling to open creates a new short option position and receives premium.",
  "yq/XlX": "Buy to close usually means what?",
  "fHe8oK": "Opening a new long option position",
  "Rs1iDM": "Selling the underlying stock",
  "ObqPiG": "Changing the expiration date",
  "0B9BHp": "A trader buys to close when repurchasing an option previously sold short.",
  "vFfz58": "Sell to close usually means what?",
  "BLKWaJ": "Opening a new short option position",
  "YJuQS1": "Exercising the option",
  "/Zzlec": "Changing the strike price",
  "cykKhA": "A trader sells to close when exiting an option previously bought long.",
  "Y8PcCb": "A covered call combines which positions?",
  "Tn34f1": "Long shares and a short call on those shares",
  "APp8cC": "Short shares and a long call",
  "boyOAa": "Long call and long put",
  "dzctZl": "Short put and short call with no shares",
  "c3S530": "A covered call sells a call against shares already owned, creating an obligation to deliver shares if assigned.",
  "8OPAaL": "A protective put combines which positions?",
  "7GXP/5": "Long shares and a long put",
  "qFNwCA": "Short shares and a short put",
  "Kf09dC": "Long call and short call",
  "C8oOGb": "Short call and short put",
  "WWuZQB": "A protective put buys downside insurance for a stock position by owning a put.",
  "Q0iX3b": "A long call is usually a position with which directional view?",
  "3Gnlz+": "Always neutral",
  "1EZv+H": "Guaranteed income",
  "RnEtR7": "A long call benefits from the underlying rising enough to overcome the premium paid.",
  "WfBG0m": "A long put is usually a position with which directional view?",
  "0YlJY1": "A long put benefits from the underlying falling enough to overcome the premium paid.",
  "rJM0Wu": "Why is selling an option not the same as guaranteed income?",
  "a3b9cf": "The seller receives premium but may take losses or be assigned",
  "g5eG1n": "The seller never receives premium",
  "kk0AVY": "The buyer controls the seller's account",
  "WHcvjM": "The exchange removes all risk at expiration",
  "3tnEte": "Short option premium is compensation for taking obligation and market risk.",
  "jXrO2P": "Moneyness compares which two things?",
  "9S9hwM": "The underlying price and the option strike price",
  "17032Z": "The bid price and the account balance",
  "VwB7WH": "The contract multiplier and the dividend",
  "5ODy6v": "The broker commission and the exchange fee",
  "n8NiHi": "Moneyness describes where the strike sits relative to the underlying price.",
  "ng2Y6N": "Extrinsic value is another common name for what?",
  "EfrHOZ": "Strike value",
  "Zc8tAA": "Exercise value only",
  "fVRHYD": "Contract multiplier",
  "kNkUyn": "Extrinsic value is the portion of premium beyond intrinsic value, often called time value.",
  "l1Ukf+": "A long call is profitable at expiration when the underlying is above which level?",
  "LJ+XFd": "Strike price plus premium paid",
  "tlDaL8": "Strike price minus premium paid",
  "YzOKq/": "Premium paid minus strike price",
  "7439tP": "A long call must finish above strike plus premium to have positive net profit at expiration.",
  "ysfN1k": "A long put is profitable at expiration when the underlying is below which level?",
  "UTCGT1": "Premium paid plus underlying price",
  "Yf/9eb": "The call strike",
  "8s1+iH": "A long put needs the underlying below strike minus premium to show positive net profit.",
  "COgKc1": "Delta primarily measures sensitivity to which input?",
  "4WAtON": "A change in the underlying price",
  "caFyNW": "A change in implied volatility",
  "FHIYXU": "A change in interest rates",
  "cmAzyy": "A change in bid-ask spread",
  "1ZD3kZ": "Delta estimates how much an option price changes for a small move in the underlying.",
  "9I3PrQ": "Gamma is best described as what?",
  "oy9NPC": "The rate of change of delta as the underlying price changes",
  "c3vJfx": "The rate of change of vega as implied volatility changes",
  "PSrNLJ": "The daily interest earned on option collateral",
  "tPPotT": "The difference between bid and ask prices",
  "kx4aCp": "Gamma describes curvature: how quickly delta changes as the underlying moves.",
  "5IX97R": "Theta most directly describes which effect?",
  "ryGLHF": "Time decay in an option's theoretical value",
  "XJRqxA": "Price sensitivity to a dividend",
  "wSue2S": "The probability of assignment",
  "hvAy+w": "The size of the contract multiplier",
  "wcdDPf": "Theta estimates the effect of time passing, with other pricing inputs held constant.",
  "7LGFvM": "Vega primarily measures sensitivity to which input?",
  "0ZglLj": "Time to expiration",
  "TJl38p": "Contract size",
  "MeYCX7": "Vega estimates how much an option's value changes when implied volatility changes.",
  "MDmbC7": "What is the cleanest distinction between implied and historical volatility?",
  "ycgvyV": "Implied volatility comes from option prices; historical volatility comes from past underlying moves",
  "AwqM5+": "Implied volatility is always lower than historical volatility",
  "OmeRsw": "Historical volatility is only used for futures, not options",
  "3sWwQ+": "They are two names for the same measurement",
  "FTuly1": "Implied volatility is forward-looking through option prices. Historical volatility is measured from realized past movement.",
  "yNsoVb": "Buying a call and selling another call with a higher strike in the same expiration creates which structure?",
  "5XyIqv": "Short calendar spread",
  "qpsFdn": "A bull call spread is a defined-risk bullish debit spread built with calls.",
  "bAnfSm": "A long straddle is usually built from which two legs?",
  "d1iX2n": "Long call and long put at the same strike and expiration",
  "fLmCbB": "Short call and short put at different expirations",
  "gcgmMM": "Long stock and short call",
  "uroA9V": "Long call and short higher-strike call",
  "AGixtS": "A long straddle owns both a call and a put at the same strike and expiration.",
  "KZHvVd": "Assignment applies most directly to which side of an option contract?",
  "WPKPiC": "The option writer with a short option position",
  "+x9iMv": "Only the option holder with a long option position",
  "PP/pAf": "Only market makers",
  "Hvnx3M": "Only expired out-of-the-money options",
  "GFl3KB": "Assignment is the process by which an option writer is required to fulfill the contract after exercise.",
  "KRpgBP": "Why can some short option positions require margin?",
  "kRwhsx": "Because the writer may have future obligations if assigned",
  "16CiFP": "Because long options always need borrowed money",
  "e/kRj/": "Because option premium is paid after expiration",
  "dc+YqR": "Because all spreads have unlimited loss",
  "2W3NCs": "Short options can create obligations, so brokers require capital to support potential losses or assignment.",
  "/a7j5A": "Rho primarily measures sensitivity to which input?",
  "IcDFf2": "Interest rates",
  "r2LgCB": "Bid-ask spread",
  "3DEilM": "Rho estimates how much an option's theoretical value changes when interest rates change.",
  "jFD4af": "A long call usually has what sign of delta?",
  "n0F8fC": "Positive delta",
  "Xs65bh": "Negative delta",
  "cNFThY": "Always zero delta",
  "7gI2Ek": "Delta equal to theta",
  "peYBSh": "A long call generally gains value when the underlying rises, so its delta is positive.",
  "U30ERY": "A long put usually has what sign of delta?",
  "KYqe+l": "Delta equal to vega",
  "ZEkBWN": "A long put generally gains value when the underlying falls, so its delta is negative.",
  "+9uuuM": "Delta hedging is mainly intended to reduce exposure to what?",
  "E1x89U": "Small moves in the underlying price",
  "EY2kaG": "Broker commission changes",
  "dayF6u": "Contract symbol changes",
  "RrKmFd": "Open interest reporting",
  "sEgFYK": "Delta hedging offsets first-order directional exposure to the underlying.",
  "afu/QL": "A long option position generally has which gamma profile?",
  "CkWYrM": "Positive gamma",
  "Dh+xiJ": "Negative gamma",
  "MgmtFa": "No gamma in any market",
  "bS/GBJ": "Gamma equal to premium",
  "ZoyM6d": "Long options usually have positive gamma, meaning delta changes in a favorable convex direction.",
  "f3IDpn": "Why can short gamma become risky during fast markets?",
  "95fK5I": "Delta can move against the position as the underlying moves",
  "dlx1f5": "Premium cannot change after entry",
  "gqtE6q": "Assignment becomes impossible",
  "1JWmL9": "The strike price becomes floating",
  "yYZc3X": "Short gamma positions tend to become longer delta as price falls and shorter delta as price rises.",
  "T0NPAQ": "A long option usually has what sign of vega?",
  "x8sbnl": "Positive vega",
  "w78fOA": "Negative vega",
  "xHtuJc": "Always zero vega",
  "b+wP9P": "Vega equal to delta",
  "OuG7kA": "Long options generally benefit from higher implied volatility, so their vega is positive.",
  "C9BvsL": "A short option usually has what sign of vega?",
  "lBKrnB": "Vega equal to theta",
  "6OHayQ": "Short options generally lose when implied volatility rises, so their vega is negative.",
  "ofGelD": "A long option usually has what sign of theta?",
  "64tTyu": "Negative theta",
  "u8XLVe": "Positive theta",
  "ogdhAp": "Always zero theta",
  "S0X4cf": "Theta equal to strike price",
  "bM6T5S": "Long options usually lose time value as days pass, so theta is typically negative.",
  "M9E0ER": "A short option usually has what sign of theta?",
  "y6L4pE": "Theta equal to implied volatility",
  "FZdKH7": "Short options generally benefit from time decay, though they still carry other risks.",
  "DwZEtc": "Option delta is sometimes used as a rough proxy for what?",
  "4JTSBL": "Probability of expiring in the money",
  "dCErPf": "The exact final settlement price",
  "Zukr+I": "The broker's margin requirement",
  "hH57cv": "The option's daily volume",
  "OoTF3O": "Delta can be a rough probability proxy, but it is not an exact probability forecast.",
  "vgo0jI": "Implied volatility rank is commonly used to compare what?",
  "n0ggZo": "Current implied volatility against its own historical range",
  "yN1gN3": "Current stock price against book value",
  "4D742N": "Option volume against open interest only",
  "Ou3zSv": "Strike price against contract multiplier",
  "lAZkC+": "IV rank places current implied volatility within a lookback range for that underlying.",
  "8/nclW": "Implied volatility percentile usually asks which question?",
  "mOWk/k": "How often implied volatility was below the current level",
  "ZcFS/L": "How often the stock closed above the strike",
  "iY4GHj": "How many contracts traded today",
  "1UQKTy": "How much margin the broker requires",
  "vszNIh": "IV percentile compares the current IV level with past observations over a lookback period.",
  "NCqXTL": "All else equal, implied volatility expansion helps which position most directly?",
  "JmZiug": "A long option position",
  "YmLPQb": "A short option position",
  "aFDhJ0": "A fully expired option",
  "MpC5jH": "A closed position",
  "vynC+/": "Higher implied volatility raises option theoretical value, benefiting positive-vega positions.",
  "Wdt3Jf": "An implied volatility crush usually hurts which position most directly?",
  "4dpUAt": "A cash-only position",
  "S2EAyi": "An already expired option",
  "kVOmt7": "A sharp drop in implied volatility reduces option value and hurts positive-vega positions.",
  "7FuMn8": "Before an earnings announcement, options often price in what?",
  "ujMgYr": "Higher implied volatility because event uncertainty is elevated",
  "WBFwwx": "Zero implied volatility because the date is known",
  "GHdYbI": "No time value because earnings are scheduled",
  "bpfrwc": "Guaranteed profit for call buyers",
  "PaG51d": "Known event risk can lift implied volatility because traders expect a larger possible move.",
  "UdAOi6": "A short volatility trade generally benefits when realized volatility is what relative to implied volatility sold?",
  "Z8b6vU": "Lower than the implied volatility sold",
  "b72Oxc": "Always higher than the implied volatility sold",
  "g2zTeP": "Exactly equal to the stock dividend",
  "beL9QN": "Unrelated to option pricing",
  "leHwgD": "Short volatility positions tend to benefit when the market moves less than the volatility embedded in option prices.",
  "hvwXhU": "Buying a put and selling a lower-strike put in the same expiration creates which structure?",
  "88/1qU": "Short straddle",
  "TpF3k8": "Covered call",
  "jN4zaS": "A bear put spread is a defined-risk bearish debit spread built with puts.",
  "E7KyNL": "Selling a put and buying a lower-strike put in the same expiration creates which structure?",
  "uCiJ+Q": "Bull put spread",
  "lI+Atp": "Bear call spread",
  "FTeLyG": "Long strangle",
  "FX8s6M": "Protective put",
  "JiM3Ep": "A bull put spread is a defined-risk bullish credit spread using puts.",
  "3AaxyC": "Selling a call and buying a higher-strike call in the same expiration creates which structure?",
  "8Bpn3x": "Protective collar",
  "vixwQ/": "A bear call spread is a defined-risk bearish credit spread using calls.",
  "34X7Vg": "For a simple debit spread, maximum loss is usually what?",
  "RgXeg9": "The net debit paid",
  "hk3+pJ": "The width of the strikes plus the debit",
  "zQGNmX": "The option volume",
  "wOJ2WW": "A debit spread's maximum loss is generally the amount paid to enter the spread.",
  "OOKn2A": "For a simple credit spread, maximum profit is usually what?",
  "83qAyX": "The net credit received",
  "pwHZrr": "Unlimited profit",
  "9UwENq": "The full strike width plus credit",
  "YOlP23": "The underlying price",
  "NvgRjY": "A credit spread's best case is keeping the credit received when the short option expires favorably.",
  "TkQh4u": "For a vertical credit spread, maximum loss is generally what?",
  "VGn4tv": "Strike width minus net credit received",
  "7COobq": "Strike width plus net credit received",
  "eIrlu0": "Unlimited loss in all cases",
  "UbIjj/": "The premium received only",
  "36Q1z0": "The long option caps the spread risk, leaving strike width minus the credit as the maximum loss.",
  "cJQSIq": "For a vertical debit spread, maximum profit is generally what?",
  "tJqBAu": "Strike width minus net debit paid",
  "BhGWBE": "Strike width plus net debit paid",
  "cwuumt": "Unlimited profit in all cases",
  "m1OA/Z": "The short option caps the upside, so max profit is the strike width minus the debit.",
  "0KOSQH": "A long strangle is usually built from which legs?",
  "WGy8xN": "Long out-of-the-money call and long out-of-the-money put",
  "gk1rJJ": "Short stock and long stock",
  "ijUesj": "Short put and long lower-strike put",
  "6Ue4AM": "A long strangle buys a call and put at different strikes, seeking a large move.",
  "GwVm/e": "A short straddle is usually built from which legs?",
  "B3MQwB": "Short call and short put at the same strike and expiration",
  "m6PN/V": "Long call and long put at different strikes",
  "w4OdB2": "Long stock and long put",
  "Rl7+Qi": "Short stock and long call",
  "/9v2vp": "A short straddle sells both the call and put at the same strike and expiration.",
  "iWJX4g": "A short strangle is usually built from which legs?",
  "DQYzTY": "Short out-of-the-money call and short out-of-the-money put",
  "RSLXSy": "Long at-the-money call and long at-the-money put",
  "tWIYvx": "Long stock and short call only",
  "Bg5psP": "Two long calls at the same strike",
  "zU8atn": "A short strangle sells options on both sides and profits if the underlying stays within a range.",
  "B7e4T3": "An iron condor is best described as what?",
  "HAtdfg": "A defined-risk short call spread plus short put spread",
  "s9v3tL": "A long call paired with long stock",
  "bHeSh5": "A single deep-in-the-money call",
  "AArmAC": "A covered call with no put side",
  "znXFiW": "An iron condor combines two defined-risk credit spreads, one above and one below the market.",
  "3JyvM+": "An iron butterfly typically has what feature?",
  "LpkiaU": "A short call and short put at the same middle strike",
  "4CW4Yd": "Only one option leg",
  "TAtU5W": "No short options",
  "uwl7qd": "A stock position with no options",
  "vzxtMP": "An iron butterfly sells the body strike and buys wings for defined risk.",
  "O2DMWo": "A classic long call butterfly is usually most profitable when what happens?",
  "Vy1Ltg": "The underlying finishes near the middle strike",
  "GCkg5l": "The underlying moves far above all strikes",
  "4rdl9O": "The underlying moves far below all strikes",
  "HogBFY": "Implied volatility becomes irrelevant",
  "opGIcr": "A long butterfly targets a settlement near the body strike, with limited risk and limited reward.",
  "0WBPA8": "A calendar spread usually has which expiration setup?",
  "6RXa4Y": "Short near-term option and long later-term option",
  "meFXBc": "Two options with the same expiration only",
  "QTY65i": "Long stock and short stock",
  "PwLWjE": "A call and put with no expiration",
  "Fb8PWo": "Calendars use different expirations, commonly selling the near-term option and buying the later-term option.",
  "M5aG3N": "A covered call generally caps upside because of what?",
  "aKU3XC": "The short call can require selling shares at the strike",
  "qAmqet": "The long shares cannot rise in value",
  "o6o5kd": "The option has no expiration date",
  "X1iQ0j": "The premium paid is unlimited",
  "s1VZLN": "The short call creates an obligation to deliver shares at the strike, limiting gains above that level.",
  "0jOUAm": "A protective put is often used to create what?",
  "CvQuK2": "A downside floor for a long stock position",
  "lnGTux": "Unlimited income with no risk",
  "X1cYoo": "A guaranteed dividend",
  "nV0gCc": "A short volatility position with no hedge",
  "r0/4y2": "The put can gain value as the stock falls, helping limit downside below the strike after premium cost.",
  "QYjBxJ": "A collar commonly combines long stock with which option legs?",
  "3wTnEO": "Long put and short call",
  "dYfOYs": "Long call and short put",
  "/gYNMH": "Two short calls only",
  "vVn2yv": "Two long puts only",
  "WMSrKc": "A collar buys downside protection with a put and helps fund it by selling upside with a call.",
  "yUI8t9": "Why can defined-risk spreads require less margin than naked short options?",
  "ZFXLct": "A long option leg limits the worst-case loss",
  "+KJLRC": "Defined-risk spreads cannot lose money",
  "x2dmI/": "The broker ignores short options in spreads",
  "J+pJdR": "The contracts have no expiration",
  "uL2AzN": "The protective long leg caps potential loss, which can reduce margin compared with uncovered shorts.",
  "EsnbQC": "Buying power reduction most closely refers to what?",
  "6w6Hqu": "Capital reserved by the broker to support a position",
  "t7zp95": "The daily trading volume",
  "Ss28Pf": "The option's theoretical delta",
  "oRlS0o": "Brokers reserve buying power or margin to cover potential risk in open positions.",
  "+EMU6D": "Early assignment can happen before expiration mainly for which style of option?",
  "lTNQVQ": "American-style options",
  "vX200h": "European-style options",
  "pxnuWq": "Expired options only",
  "XJcWwO": "Cash positions only",
  "38sh7h": "American-style options can be exercised before expiration, creating early assignment risk for shorts.",
  "wm191e": "Pin risk is most associated with what situation near expiration?",
  "qEqYmZ": "The underlying settles near an option strike",
  "6ZhK1+": "The option has no strike price",
  "/8+Pge": "The market is closed for a holiday only",
  "llMdoM": "The contract multiplier is unknown",
  "+ONE39": "When the underlying is near a strike, final exercise and assignment outcomes can be uncertain.",
  "IXAcAR": "Before expiration, why might selling a long option be preferable to exercising it?",
  "w0YVxr": "Selling can preserve remaining extrinsic value",
  "T4W7CX": "Exercise always creates extra time value",
  "vo7LaV": "Selling removes all taxes and fees",
  "kWD3rE": "Exercise changes the strike price",
  "6+XRyA": "Exercising can forfeit remaining extrinsic value that could be captured by selling the option.",
  "FSzJTW": "Automatic exercise at expiration usually applies to options that are what?",
  "fenl6O": "In the money by at least the broker or clearing threshold",
  "RdEvOq": "Out of the money by any amount",
  "lb2Hbu": "Never traded during the day",
  "KsahwX": "Only listed on futures",
  "wEtR9e": "Clearing and broker rules commonly auto-exercise sufficiently in-the-money options unless contrary instructions apply.",
  "PBtxRb": "In a vertical spread, strike width directly affects what?",
  "T52zfb": "The maximum possible spread value at expiration",
  "JZSxeF": "The expiration date of the options",
  "pGw1RR": "The contract multiplier changing to one",
  "1WTiNc": "The underlying's dividend schedule",
  "nC/9u3": "The distance between strikes sets the maximum intrinsic value of a vertical spread.",
  "lbriQa": "An implied volatility surface organizes implied volatility across which dimensions?",
  "e+Pit9": "Strike or moneyness and time to expiration",
  "AIwt1N": "Only daily realized returns",
  "S2cbVG": "Only bid and ask size",
  "HV9hU2": "Only the option contract multiplier",
  "nSW/Id": "The volatility surface maps implied volatility across strike or moneyness and expiration.",
  "SCbIit": "Volatility skew most commonly refers to what?",
  "MefGGl": "Different implied volatilities across strikes for the same expiration",
  "Od/WwN": "A guaranteed rise in volatility before every expiration",
  "n6zDGH": "The difference between opening and closing stock prices",
  "8byjCe": "The interest rate used in Black-Scholes",
  "RtIEpC": "Skew describes how implied volatility varies by strike rather than staying flat.",
  "CxO+nV": "A standard calendar spread is usually built by combining which expirations?",
  "9j0U1y": "Shorter-dated option sold and longer-dated option bought at the same strike",
  "DmsiNM": "Two options with the same expiration and different strikes",
  "XAb+zP": "Long stock and a short call",
  "IFJW8p": "A call and put with different underlyings",
  "KIqGwC": "A calendar spread isolates term structure by using different expirations, often at the same strike.",
  "ASZDul": "What distinguishes a diagonal spread from a simple calendar spread?",
  "+z5UQl": "The legs usually differ by both expiration and strike",
  "19ARtf": "The legs must use different underlying symbols",
  "OdKxak": "The position cannot contain short options",
  "fEl9K7": "The position has no sensitivity to volatility",
  "LW6FCj": "Diagonals combine term structure and strike selection because the legs differ in expiration and strike.",
  "y46EiJ": "Gamma scalping is most closely related to which idea?",
  "k+cb83": "Rebalancing the underlying hedge as delta changes",
  "jcOcao": "Holding every option to expiration without adjustment",
  "Kbj+hp": "Ignoring delta because gamma is always zero",
  "gGUfus": "Selling only options with no bid-ask spread",
  "5n018Y": "Gamma scalping manages changing delta, often by trading the underlying against an option position.",
  "0FCKHz": "For a multi-leg options portfolio, which statement is most accurate?",
  "goAbTA": "Net Greeks and payoff shape can differ greatly from any single leg",
  "63JmCk": "Only the first leg determines portfolio risk",
  "iacmSU": "Defined-risk spreads can never lose money",
  "9/9anH": "A near-zero delta means the portfolio has no risk",
  "VIGkm7": "Portfolio risk comes from the combined legs. Delta, gamma, theta, vega, and payoff boundaries all matter.",
  "TR68QP": "Volatility term structure compares implied volatility across what?",
  "gak5Bg": "Different expirations",
  "cIoSuE": "Different broker commissions",
  "PGaGLZ": "Different account types",
  "Z2byKh": "Different contract multipliers",
  "w8q8hL": "Term structure describes how implied volatility differs across expiration dates.",
  "USuYeZ": "A short options position often has which gamma profile?",
  "bDmD7Y": "Always positive gamma",
  "P5wTCH": "Zero gamma at every price",
  "6sJqdF": "Gamma that only depends on dividends",
  "cY3bh1": "Short option positions commonly carry negative gamma, meaning delta can move against the position as price moves.",
  "RHy1ny": "Volatility surfaces are often modeled by moneyness relative to what?",
  "5GZUSU": "The forward price for that expiration",
  "EXqxRb": "Only the last trade price from yesterday",
  "yoUhxD": "Forward moneyness accounts for rates, dividends, and time to expiration when comparing strikes.",
  "v2QNgN": "A sticky-strike volatility assumption means implied volatility is held constant by what?",
  "Eh7FId": "The absolute strike",
  "bfNNYA": "The option delta",
  "jMMH6/": "The portfolio theta",
  "ytQfFB": "The broker account type",
  "vSg9wu": "Sticky strike assumes the implied volatility for a given strike stays fixed as the underlying moves.",
  "gsWgUT": "A sticky-delta volatility assumption means implied volatility is held constant by what?",
  "tNF18Z": "Option delta or moneyness",
  "n8B1fF": "Absolute strike only",
  "b7Ax4M": "Daily volume only",
  "u7POtj": "Assignment history only",
  "+bsObq": "Sticky delta assumes the volatility smile moves with the underlying so comparable deltas keep similar volatility.",
  "Ns/fbs": "A volatility smile describes which pattern?",
  "2Ok1jS": "Higher implied volatility away from at-the-money strikes",
  "/DpuvY": "Identical implied volatility at every strike and expiration",
  "yfGZFH": "Only higher volume at the opening bell",
  "9ol6R5": "A guaranteed rise in the underlying",
  "O2zRVQ": "A smile means options away from the center can trade at higher implied volatilities than at-the-money options.",
  "656mfu": "Skew steepening usually means what changed?",
  "qH/q9n": "The implied volatility difference between strikes became larger",
  "6O5HIP": "All strikes now have identical implied volatility",
  "OZbXDP": "Expiration dates disappeared from the chain",
  "OzFVy6": "Historical volatility stopped being measurable",
  "Mje8Et": "A steeper skew indicates a larger volatility premium for one part of the strike range versus another.",
  "rQSlOc": "Skew flattening usually means what changed?",
  "k0bFEq": "The implied volatility difference between strikes became smaller",
  "2ey2n3": "All option prices became zero",
  "atz+DJ": "The contract multiplier changed",
  "ZoDmBm": "The underlying stopped trading",
  "S1Nqzj": "A flatter skew means less relative volatility difference across strikes.",
  "pOPoq2": "Volatility term structure in contango usually means what?",
  "xQNyp/": "Longer-dated implied volatility is higher than shorter-dated implied volatility",
  "KggVBW": "Shorter-dated implied volatility is always higher than longer-dated implied volatility",
  "u5ZGpW": "All expirations have zero implied volatility",
  "ZkpbHu": "Only historical volatility matters",
  "HWNKbf": "Contango describes an upward-sloping term structure across expirations.",
  "sOFPg5": "Volatility term structure in backwardation usually means what?",
  "aFiMYP": "Shorter-dated implied volatility is higher than longer-dated implied volatility",
  "Af68l7": "Longer-dated implied volatility is always higher than shorter-dated implied volatility",
  "Hv5oCL": "All expirations have identical volume",
  "YbldLH": "Options cannot be exercised",
  "irnkwk": "Backwardation often appears when near-term event or stress risk is priced above longer-term volatility.",
  "N4WySM": "Event volatility is most directly isolated by comparing what?",
  "tWEPxa": "Expirations that include the event with expirations that do not",
  "LvOtjx": "Only the stock's daily volume and open interest",
  "UKl8Bz": "Only deep-in-the-money calls",
  "W0nhEV": "Only broker margin schedules",
  "SKmVHC": "Term structure around an event can reveal how much extra volatility the market assigns to that event window.",
  "C4yPeq": "Forward volatility attempts to estimate what?",
  "uoMXIM": "Implied volatility for a future time window between expirations",
  "39HTEF": "The next trade price with certainty",
  "tKvut+": "Only the current bid-ask spread",
  "jELa/t": "The exact assignment probability for a short option",
  "Ucg7r6": "Forward volatility backs out the volatility implied for a later interval from different expiration prices.",
  "2BQQb+": "Why do traders often work with variance rather than volatility across time?",
  "RLOl4Q": "Variance scales more naturally with time under common assumptions",
  "k/7TED": "Variance is always equal to option delta",
  "BH63dE": "Variance removes all jump risk",
  "IEseDZ": "Variance ignores expiration length",
  "AwVzBv": "Variance, or volatility squared, is commonly used because time aggregation is more tractable.",
  "q6BMMB": "The volatility risk premium generally refers to what?",
  "dk3MOr": "Implied volatility tending to exceed subsequent realized volatility over time",
  "6k4xN0": "Realized volatility always exceeding implied volatility every day",
  "Yu6PA7": "The broker paying traders for every option order",
  "qhrjcA": "The difference between bid and ask size only",
  "m/GQp3": "Option sellers often demand compensation for bearing volatility and jump risk, creating a volatility risk premium.",
  "uCFYgW": "Tail risk in an options portfolio refers to what?",
  "vPp9pg": "Low-probability but high-impact market moves",
  "mLNGpE": "The last trade printed before the close",
  "HA7wKp": "Only commissions on multi-leg orders",
  "Q+rqjl": "The smallest option position in the account",
  "WdIZQs": "Tail risk focuses on rare but severe outcomes that can dominate portfolio losses.",
  "2T9aeG": "Value at Risk is designed to estimate what?",
  "AxkBXx": "A loss threshold over a time horizon at a confidence level",
  "2Ikwwq": "The exact maximum possible loss in all scenarios",
  "gxirS2": "The option's intrinsic value only",
  "3IA2hm": "The broker's commission schedule",
  "T7dERO": "VaR summarizes a loss level over a horizon for a stated confidence, but it does not fully describe tail severity.",
  "yCaX3N": "A portfolio stress test is mainly used to do what?",
  "te5Wls": "Estimate outcomes under large market and volatility shocks",
  "eStEom": "Guarantee the next day's profit",
  "xIQ7a0": "Remove all assignment risk",
  "kH1ies": "Make every spread risk-free",
  "3gO41r": "Stress tests explore how positions might behave under adverse moves beyond ordinary day-to-day changes.",
  "l3f6px": "A scenario grid for options risk commonly varies which inputs?",
  "W7D/qL": "Underlying price, time, and implied volatility",
  "mksNg7": "Only the option symbol and broker name",
  "HNzYGL": "Only historical volume",
  "Mr8n8O": "Only the contract multiplier",
  "uzIXOW": "Options are path-sensitive to price, time, and volatility, so scenario grids often shock all three.",
  "3kGkyd": "Vanna is commonly associated with sensitivity involving which two variables?",
  "MiVd8E": "Delta and implied volatility",
  "HWsrDh": "Theta and broker commission",
  "ZvYTrg": "Open interest and volume",
  "x7hGvY": "Strike width and account type",
  "uzzd2f": "Vanna measures how delta changes with volatility, or equivalently how vega changes with the underlying.",
  "kCeVjX": "Volga, also called vomma, measures what?",
  "FnangZ": "The sensitivity of vega to changes in implied volatility",
  "HkaN+L": "The sensitivity of delta to time only",
  "dAFStF": "The number of contracts open in the market",
  "XawFKX": "The strike width of a spread",
  "1yPwep": "Volga describes curvature in volatility exposure as implied volatility changes.",
  "AMq1+1": "Charm is commonly described as what?",
  "z3LuDv": "The change in delta as time passes",
  "5czffg": "The change in volume as price changes",
  "W+nkIo": "The change in strike after assignment",
  "PW0Z3/": "The change in broker margin rules",
  "VohfEx": "Charm captures delta decay over time, which can matter for hedged option books.",
  "A2isno": "Color is commonly associated with what?",
  "+eFkZ0": "The change in gamma as time passes",
  "ZszidK": "The color of profit and loss charts",
  "+L1W7G": "The number of strikes in the chain",
  "xozMpA": "The bid color on a trading screen",
  "Dm8fFB": "Color describes how gamma changes over time, often relevant near expiration.",
  "sDxNs3": "A long gamma scalping approach generally benefits when realized movement is what?",
  "VbKG5a": "Large enough to overcome theta and trading costs",
  "lbTvfc": "Always exactly zero",
  "Nt90p6": "Unrelated to hedging frequency",
  "aOwdzt": "Lower than every commission charge",
  "LZ3gub": "Long gamma can monetize movement through rehedging, but gains must exceed theta decay and costs.",
  "oKMem8": "Increasing delta-hedging frequency usually increases sensitivity to what practical cost?",
  "YAiRQI": "Transaction costs and slippage",
  "Psv+rc": "The option's strike changing",
  "3jQnGW": "The expiration date moving farther away",
  "KZjZkq": "The contract multiplier becoming zero",
  "JhJsME": "Frequent hedging can better control delta but may create meaningful execution costs.",
  "oavf3n": "Discrete hedging risk arises because hedges are adjusted how?",
  "Uw6SQS": "At intervals rather than continuously",
  "kemNpN": "Only before the trade is opened",
  "zoIfar": "Without looking at the underlying",
  "gBGmJJ": "Real portfolios cannot hedge continuously, so jumps and moves between hedges create residual risk.",
  "LYlvi/": "Gap risk is especially important for which kind of position?",
  "4Ir4nk": "Short gamma positions exposed to large overnight moves",
  "UBul4S": "Closed positions with no exposure",
  "iLRwEA": "Cash balances only",
  "OKtP18": "Options that already expired worthless",
  "z6AYM8": "Short gamma positions can be hurt by large jumps that occur before hedges can be adjusted.",
  "w15zIh": "A typical long calendar spread often has which volatility exposure?",
  "zY3Per": "Positive exposure to longer-dated implied volatility",
  "Ug94jK": "No exposure to implied volatility",
  "YIu0zS": "Only exposure to stock dividends",
  "i8S0yK": "Unlimited negative delta by construction",
  "+MTmGS": "The longer-dated long option often gives a long calendar positive net vega, though details depend on strikes and expirations.",
  "kGigSK": "A calendar spread near the short strike often tries to benefit from what?",
  "XZI3/d": "Faster decay of the short near-term option",
  "YAr1Cf": "The long option expiring before the short option",
  "FDxp57": "The strike width becoming unlimited",
  "noqNi3": "The underlying being delivered immediately",
  "yEwJrm": "Calendars often sell faster-decaying near-term extrinsic value while holding later-term optionality.",
  "6Fg0VK": "A diagonal spread can combine term-structure exposure with what other exposure?",
  "jVhbR8": "Directional exposure from different strikes",
  "XA1jmW": "Guaranteed zero delta",
  "beDZNA": "No volatility sensitivity",
  "ASqjcy": "No expiration risk",
  "2WNAks": "Because diagonal legs differ by both strike and expiration, they can carry directional and term-structure views.",
  "rpUTBx": "A poor man's covered call usually replaces long shares with what?",
  "XT63n+": "A long deep-in-the-money longer-dated call",
  "93xqsr": "A short deep-in-the-money put only",
  "PPVgFg": "A long out-of-the-money put only",
  "bOfL2J": "A cash-settled futures contract only",
  "cZUno/": "The strategy uses a long-dated call as stock-like exposure and sells shorter-dated calls against it.",
  "c5Fdru": "A ratio spread generally means what?",
  "aGkO6x": "The number of long and short option contracts is unequal",
  "DyqJcF": "Every leg has the same quantity",
  "sCK+qZ": "The trade has no short options",
  "mFvWpN": "The trade has no expiration date",
  "iwObWw": "Ratio spreads use unequal quantities, which can create nonlinear and sometimes uncovered risk.",
  "JvyEhr": "A backspread typically buys more options than it sells to create what?",
  "ZP1p+O": "Long convexity in a large move",
  "4yZOoX": "A guaranteed flat payoff",
  "YrNBwZ": "No gamma exposure",
  "qt74a8": "A position with no premium risk",
  "7Tr77G": "Backspreads often seek convex payoff from large moves while financing part of the long options by selling fewer options.",
  "A26AIO": "A broken-wing butterfly differs from a regular butterfly because what is uneven?",
  "qMbHJW": "The distance between the body and the wings",
  "e25J2i": "The contract multiplier for each leg",
  "e3vo5H": "The underlying symbol for each leg",
  "yhAosc": "The expiration date must be missing",
  "yXAnxq": "Broken-wing butterflies shift one wing farther away, changing credit, debit, and tail risk.",
  "fnAXa1": "Wider wings in an iron condor generally do what?",
  "4KBowa": "Increase maximum risk if credit does not rise enough",
  "4kQloQ": "Eliminate all assignment risk",
  "44MBz6": "Make the position a long straddle",
  "u5KUx0": "Remove exposure to implied volatility",
  "wepiKG": "Wider defined-risk wings can increase loss potential unless compensated by enough additional credit.",
  "MilC9p": "Correlation risk in an options portfolio matters because what can happen?",
  "e5muMn": "Positions that seem diversified can lose together in stress",
  "ZUn1vO": "Every underlying always moves independently",
  "7eQhPP": "Correlation removes volatility risk",
  "JywElM": "Correlation only affects expired options",
  "+bpFO3": "During stress, correlations can rise and make positions behave more similarly than expected.",
  "ECCmtY": "Beta-weighting a portfolio is used to express risk relative to what?",
  "aQuBfn": "A benchmark or reference underlying",
  "XkPmaZ": "Only the account's cash balance",
  "F3ghc+": "Only the option's expiration date",
  "UM7yzj": "The number of symbols in the watchlist",
  "a5ymAE": "Beta-weighting translates different positions into approximate exposure to a chosen benchmark.",
  "s1vQiw": "Concentration risk means a portfolio is too dependent on what?",
  "1O7tJU": "A small number of underlyings, factors, or scenarios",
  "yqH1RL": "The existence of both calls and puts",
  "epL9to": "Having more than one expiration",
  "he90l+": "Using limit orders",
  "2th6dN": "Concentration can make losses larger when one theme, symbol, or scenario moves against the portfolio.",
  "MBjFhL": "Liquidity stress can affect options portfolios by doing what?",
  "Cbw5kX": "Widening spreads and making exits more expensive",
  "0e6alB": "Guaranteeing fills at theoretical value",
  "dPZjFU": "Removing the need for margin",
  "M6DTJZ": "Making Greeks constant",
  "bjrRD7": "In stress, liquidity can vanish, spreads can widen, and modeled exits may become unrealistic.",
  "g9PQad": "Model risk in options valuation means what?",
  "H8dNZQ": "The pricing model or assumptions may not match real market behavior",
  "n3UUdi": "The model guarantees fair value at all times",
  "uouIWl": "Only the chart color could be wrong",
  "T4YwLW": "The option has no market price",
  "N3WK6O": "Models simplify reality, so assumptions about volatility, rates, dividends, and jumps can create errors.",
  "acFF95": "Dividend assumptions matter most directly for which options risk?",
  "KLDlOf": "Pricing and early exercise decisions in equity options",
  "x/4Mfn": "The option symbol's font size",
  "P/iH+d": "The number of listed exchanges",
  "vmkkDf": "The account login method",
  "0XN5ZZ": "Expected dividends affect forwards, option values, and early exercise incentives for calls.",
  "ih9nnG": "Interest rates enter option pricing mainly through what concept?",
  "Uq1sQR": "Discounting and the forward price of the underlying",
  "hKuCay": "The bid color on the screen",
  "Lgqth2": "The number of market makers only",
  "4/tFCU": "Rates influence present value and forward pricing, which feed into option valuation.",
  "WzJoKx": "A local volatility model makes volatility a function of what?",
  "FbHQzx": "Underlying price and time",
  "4az1oG": "Only broker commission",
  "eJUAM6": "Only option volume",
  "OYeD6d": "Only account margin type",
  "LPGaNh": "Local volatility models fit a volatility function across price and time to match an implied surface.",
  "bdY4yG": "A stochastic volatility model treats volatility as what?",
  "6ApCTP": "A variable that can evolve randomly over time",
  "5Itx4M": "A fixed number that never changes",
  "z9Cymq": "The same as option volume",
  "q+Oaql": "The broker's margin rate",
  "6SL5Jw": "Stochastic volatility models allow volatility itself to move unpredictably.",
  "M11+ty": "Jump risk is difficult for delta hedging because what can happen?",
  "hi/Mz3": "The underlying can move discontinuously before the hedge is adjusted",
  "rT1kIc": "Delta becomes exactly zero for every option",
  "AhZMW/": "The option premium cannot change",
  "8m+I9O": "The strike price adjusts automatically",
  "QTDiDZ": "Delta hedges are local approximations and can fail when prices jump across a large range.",
  "5sSi1z": "Foundations required",
  "/RvHyr": "Intermediate required",
  "BFsH4+": "Read single-leg options and expiration payoffs clearly.",
  "UVYljC": "Call/Put",
  "JKh5wf": "Expiration payoff",
  "+yZUz6": "Covered/protective basics",
  "Dl50ts": "Concept boundaries",
  "DzUFFm": "Formula recognition",
  "7v6GTM": "Payoff direction",
  "a+mezc": "Connect Greeks, volatility, and common spread structures.",
  "45g521": "Vertical spreads",
  "yNMbw6": "Straddles/strangles",
  "lJK0aS": "Margin",
  "LJV4+Y": "Exercise/assignment",
  "+B3Di8": "Sensitivity logic",
  "mCeTg8": "Structure selection",
  "x6sYEM": "Risk source",
  "++1xV9": "Manage term structure, skew, dynamic hedging, and portfolio risk.",
  "PvNKew": "Calendar/diagonal",
  "xeBgEv": "Ratio/wing structures",
  "2JXtB+": "Gamma scalping",
  "cZpsC8": "Portfolio risk",
  "Y+YQZb": "Volatility regime",
  "EoQMlN": "Hedge tradeoff",
  "BvATNn": "Portfolio exposure",
  "3cc4Ct": "Light",
  "pPANfc": "Deep",
  "J9+DGS": "Could not load questions.",
  "0pZxwl": "No questions for this topic",
  "KV/9Hv": "Questions",
  "sizjHY": "Could not save progress.",
  "uJ61dq": "{count}-day streak",
  "4CymrY": "Redo missed",
  "vBWmSA": "Review mastered questions",
  "t4Yrhm": "Start quiz",
  "KxXYNo": "You have completed the available questions in this selection. Review what you learned or choose another topic.",
  "OBUa70": "Choose practice",
  "6NoIUl": "Correct",
  "Ypr9T5": "Incorrect",
  "aXluVt": "Previous question",
  "JKgNd/": "Answer skipped questions",
  "FIJzvZ": "{correct} correct out of {total}",
  "zmq2+1": "Redo full set",
  "Mc6JFr": "Next set",
  "wac8ex": "Daily Quiz",
  "ihIcdp": "{done}/{total}",
  "A1thHV": "No check-in yet",
  "4VYdh2": "Check-in summary",
  "uO5xca": "Stages",
  "u/fP3G": "Reinforcement practice",
  "+BqxXG": "Missed practice",
  "3Dw73J": "Boards",
  "kc79d3": "Topics",
  "DELZc+": "There are no questions in this selection yet. Choose another topic or level.",
  "OEGZQC": "{current} / {total}",
  "qp6UBO": "{answered} answered",
  "WEBo9C": "Change set",
  "nso3Mj": "Scope",
  "HoSM3S": "Next missed set",
  "85cyVg": "Move on",
  "U6vCLD": "{score}% correct",
  "ERJjcu": "{wrong} missed",
  "k0IMj5": "Missed questions cleared. Move on.",
  "t88s+R": "{correct}/{total}",
  "9gDH72": "Category performance chart",
  "sxNKiz": "Opening bell",
  "Piv8gA": "Master fisher",
  "oAuHBH": "Clean net",
  "/0eRJ0": "Still afloat",
  "z0DSW6": "Broken ropes",
  "+s81D7": "Wide range, steady theta, hates breakouts.",
  "kfzeF3": "Iron Condor Net",
  "indwML": "Directional net that catches upside drift.",
  "TCXaNi": "Call Spread Net",
  "LZCiFV": "Tight center net: big catch or quick damage.",
  "CiMCDO": "Straddle Scoop",
  "yNUS8n": "Small target, better when IV stays full.",
  "Ou7sWk": "Calendar Trap",
  "1Or9s1": "Options fishing game",
  "oF2poX": "Theta Nets",
  "0dywrZ": "Place an options net around the price river, advance the tape, and learn how premium, IV, width, and tail risk fight each other.",
  "JeBy61": "Catch",
  "T807D4": "Damage",
  "mLlOgJ": "Net score",
  "xLCZAR": "Streak",
  "VP5+CR": "Rank",
  "qukSCe": "Price river",
  "mXmvg2": "Expiry reached. Read the settlement card or cast again.",
  "fn/VCc": "Clean catch. Theta paid and the net held.",
  "+PnZg2": "Pressure hit the ropes. Re-center or widen the net.",
  "X7s0vF": "Cast a net, then step the market forward.",
  "xfYYJ1": "Step one day",
  "Vl02jc": "Pause auto step",
  "pgDoDR": "Auto step",
  "92HUDe": "IV tide",
  "V55xlZ": "Round",
  "5ir/Y+": "Last P&L",
  "dEYOLr": "Settlement card",
  "KFY7s2": "Your net survived expiry with positive edge.",
  "RWb9RL": "The river got through. Try a wider net or a new center.",
  "QJsFeW": "Cast again",
  "3efiQX": "Cast controls",
  "WdD6el": "Net center",
  "8UZS3K": "Net width",
  "0XM75I": "Premium fish",
  "OGauwX": "Caught when spot stays inside the net.",
  "2BqG3O": "Theta current",
  "TALHpe": "Pays more as expiry gets closer.",
  "bxTnXb": "High IV can feed calendars or tear short nets.",
  "pXra9p": "Rope stress",
  "xWc+eU": "Damage rises when price escapes the payoff zone.",
  "NOmhZm": "User blocked. You can manage blocked users from the Discover menu.",
  "U9geyY": "This profile could not be loaded.",
  "P4Uhwi": "Member since",
  "mrwfXX": "Shares",
  "ieGrWo": "Follow",
  "4j1TGZ": "Tip",
  "C69xts": "Could not update your follow. Please try again.",
  "uUy2wT": "Verify ownership of your public creator account. This badge does not verify your legal identity or financial qualifications and does not endorse your content.",
  "rNMiia": "Creator account verified",
  "VU8368": "Your creator badge and community publishing permissions are active. Membership pricing and professional licenses are not included.",
  "v7oUfK": "Prove account ownership",
  "czcSwN": "Add this verification code to the bio of the public profile you submitted. Keep it visible until an administrator completes the review.",
  "JdAFKw": "Your application is awaiting review. A submitted link alone does not establish ownership.",
  "XlBMzK": "Verification revoked",
  "ja7YtT": "Verification not approved",
  "J/vcCY": "Submit your public profile and one original content sample. We will generate a code for you to display on that profile. Do not upload identity documents or sensitive personal information.",
  "SkUbN6": "Creator display name",
  "YMkrg6": "Additional context (optional)",
  "BkN56Z": "Could not submit verification. Check your details and try again.",
  "lJhjLq": "Request verification code",
  "oeAC65": "Open workspace",
  "mWwUwa": "Start free. Go deeper when you need to.",
  "f8Wb2g": "From everyday learning and notes to deeper analysis and review.",
  "dz5v8V": "Free to use",
  "7bG1Ok": "A clear, simple workspace for your daily routine.",
  "Fg6Vy9": "$0",
  "zdZbzZ": "No subscription required",
  "KnaLVT": "Market calendar and reminders",
  "2oeacV": "Strategy library and contract editing",
  "v9/wMP": "Trading journal and performance records",
  "wQrXPf": "Options theory and practice",
  "xJVV/l": "Open 2.0 General",
  "PZ2Hhe": "More dimensions, more control, deeper analysis.",
  "A0liQK": "Everything in 2.0 General",
  "APU9rD": "You're subscribed to 3.0 Flagship.",
  "I54eeZ": "Invited by a friend · annual plan {price}",
  "GhZZxV": "Referral offer · annual plan {price}",
  "WeTNQc": "Subscribe now and lock in the offer",
  "mmafso": "Subscribe now",
  "IfDLmh": "Your selected plan",
  "tBA2++": "Get started with 2.0 General",
  "texxbY": "Create your free account. Your login PIN will arrive by email.",
  "dDHp0Z": "Choose monthly or annual above, then continue to secure checkout.",
  "FgfuL5": "Friend referral price is active for the annual plan.",
  "wKqcUW": "Creator member pricing is active for the annual plan.",
  "PUlPbH": "Subscribe · {price}/year",
  "LOFGac": "Subscribe · {price}/month",
  "7Xx8IX": "Continue to checkout",
  "ShH/MK": "Create free account",
  "3MPFV2": "Auto-renews at {price}/year. Cancel anytime.",
  "NScyeW": "Auto-renews at {price}/month. Cancel anytime.",
  "YrYFv7": "You already have a subscription. Manage it from Settings.",
  "sApwHs": "This email already has a subscription. Log in to manage it.",
  "dnb4vu": "Referral code {code} applied",
  "ZNFw12": "Change referral code",
  "eGxlvt": "Referral code",
  "1SvspN": "Checking...",
  "x2R8CB": "Invalid code",
  "4CNgZG": "Tools for reflection, not trade calls",
  "VKLw8l": "By continuing, you agree to our <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.",
  "6bKmjV": "Using",
  "CNxkz8": "By using",
  "Jm/KMV": ", you agree to follow these rules. If you don't agree, please don't use the app.",
  "g5q1wh": "2. What This App Does",
  "EEN/Vn": "is a learning and practice tool for options trading. You can build trading strategies, test them against past market data, and keep a journal of your trades. It is meant for learning and analysis only.",
  "FTczxz": "3. This Is Not Financial Advice",
  "gm0Inx": "We are not financial advisors. Nothing in this app is telling you to buy or sell anything. Everything here is for learning purposes only. Before you trade with real money, talk to a professional financial advisor.",
  "sRsiQ7": "4. Our Data May Not Be Perfect",
  "CVs9SW": "We try hard to show correct numbers, but we can't promise everything is 100% accurate. Market prices might be delayed. Past results from backtests don't mean you'll get the same results in the future.",
  "q+1zzm": "5. Trading Is Risky",
  "LPxSSb": "Options trading can lose you a lot of money — sometimes more than you put in. The strategies in this app are complex and risky. If you decide to trade for real, that is 100% your choice and your responsibility. We are not responsible for any money you lose.",
  "3x5OJy": "6. Your Account",
  "+y4k3A": "Keep your login PIN secret. Don't share it with anyone. If someone misuses your account, that's on you. We can close accounts that break these rules.",
  "82qcLQ": "7. Payments",
  "yfKeQP": "3.0 Flagship is a monthly or annual subscription. It renews automatically at the price you subscribed at until you cancel. Cancel anytime from Settings → Membership → Manage subscription: you won't be charged again, and you keep access until the end of the period you already paid for. Payments already made aren't refunded automatically; if something went wrong, reach out and we'll look at it case by case.",
  "f8QboS": "8. Don't Copy Our Stuff",
  "lL4yaz": "Everything in",
  "f3taff": " — the design, the code, the tools — belongs to us. You can't copy it, share it, or make something new from it without our written permission.",
  "PDibdd": "9. We Are Not Responsible for Losses",
  "nvUot6": "If something goes wrong — the app breaks, the data is wrong, or you lose money trading — we are not responsible. You use this app at your own risk.",
  "dJH5K0": "10. We Can Update These Rules",
  "cqyG0o": "We might change these rules from time to time. If you keep using the app after we change them, that means you agree to the new rules.",
  "MQhNBe": "Last updated: October 2026",
  "6n79hD": "Save your selection",
  "g7lrTa": "This temporary draft is no longer available. Return to Options Theory to start again.",
  "reycA5": "Your selection could not be saved. It is still available in this tab. Check your connection and workspace capacity, then retry.",
  "5R+Yvx": "Saving your selection…",
  "t+AQEb": "Back to Options Theory",
  "OGyLiW": "Adds downside risk",
  "T49dIJ": "Caps upside",
  "31vPJB": "Downside protection",
  "niMFMe": "Downside risk",
  "26HIAR": "Shape anchor",
  "oZrayB": "Upside above this strike",
  "WmUO79": "Upside cap",
  "BTV5BY": "Upside exposure",
  "50PPGB": "Favorable when price rises",
  "N+X4BT": "Unfavorable when price rises",
  "Eq+YDY": "Favorable when price falls",
  "U9gFEK": "Unfavorable when price falls",
  "PQTbS7": "Base setup",
  "UJqwvM": "Gap",
  "6uqwRP": "Likely credit structure",
  "HTKZ58": "Likely debit structure",
  "Y4kH1Y": "Mixed cost structure",
  "aGuQRr": "Near-flat cost example",
  "vbAobL": "Net credit example",
  "wdUpET": "Net debit example",
  "D1Uz5j": "Reach",
  "NaCRvw": "Upside optionality; theoretical gain has no upper limit",
  "cFt1IF": "Downside optionality; theoretical gain is large but capped",
  "8g7Ize": "Span",
  "JsYi24": "Target level",
  "bp32eT": "Find the peak, mark both breakevens, then watch value fade outside the target zone",
  "3Pe4bk": "Locate the main profit zone, then use breakevens and tail slopes to see where reward flips into risk",
  "VYqDD1": "Start with the center zone, then check the breakevens and the drop beyond the range",
  "PUhNdb": "This structure works best when price stays inside a defined area",
  "bd+L8a": "This structure turns a market view into a defined payoff with clear risk and reward",
  "1nQSHb": "A time spread uses two expiries to trade time decay around a target zone",
  "uv80fC": "This structure trades movement size or implied volatility, not just direction",
  "h+J769": "First ask whether the strategy wants expansion, compression, or a stall, then judge the move it needs",
  "POmYVs": "Current price",
  "aGDJAf": "Strike levels",
  "Cbb1Tl": "Underlying price axis",
  "pWLD9k": "Leg B/E",
  "xJndTG": "Strategy Shape",
  "xzpER/": "Leg breakdown",
  "hNQgV6": "Scenario value",
  "DmLT3x": "Strategy B/E",
  "sua8E+": "Valuation Evolution",
  "GUWKJj": "Current valuation P&L = current theoretical option value - entry cost",
  "3x2mRT": "Structure Evolution",
  "V1PxU5": "Expiry P&L = intrinsic value at expiry - entry cost",
  "sV4Od1": "Recognition",
  "/AElfC": "Surface",
  "rX4Xug": "This describes how price direction affects each leg. Overall profit or loss also depends on costs and the other legs.",
  "l9AsX1": "Evolution",
  "CoL84c": "Up {percent}%",
  "1nu76R": "Down {percent}%",
  "OPM0Uk": "Unchanged 0.00%",
  "G0oNDp": "Entry setup",
  "+j/nTL": "Near front expiry",
  "E51Zau": "Back-month residual",
  "rera5g": "Adjust spot, strikes, days remaining, and IV to see how the curves change.",
  "qV8zK8": "Simulated spot price",
  "qB7XvW": "Current price affects the breakeven and profit/loss zones",
  "tDBbJ0": "Moves the breakeven and P/L zones",
  "7sRl4n": "Changing the structure changes the payoff shape",
  "7Yr4un": "Changes the payoff shape",
  "2gNueF": "Front Decay",
  "Nbweyr": "Closer to expiry usually means less time value",
  "FoOT5b": "Closer expiry usually means less time value",
  "AP4HpE": "If the market expects bigger moves, options are usually pricier",
  "IAgODN": "Bigger expected moves usually mean pricier options",
  "sjVZ1y": "Flexible payoff",
  "eBQdu2": "Depends on the chosen structure",
  "WDg9jp": "Long volatility",
  "pI8lK1": "Short volatility",
  "is3xT4": "Range bearish",
  "vN5UMz": "Extreme volatility",
  "jd7vvb": "Range bullish",
  "LYaNlL": "Prev",
  "+pe1+p": "Teaching view for time spreads Open in editor to simulate the live front and back expiries",
  "vd1dvM": "More simulation, open in editor",
  "ff/mVe": "higher strike",
  "eRG040": "ITM call",
  "U4q1Cq": "ITM put",
  "G7WT4X": "lower strike",
  "QFyd0k": "OTM call",
  "i5jmd4": "OTM put",
  "3duexM": "K",
  "5R/3cy": "See which strikes the market prices richer",
  "d3F21T": "Main curve",
  "hOnZIP": "Neutral curve Smile reshapes wings Skew tilts sides",
  "TRMKTx": "ATM level (IV lifts option value)",
  "XbPGhw": "Judge whether options around ATM are rich or cheap",
  "YR5Qd7": "Smile strength (IV bends option value)",
  "0xWY3M": "Judge whether farther-from-ATM strikes are priced richer",
  "lQJZEc": "Skew bias (IV tilts option value)",
  "vEjvuR": "Judge whether the left side or right side is richer",
  "1rqEzD": "Your access has ended. Purchase access to continue.",
  "wdHd1F": "Too many attempts. Wait a minute and try again.",
  "X02lYY": "Login failed. Try again.",
  "OvkNAz": "Sign up free · 2.0 General",
  "td3oqq": "Already have an account? Log in with your PIN",
  "QXCiLH": "Forgot your PIN?",
  "Bo4x4i": "Too many email requests. Please wait before trying again.",
  "UEP7qP": "Unable to send your PIN. Please retry the verification.",
  "/N55ps": "By logging in, you agree to our <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.",
  "YrTaSr": "2.0",
  "kt44+R": "Enter 2.0",
  "duziu7": "General Edition",
  "xquvI8": "Enter 3.0",
  "yed+rm": "Discover Flagship",
  "++EEjI": "Flagship Edition",
  "aI0Hsl": "Login successful!",
  "affGSV": "Your workspace is ready.",
  "Ph6B7A": "Choose where you want to enter.",
  "cix1k0": "Strategy Center",
  "fJBWP+": "Shape, compare, and refine a working plan before or after review.",
  "2ObwR3": "Review decisions, reminders, notes, and outcomes across one timeline.",
  "HyXHxS": "Carry a plan forward, then keep tracking, reminders, and review inside one working desk.",
  "g9YA+g": "Allow session storage in this browser to keep your draft while you sign in.",
  "XTROyJ": "Complete the contract values and premiums before saving.",
  "jRMMXS": "This shared example is invalid. The default example is shown.",
  "1DH9Kx": "Strategy simulator",
  "5JCulU": "Reference price $500. All strikes and premiums are illustrative, not live quotes or a trade recommendation.",
  "GTGGea": "Explore the outcome",
  "7yaXGQ": "Enter valid contract values to calculate the outcome.",
  "lSGulb": "Breakeven prices at expiration",
  "vzQ5Hf": "No isolated breakeven price",
  "gvW2sZ": "Edit the contracts",
  "prLyDg": "Reset example",
  "RUr0KH": "Share scenario",
  "DkP//w": "Save this strategy",
  "X4f3ZX": "Save to your account and continue in your workspace.",
  "U6qGuO": "Position",
  "J0vUhO": "Track",
  "Px2xWV": "Open Position",
  "T6rVKC": "Create a position from the strategy editor snapshot.",
  "djNL6D": "Read-only",
  "Zgurtq": "Open Simulator",
  "HlljQp": "Tracked",
  "y4svrI": "Net entry",
  "VlqGUg": "No open positions yet.",
  "hKxqT+": "Opened Strategy",
  "Z/gq7D": "Manage Position",
  "mYAor4": "Position List",
  "GvvPSU": "Manage status and review recorded strategy snapshots.",
  "kp0NPF": "Planned",
  "PFtMy9": "Canceled",
  "fNSoEC": "No positions yet.",
  "r7nsaT": "Journal Library",
  "YDP1qm": "Strategies, discipline, and growth.",
  "BrM+Z3": "Notes, ideas, and references.",
  "dRXcgr": "Reading. Writing. Learning.",
  "SLMbdJ": "Book title",
  "ZLW3Ul": "Book description",
  "bwH2te": "Build a strategy",
  "orEaKq": "All types",
  "sVZZBm": "Multi-leg",
  "nNLJjQ": "Start in the simulator, save the structure, then positions and risk views stay attached to it here.",
  "Sf2BeB": "No positions yet",
  "+f9XbS": "Strategies in Build appear here once saved. Open a strategy's ••• menu in Build and choose Save or Watch.",
  "dhHjsg": "Quick open",
  "vjhtoP": "Search tickers",
  "z6/6z0": "No tickers match this search",
  "Gyxm/c": "No positions match these filters",
  "xN7WFk": "No saved strategies yet",
  "mAArDz": "No watched plans",
  "CfejBq": "No active positions",
  "c8EWLR": "No closed positions",
  "7j1Mgp": "No archived positions",
  "kIhdMY": "No hidden positions",
  "mLUgce": "Clear the search or change the filters to see more tickers.",
  "rutc7s": "Turn off a filter to see more positions.",
  "Nph2An": "Save a simulator structure to keep it available here.",
  "HNFYuR": "Watch a strategy when you want to follow it before opening.",
  "abznLW": "Activate a strategy when you want to track an open position.",
  "Cdgcco": "Positions appear here after you record their exit.",
  "bOaUqZ": "Archived positions stay in statistics and can be restored here.",
  "sO3Bze": "Hidden positions are excluded from statistics and can be restored here.",
  "bZdq0G": "Collapse all position details",
  "fOG9Tb": "Expand all position details",
  "b8P01l": "Remaining legs",
  "mPKS81": "Settle",
  "bz+S/R": "{count} active",
  "ikscQi": "Adjusted",
  "HnxG15": "Set",
  "it6Hed": "Since watch",
  "5YhudP": "Pending settlement",
  "+8P2r8": "View quick note",
  "Vhoe1W": "View reminder",
  "HJv0iT": "Analyze",
  "o6N36n": "Edit quick note",
  "0Bs6+z": "Edit reminder",
  "SyaPvp": "Unwatch",
  "eZSeUm": "Simulate",
  "ik14st": "Select leg",
  "EaG+NV": "Change {direction} color",
  "Hwkt6M": "Direction color",
  "Ob2IQq": "Use {color} for {direction}",
  "H1pTIh": "Custom color",
  "CSYtw1": "Priced",
  "hVxfnN": "Positions",
  "ThUvIL": "Hidden",
  "f6a7e/": "Settled",
  "Qgz2Vn": "Cumulative performance",
  "rbt2f5": "Current list",
  "OS3U7j": "Includes archived, excludes hidden",
  "QDIVBy": "{count} watching",
  "/qOQTh": "1 position",
  "A20+WU": "{count} positions",
  "SGxHBU": "{count} closed",
  "YjHnYx": "{count} archived",
  "mU7A0p": "{count} hidden",
  "QpLG3I": "{value} win rate",
  "Rwykbl": "Excluded from statistics",
  "M0AnzG": "{priced}/{total} priced",
  "mh3wPC": "Some positions are missing pricing data. Portfolio totals are withheld.",
  "//uGU4": "Hypothetical after expiry",
  "VMy/tf": "Time decay needs an unexpired position with option pricing.",
  "UGe/dl": "Waiting for quotes",
  "ShK4oL": "Actual realized",
  "VZKdlL": "If held now",
  "JiHVub": "Estimated P&L",
  "g8ZbQ5": "Estimated if held at expiry",
  "qo0qUR": "Est. expiry P&L",
  "7Jm7U6": "Original expiry",
  "GrjpeW": "Saved strategies use current market prices as the entry estimate.",
  "R61VBV": "Waiting for enough market data to calculate this payoff.",
  "Aj6ic0": "Mark",
  "fp1oz4": "Could not rename this strategy",
  "uxZZAv": "Rename strategy",
  "LVwPTo": "Change the name without changing its structure.",
  "T5INbY": "Could not archive this position",
  "zuox0y": "Could not restore this position",
  "YMmEiS": "Could not hide this position",
  "EneU0Y": "Archive this position?",
  "3+4hrG": "Restore this position?",
  "O9Sipg": "Hide this position?",
  "dugfnJ": "It will move to Archived and stay included in performance statistics. You can restore it later.",
  "vfMsL9": "This position will return to its original list.",
  "8mP0pJ": "It will move to Hidden and be excluded from performance statistics. You can restore it later.",
  "CfWiRl": "Archive position",
  "m2mTdA": "Confirm restore",
  "q8NSOn": "Hide position",
  "zVCv7s": "Could not delete this strategy",
  "YS4On5": "Could not permanently delete this position",
  "53EorX": "Permanently delete position?",
  "Vq5OSe": "Delete this template?",
  "EVMb+G": "This permanently deletes the position and removes it from all statistics. This cannot be undone.",
  "R46+3v": "Delete permanently",
  "YaaCeG": "Could not save this record",
  "QYSyb0": "Select the contract and confirm the opening fill.",
  "XdGPuT": "Underlying",
  "HKCOwy": "Entry time",
  "qgw8AH": "Cash flow",
  "D5lF77": "Add leg",
  "BP+63j": "Total cost",
  "lwsE+O": "Payoff shape",
  "bgusDi": "Confirm open",
  "soYk0t": "{count}-leg strategy",
  "KP3wT9": "Watch spot",
  "K0UL2X": "Watch premium",
  "FEmWwD": "Entry amount",
  "dsrYnm": "Entry legs",
  "NbxUGS": "Could not end this record",
  "ey6L2t": "Settle strategy",
  "PpsgXy": "End strategy",
  "tS9FPC": "Enter the realized P&L reported by your broker.",
  "1IEGYF": "Enter the official settlement value. Each leg is calculated automatically.",
  "NhmG6m": "Enter the underlying reference price to estimate exercise and assignment.",
  "GIxo6M": "Enter the actual net closing price. This does not place an order.",
  "yotyOA": "complete contract",
  "4NAQB9": "complete contracts",
  "OJUasc": "Cash settlement",
  "B2p6Bi": "Broker result",
  "0VNDuE": "Actual realized P&L",
  "V+qFDZ": "Official settlement value",
  "BUH8zP": "Underlying reference price",
  "Zr+XyS": "Net price / share",
  "QPsBe2": "Use the final amount from your broker statement",
  "G2Knv1": "Use the official settlement value, not the last quote shown in Monitor",
  "pMLhyY": "Used to estimate exercise and assignment",
  "eatQ+I": "Credit received / share",
  "WL6scr": "Debit paid / share",
  "6rix6a": "Per contract",
  "Ma8x1D": "Price × 100",
  "pQaa3l": "Close quantity",
  "i8OeMM": "Selected total",
  "2PKjNz": "Leg settlement",
  "y3j4Us": "Estimated outcome",
  "drqP2L": "Delivery",
  "4n3J7u": "Worthless",
  "0bRwOS": "Exercised",
  "iZDRGO": "Assigned",
  "871J/6": "Expired worthless",
  "beB5uE": "shares",
  "sjHccx": "Net settlement",
  "b3Xwdd": "Net share delivery",
  "MXoK1F": "Strike cash flow",
  "YTCJ+M": "Estimated economic P&L",
  "sPWQ7D": "Settle later",
  "yYCJE5": "Settle now",
  "Qfb5ZZ": "Could not close this leg",
  "6qZEsJ": "Close all or part of this leg. The other legs stay active.",
  "0BfMZB": "Open qty",
  "oz2JkI": "Closing price",
  "FAYrr7": "Cash received",
  "ekYUAx": "Cash paid",
  "2bfWlg": "Run historical tests and read the result in one focused flow.",
  "U7f4Pj": "Use historical context to pressure-test a route before carrying it onward.",
  "jAZBxq": "Continue a plan, check what needs attention, or open a working tool.",
  "Z0jnBj": "Archive · {year}",
  "hJ6EC5": "Historical year with archived positions, realized outcomes, and dated review notes.",
  "8JJ/KH": "Basis",
  "0VMZU5": "Debit avg $1.96",
  "TQaZmF": "48 closed trades",
  "+KgWt/": "5906 avg",
  "CHLuYQ": "-$28k",
  "mrOnjM": "Mode",
  "9w5c2P": "Archived directional book",
  "2dZYch": "+$11.2k",
  "649SQD": "Credit avg $1.08",
  "Tv3gzx": "Archived income book",
  "jK4np8": "+$2.1k",
  "mdxPio": "Calendar year {year}",
  "yABxM/": "Annual book · {year} archive",
  "avWSMa": "Archived years keep the same visual system, but the content is explicitly historical: realized outcomes, closed books, and past review paths.",
  "947I6g": "Cycle",
  "gSM0WL": "Year · {year}",
  "VmnY82": "The selected annual book.",
  "NGKqPT": "Debit avg $2.68",
  "ANQM1C": "Days in trade",
  "sYMLag": "Live + planned book",
  "zpv8jG": "5988 avg",
  "N/wcOE": "-$36k",
  "QJWHzz": "Next move",
  "k9bZQY": "Open current plan",
  "tAZ+YS": "Debit $2.80",
  "fddwUI": "Bull call ladder",
  "iSfLPg": "+$184",
  "RAhSDR": "Credit $1.34",
  "iesPLO": "Iron condor drift",
  "8ObPam": "-$42",
  "7qBnyG": "Debit $5.10",
  "v+DE/u": "Calendar repair",
  "IZFEUg": "Ready",
  "sbDnP2": "Annual book · current year",
  "y+C2aN": "The current year should unify everything: the live book, planned structures, and the review trail that explains how the book got here.",
  "wBpAA8": "Plan horizon · {year}",
  "Kv1dj0": "Future planning year with staged routes, projected structures, and no realized fills yet.",
  "KCfzO/": "Planned avg $3.04",
  "5Kx7yd": "Forward year",
  "B8EZ5K": "6054 avg",
  "GSahCH": "-$41k",
  "Vfvggz": "Plan horizon",
  "08b5tn": "Planned $3.20",
  "DqeRtW": "Ladder carry roadmap",
  "X4ZEP3": "Planned $1.42",
  "056NtU": "Income repair map",
  "W+J13o": "Annual book · {year} plan horizon",
  "hWeW8R": "Planning years should keep the same interface, but everything on stage should read as a route map: proposed exposure, projected timing, and future review anchors.",
  "3uGLNA": "No data · {year}",
  "P1SQsM": "Empty year range. No historical records or future plans are attached yet.",
  "thiOfy": "--",
  "UG5qoS": "No data",
  "cjO0aw": "No position data yet",
  "CNkoci": "Empty year",
  "Q2yxVw": "Annual book · {year} empty range",
  "uFQT3Y": "Empty years remain navigable in the same time system, but the content state is explicit: no live book, no archive, and no future plan attached yet.",
  "5aHLfb": "Q1",
  "t8QlFE": "January",
  "3mcx52": "Jan",
  "0TR0PD": "February",
  "lsI6+i": "Feb",
  "T5W0CV": "March",
  "Ntypeb": "Mar",
  "0Y/8yJ": "Q2",
  "h7xti1": "April",
  "vICE/x": "Apr",
  "zUpHdf": "May",
  "xBaHKe": "June",
  "040rfl": "Jun",
  "trR2dv": "Q3",
  "NGWumB": "July",
  "iPtQUl": "Jul",
  "lINtN6": "August",
  "2eQSom": "Aug",
  "TFf5u+": "September",
  "aV/c/P": "Sep",
  "gNixBN": "Q4",
  "EuK7yR": "October",
  "6Uae/q": "Oct",
  "pn+jQD": "November",
  "OOkYHt": "Nov",
  "SsiZK7": "December",
  "g7daoL": "Dec",
  "YA1Ydf": "days left",
  "k1oTSN": "weeks left",
  "wU87pu": "months left",
  "u26zQm": "trading days ago",
  "EpzWvP": "trading days left",
  "hYXp3+": "trading days until",
  "Yai4KM": "Month · {month}",
  "he6DvA": "Archived month inside {year}.",
  "mEqBuO": "Archived month",
  "0zFji5": "-$2.8k",
  "BQ4Nrb": "Archived avg $1.96",
  "ZHON+n": "Archived monthly book",
  "3Cpnbk": "+$880",
  "dxDfXh": "Monthly book · {month} archive",
  "U+VcDy": "Month, week, and day should all inherit the selected year baseline instead of behaving like separate timelines.",
  "CLPpG7": "Planned month inside {year}.",
  "ODrLpl": "Forward month",
  "SJycpz": "-$3.6k",
  "v1aogz": "Planned $3.04",
  "DTDjo3": "Monthly route map",
  "+tjG21": "Monthly book · {month} plan",
  "pUic6k": "After you choose a planning year, the month view should remain in that same annual frame rather than snapping back to the current live year.",
  "ZnW07R": "No monthly data inside {year}.",
  "1bDyQq": "Empty range",
  "k0mPiS": "No monthly data yet",
  "KOIMkh": "Empty month",
  "dVt6TW": "Monthly book · {month} empty",
  "sqll8V": "Month view should stay navigable even when a selected year has no content, because the time system still needs one continuous hierarchy.",
  "azA/mf": "Live frame",
  "RE27Wb": "Week {week}",
  "cA9+ey": "Week {week} inside {month} {year}.",
  "LsYasz": "Planned avg $2.84",
  "J7RKUv": "Debit avg $2.36",
  "SGcXj+": "7-day window",
  "G4D7FM": "Anchored to month",
  "NVKmtq": "Scoped to range",
  "FHJmd5": "Planned weekly map",
  "gcVGVu": "Anchored weekly read",
  "uFtAgz": "No weekly data yet",
  "1P516t": "Weekly range snapshot",
  "PxG3cX": "Scoped",
  "+RhnH+": "Empty",
  "E4+csi": "{month} {start} - {end}, {year}",
  "Xub7tu": "Weekly book · {month} week {week}",
  "6geTOm": "Once a month is selected, weekly navigation should read as that month’s internal breakdown instead of a disconnected recent-week carousel.",
  "To52hH": "Snapshot · {weekday}",
  "O0SopU": "{month} {day}, {year} snapshot.",
  "buUDsH": "Planned daily map",
  "fsuPbC": "Archived daily mark",
  "MFxZsc": "Daily scope",
  "Ny8bRn": "Single day",
  "mMFdJj": "Anchored to day",
  "kkZpF7": "Scoped to day",
  "wt4GvW": "Planned daily route",
  "fyqUlv": "Anchored daily read",
  "aTX7LJ": "1D",
  "qRAGY7": "No daily data yet",
  "E5Skre": "Planned position",
  "pbdPil": "Closed position",
  "ZaNKvA": "Open position",
  "rlkTbu": "{weekday} · {month} {day}, {year}",
  "SscrMt": "Daily book · {month} {day}",
  "ZBNq6u": "After a month is chosen, daily navigation should simply walk that month’s internal dates under the same year baseline.",
  "Q5w5/Q": "Day range",
  "+yklh7": "Week range",
  "ptW4Sw": "Month range",
  "eK9wmJ": "Year range",
  "7i4by+": "Read the book across the selected day span without leaving the calendar panel.",
  "rucdxS": "Compare the book across the selected weekly window as one continuous operating frame.",
  "Lf5SJy": "Read the selected months as one planning and review arc inside the same annual frame.",
  "xy5li8": "Read the selected years as one archive or planning horizon without leaving the shared page baseline.",
  "pXYUJ2": "Debit $4.90",
  "NapaKO": "Jun 21",
  "Q/7Pyf": "Credit $2.10",
  "zFieBl": "Credit $0.00",
  "3JsS/z": "Credit $1.24",
  "4G8OvL": "Debit $0.52",
  "Lvm8Pd": "Credit $1.08",
  "vRZyBJ": "Debit $0.46",
  "Pgj0YV": "Credit $2.80",
  "xGKP8X": "Debit $7.90",
  "1wWWtl": "Jun 28",
  "IzWm6A": "Watching position",
  "EpYUBA": "ROLL",
  "qW14/k": "Mark to planned",
  "YhE3pd": "Delete plan",
  "iNBANA": "Open note",
  "PzhJ/E": "All positions",
  "aw5UGn": "Select a position to focus the details panel.",
  "T/faTw": "View planned",
  "8YKEEW": "Open reminders",
  "m9Vy8g": "Nothing is live in this slice right now. Open positions will appear here once a trade is active.",
  "RBaP0R": "No open positions",
  "5oJyQm": "View open",
  "V8AUHl": "There is nothing on watch right now. Watching positions will show up here when you are monitoring without acting yet.",
  "G44uIC": "No watching positions",
  "sK5w2c": "No queued trade plans match this slice. Planned ideas will appear here before they move into the live book.",
  "lyeh4t": "No planned positions",
  "3qxSi8": "Open journal",
  "0mUCwt": "Open analyze",
  "trTp5v": "Nothing has been closed inside this slice yet. Completed trades will show up here once they are ready for review.",
  "XMapyU": "Price alert",
  "zuFWKo": "Expiry reminder",
  "yktVOZ": "Follow-up reminder",
  "8vxcEz": "Realized pnl",
  "5dgeW5": "Closed and marked inside the selected time baseline.",
  "y1Dzrb": "Flat",
  "HYWpzj": "Managed positions included in this slice.",
  "qcaDSl": "Positive realized outcomes in the current frame.",
  "cCC/bL": "Avg hold",
  "DuutHc": "Average days carried before review or exit.",
  "/ph2Jr": "Same day",
  "kVm/25": "Bullish call structures",
  "o9fe8I": "Bearish hedge structures",
  "VHJRnP": "Range income structures",
  "xCcmTM": "Calendar repair structures",
  "0tOalt": "Custom managed structures",
  "NW+B5A": "Profit is being led by the strongest structure family in this slice.",
  "wh3Z4O": "No structure attribution is attached to this slice yet.",
  "DOMFkY": "Awaiting closed structure outcomes.",
  "BYHcyk": "By strategy",
  "UXy2ZL": "Ticker concentration is defining most of the realized result here.",
  "zP+YKA": "No ticker attribution is attached to this slice yet.",
  "zKKyck": "Awaiting ticker-level contribution data.",
  "rFzPCl": "Book state is showing whether open, planned, or closed work drove the outcome.",
  "2PPkMi": "No status attribution is attached to this slice yet.",
  "VdTTjB": "Awaiting state-based contribution data.",
  "9OEa4w": "By status",
  "5DFT+z": "workspace-derived",
  "2KtWqT": "Internal",
  "fgZsGY": "broker/imported",
  "QG6+rR": "External",
  "MtAlTm": "combined analysis",
  "aJicJg": "Broker and imported outcomes inside the selected window.",
  "iFsDVR": "Loading",
  "Y/W1GU": "Imported executions counted in this time slice.",
  "OqsNmH": "Win rate from imported and broker-linked records.",
  "pl/OMC": "Risk-adjusted result from imported daily history.",
  "o4ALsy": "Avg per day",
  "DvHrgo": "Average realized imported pnl per trading day.",
  "Tunfr8": "Imported results are being led by one or two underlying books in this slice.",
  "hZILDu": "No imported ticker attribution is attached to this slice yet.",
  "ggjiYf": "Awaiting imported ticker results.",
  "yFWp4Y": "Combined mode keeps the workspace frame but lets imported ticker results lead the attribution read.",
  "fPSSeS": "Combined mode is ready, but no imported ticker data is attached to this slice yet.",
  "SUwKav": "Imported trade history shows this underlying as a leading realized contributor in the selected window.",
  "fMem24": "Trend aligned and kept compact enough to realize gains without a late repair.",
  "6mMtIR": "Imported trade history shows this underlying as one of the largest realized drags in the selected window.",
  "kDMp5i": "Stayed exposed longer than the payoff improvement justified once the move weakened.",
  "TK8bb1": "Equity curve",
  "9WBD0z": "Monthly heatmap",
  "tfQGFI": "Pnl distribution",
  "AwRFBj": "{count} trades at {winRate}% win",
  "sLWbBX": "Imported attribution will appear here once the selected window has enough broker-linked history to break down.",
  "GfDX12": "Workspace-derived attribution will appear here once this slice has enough local outcome history to summarize.",
  "X4a9zL": "No attribution data yet",
  "6oGvmt": "No local attribution yet",
  "ygzclX": "Explain trading-day countdown",
  "+51nyq": "Open compound calculator",
  "fdCHpx": "Trading-day countdown rules",
  "O0bpOT": "Select a past date to see how many trading days have passed.",
  "q6FHAm": "Select a remaining date this year to see how many trading days are left.",
  "n4kral": "Select a future date next year to see how many trading days away it is.",
  "K3uyvq": "months",
  "iVMyn1": "Close and return to today",
  "86dZiZ": "Collapse calendar dates",
  "jfd62c": "Expand calendar dates",
  "IQvXuv": "Open full calendar",
  "s+vdyj": "Weekly ranges",
  "T8JZHe": "Mon",
  "C4ENlv": "Tue",
  "2NqUgh": "Wed",
  "FC0AP4": "Thu",
  "hFYE2M": "Fri",
  "3Hv4Fb": "Sat",
  "1Aday2": "Sun",
  "g0Dddx": "Goal progress",
  "X+EqZ8": "Active target",
  "0VV/sK": "Goal",
  "MZ726w": "Target amount",
  "LAWWFB": "Progress details",
  "hCCnsx": "Profit goal",
  "BgtKWR": "Earned so far",
  "hpk3xG": "Today change",
  "RvwGpR": "Funding progress",
  "F77KSL": "Prepared",
  "z4gijG": "Deployed",
  "ka8VLG": "Remaining",
  "y2BOm7": "Prepared progress",
  "UQ/4Dp": "Delete current target",
  "HoiRnc": "Add target",
  "WgB4iI": "Target name",
  "zvQKpZ": "No reminders",
  "l3AfOI": "Due date",
  "HBLmBD": "Selected date",
  "tD1OSX": "No scheduled macro events in this month.",
  "8BelZy": "Official schedules prevail.",
  "byP6IC": "Selected",
  "/Ko9ai": "Showing selected range only",
  "wkuwe/": "Undated price alerts are listed below.",
  "Gs9Kfp": "Back to top",
  "w4OOda": "Compound Calculator",
  "Z21NKx": "Manage open, watching, planned, and closed positions in one place.",
  "Gn2VdB": "New plan",
  "78Gbn1": "SPX",
  "nIiewT": "NDX",
  "q5OQqU": "Empty state",
  "qMgtSE": "Hide legs",
  "7i7IG/": "Expand legs",
  "/uA3qY": "No leg detail is attached to this position yet.",
  "YIUs4+": "Clear date filter",
  "V7d8KW": "New reminder",
  "tvknXg": "Close reminder form",
  "B25Wur": "Reminder type",
  "YTVz0Q": "Contract expiry",
  "Mvi3A8": "Trigger when",
  "W3rByC": "Reminder frequency",
  "nluNPP": "Remind once",
  "ysT8nU": "Note (optional)",
  "3itOWt": "Save reminder",
  "FjPVFv": "Reminder type filter",
  "eKEL/g": "Pending",
  "PL5iZt": "{ticker} target not set",
  "O5faII": "Check expiry timing.",
  "Pvdacj": "Bring the expiry window back into view before timing turns into drift.",
  "9mLiUs": "This reminder is ready to be handled from the alerts desk.",
  "Zqa4dQ": "Triggered",
  "5jeq8P": "Unknown",
  "tDp15p": "Reminder actions",
  "4Y2K5+": "Mark completed",
  "/diypV": "Open linked position",
  "GpVe0K": "Previous reminder page",
  "U68BxZ": "Next reminder page",
  "zWkvNO": "Timeline",
  "aH4De2": "Source",
  "HtMahR": "External import",
  "pZCOqy": "Bring in broker history before reading the external timeline.",
  "jiqZ1b": "No recorded data for this range",
  "obnOhI": "Attribution headline",
  "8keCZ9": "No realized result to attribute yet.",
  "VB7wED": "Use one dimension at a time so contribution, win rate, and average result stay comparable on the same table.",
  "7adwjN": "The breakdown becomes meaningful after a position records a realized result.",
  "Otefae": "Dimension",
  "J+jj1H": "Pnl",
  "f6+ZSh": "Avg pnl",
  "LJOoay": "Top contributors",
  "Wv+bxD": "Top detractors",
  "Oy/Lgi": "Most traded",
  "YCQYiv": "No imported activity yet",
  "u5A6nB": "{count} imported trades made this the heaviest reviewed book in the selected range.",
  "1KLl6N": "Once imported executions appear in this window, the most active underlying will show here.",
  "6zhrlX": "By day",
  "V32rQQ": "Reminder completed",
  "Lr869H": "Reminder reopened",
  "T/TkAZ": "1. What We Collect",
  "w3v7mq": "When you sign up, we collect your email address. We also create a login PIN for you. If you pay, Stripe handles your payment info — we never see your credit card number. As you use the app, we store things you create like trades, strategies, and alerts.",
  "lgt491": "2. How We Use It",
  "Wczvjp": "Your email is used to log you in, recover your PIN, and send alert notifications. Your trades and strategies are stored so the app works for you. We don't sell your information. We don't share it with anyone.",
  "qyw0P2": "3. Where We Store It",
  "aauQMk": "Your data lives in a secure database. It's encrypted when stored and when sent over the internet. Payments are handled by a third-party payment processor — we never see or store your card details.",
  "66uD/i": "4. Cookies and Storage",
  "vkWyDG": "We use one cookie to keep you logged in. We save your language and display preferences in your browser. We don't use any tracking cookies and we don't track you across the web.",
  "dibMUt": "5. Push Notifications",
  "mywTS3": "If you turn on push notifications for price alerts, we store your browser's notification address on our server. You can turn this off anytime in your browser settings or in the app.",
  "+Vq92J": "6. Market Data",
  "7RMFwt": "We get SPX and VIX prices from public market data sources. We only use this data to power the simulator and alerts in the app.",
  "TSrjth": "7. How Long We Keep It",
  "hRFN9U": "We keep your data as long as your account is active. Your free General account remains available when Flagship access ends. You can ask us to delete your data anytime.",
  "X+9MhG": "8. Other Services We Use",
  "nwi02M": "We use third-party services for payments, hosting, and data storage. Each of these has their own privacy rules about how they handle data.",
  "plSjrj": "9. Kids",
  "A2TNyg": "This app is not for anyone under 18. We don't collect information from minors on purpose.",
  "T0Y1JF": "10. Changes",
  "kaSaA+": "We might update this policy. If you keep using the app after we make changes, that means you're okay with the new policy.",
  "n8T6A6": "11. Questions?",
  "ogOwoI": "If you have questions about your privacy, email us at the address on the purchase page.",
  "b4hQBy": "Last updated: April 2026",
  "CYW7pR": "Discover the market conditions where a strategy holds up — and where it breaks.",
  "4DCLAA": "Evidence Lab",
  "IPBLX8": "Loading 3D explorer…",
  "MQUznC": "3D options explorer",
  "/2yBU5": "Explore how option structures respond to price, time and implied volatility. Start with a call, put, spread, straddle or iron condor, then rotate the surface and switch between P&L and Greeks.",
  "11Fv+Z": "Reading the surface",
  "cZTNgU": "Each point on the surface is a model result for the two selected inputs. P&L shows the modeled change from the example's entry value. Delta, gamma, theta and vega show different sensitivities. Use the analysis presets to explore a question, or choose your own axes in Manual mode.",
  "1Ku6j1": "Examples use theoretical option prices, constant volatility across strikes and no trading costs. They explain model behavior; they do not predict returns or represent executable market prices.",
  "IUSc2p": "Back to positions",
  "9R+8FN": "Close Position",
  "3jalA3": "Exit credit",
  "gRctwu": "Exit debit",
  "REhBx2": "Record Close",
  "OGYRNS": "Realized PnL",
  "4LeXxR": "Previewing structure",
  "jGzgJI": "Add to Workbench",
  "7jQMlt": "Learn the strategy",
  "W5wAqT": "Hover to preview",
  "Rj0Sd6": "As of {date} (ET)",
  "7tqSOi": "{ticker}: {date} (ET)",
  "l8cLKS": "Volatility index",
  "0O2BkM": "ATM IV: {date} (ET)",
  "yefR6Y": "ATM IV expires {date}",
  "Fb02M5": "No current ATM IV",
  "vSu746": "Compare defined-risk structures for upside, downside, or asymmetric follow-through.",
  "QwubtG": "Range / Income",
  "YDnaXb": "Compare structures that concentrate value around a range, time decay, or premium collection.",
  "/aXvb7": "Compare structures driven by realized movement, implied volatility, or the passage of time.",
  "q3w6vj": "Overlay / Defense",
  "AonZ0n": "Compare overlays that soften downside, generate carry, or reshape an existing directional position.",
  "mX8/sM": "Compare strategy families through payoff shape and trade-offs.",
  "neBHLb": "Strategy Gallery",
  "5NEEmc": "Compare strategies by direction, range, volatility, and defense.",
  "LXi25y": "Day change",
  "tE2cGi": "ATM IV",
  "9M96QK": "session drift",
  "q2GeJ7": "pre-market",
  "xlwRpL": "after close",
  "pYDJi3": "closed",
  "pizY2a": "context",
  "cPIKU2": "Following",
  "OJ4QAX": "Make this share visible only to me",
  "lzpH+r": "Make this share public",
  "uhu5aG": "Public",
  "SsCPKP": "Only me",
  "DYXaO9": "This post was collapsed after multiple community reports.",
  "8VkHvE": "Show post",
  "8h0sA8": "Read full post",
  "1Vd442": "Edit post",
  "yPcmjR": "Delete post",
  "RTOuyx": "Shared post",
  "Rtle8V": "This post could not be deleted. Please try again.",
  "pKoYZo": "This share's visibility could not be changed. Please try again.",
  "TEh92x": "Loading shares...",
  "0oagnH": "Loading posts...",
  "7NbAR6": "Shares could not be loaded.",
  "/jLzlC": "Posts could not be loaded.",
  "xy9fIB": "Refresh posts",
  "BjCf6E": "New content",
  "mn0wOp": "No public shares yet.",
  "eGs7OB": "Nothing has been shared here yet.",
  "lzekKe": "No shares yet.",
  "xI2csf": "No saved posts yet.",
  "VyP9+l": "No liked posts yet.",
  "s5Emdj": "Following is quiet for now.",
  "oWTc7R": "Public notes from this person will appear here.",
  "SA5wTS": "Writing people choose to share will appear here.",
  "W2IrK2": "Notes you choose to share will collect here.",
  "lsqh6j": "Posts you save will appear here.",
  "5n5BSA": "Posts you like will appear here.",
  "IR584b": "Posts from people you follow will appear here.",
  "1cI1mA": "Focus on insights. See what matters.",
  "6fIVdc": "Delete this post?",
  "b3KIxg": "This share could not be updated. Please try again.",
  "08bjdS": "Edit share",
  "6SSNQY": "Share content",
  "h+vI/j": "Posting requires creator verification.",
  "4lqEYb": "New accounts can share external links after 24 hours. Your note is still here.",
  "/WN/Am": "Referral and offer links cannot be posted to the community.",
  "9YtkTN": "Please wait {seconds} seconds before sharing again. Your note is still here.",
  "xac7x3": "Hourly sharing limit reached. Your note is still here; try again in about {minutes} minutes.",
  "ZYR+2M": "Daily sharing limit reached. Your note is still here; try again in about {hours} hours.",
  "myPKoT": "This note could not be shared. Please try again.",
  "UDDCEP": "Share a note",
  "ro28YS": "Note to share",
  "yvueWX": "Write what you noticed, learned, or want to remember...",
  "Xqfld1": "Only verified creators can publish posts. A subscription does not grant posting access. You can still read, follow, like, save, and report posts.",
  "UU+20q": "Add a share",
  "OKXv4I": "Post count",
  "8/YhTK": "All posts",
  "4sfKEB": "Following feed",
  "L+t7yr": "Liked posts",
  "hdqC44": "Saved posts",
  "opri2O": "People count",
  "5gIWIu": "Switch feed",
  "cE4Hfw": "Discover",
  "yFYhfh": "My shares",
  "sdGmEY": "Replace profile photo",
  "UkpJTd": "Add profile photo",
  "34SlJb": "Photo upload failed",
  "ADK15s": "+ Write a share",
  "Q8/qWQ": "Profile content",
  "tYvY9B": "Audience. Referrals. Payouts.",
  "J6M9RB": "Could not load your KOL information. Please retry.",
  "a18IzS": "Track creator performance, active links, and payout history from the same workspace shell.",
  "s6uMnZ": "Paid out",
  "qCcwo3": "Links",
  "zHDJut": "Purchase link",
  "cCGg3D": "$98 share card",
  "E+sBOl": "Promotion page",
  "g4d3j2": "No link is available yet.",
  "6Tps09": "Inactive",
  "ZE8lRT": "uses",
  "9Sak6b": "No reference",
  "8RpXfZ": "Allow session storage in this browser to keep your selection while you sign in.",
  "mr//Om": "Could not update your favorites. Please try again.",
  "VqRNsA": "Learning sections",
  "A87nSW": "Lesson not found",
  "1PNi68": "Choose a structure. Read the theory or explore it in the simulator.",
  "O81lSB": "Free to explore · No sign-up needed",
  "UUmUhU": "Explore how each structure works, its payoff and its risks.",
  "fhwTpA": "Sources",
  "zLLA3l": "About ABG One",
  "iZNmMF": "This page drifted off the chain.",
  "2rme/A": "The link may be expired, mistyped, or pointing at a profile we no longer carry. Roll it forward and pick up where you left off.",
  "HaJFP2": "Back to the simulator",
  "mNAfKI": "OR LOG IN",
  "qv1bNN": "Back to runs",
  "KAeJLW": "Failed to load run:",
  "7b4tym": "Daily log",
  "WzEqfA": "No daily results — every day in the window was skipped.",
  "OUDup4": "Cumul.",
  "39CMzF": "Generating your access PIN...",
  "z0Wa9w": "We also emailed it to you. Check spam if you don't see it.",
  "pxCGqt": "Something went wrong. Please contact support.",
  "gmezZ0": "YOUR ACCESS PIN",
  "psITWt": "Save this PIN — it is your permanent login credential. You can change it later in Settings.",
  "w8icYy": "Copy PIN",
  "cRLxCh": "Choose a market route and preview the structure before taking it into the workbench.",
  "eDR8ff": "Recognition & Surface",
  "AvuUur": "Recognize strategy shapes, then switch into volatility surface, smile, and skew.",
  "l9EhxQ": "Learn options basics, Greeks and strategy principles, then practice what you learned.",
  "pfxoQZ": "View example",
  "pqVS1c": "Buy a call",
  "9zkYCX": "Sell an uncovered call",
  "iQ+lPX": "Buy a put",
  "qCdQEA": "Sell a put",
  "+EhIrw": "Practice topic",
  "MNk85U": "1. What it is",
  "LqqOqn": "Buy a call and put at the same strike and expiration for a long straddle; sell both for a short straddle. This structure uses the long version.",
  "6zTvRE": "2. Why use it",
  "vWT1rl": "3. How the numbers work",
  "4dMChc": "4. How it changes",
  "WDvESB": "5. What to watch for",
  "f1ysks": "Examples use illustrative entry prices and amounts per underlying unit, before costs. Contract amounts require the contract multiplier. Expiration payoffs assume the illustrated legs remain intact; earlier position values and exercise or assignment outcomes can differ.",
  "lA9OPP": "The Greeks describe an option's sensitivity to changes in different factors. Here we use ordinary stock options, with other pricing inputs held fixed.",
  "Mk3Iy7": "For the same option and quantity, a short position has the opposite Greek signs to a long position.",
  "NzZoeS": "Several factors can change together: a call can lose value even as the stock rises if time decay or falling implied volatility outweighs the gain from the stock move.",
  "QRccCM": "Page not found",
  "aIRWQB": "Back to home",
  "/Zj5Ed": "One-time",
  "b1Ou36": "Quarterly",
  "oyG65W": "Every six months",
  "dqD39h": "Yearly",
  "yJM83C": "Amount invested",
  "UdiaLk": "Amount per ticker",
  "S9zGng": "Amount per contribution",
  "0DDl29": "Contribution per ticker",
  "eqVonM": "Historical prices are still preparing. Please try again shortly.",
  "g2zN7a": "Choose a date within the last 30 years.",
  "mtZEwW": "Historical prices cannot be prepared right now. Please try again shortly.",
  "+6NTUJ": "This ticker is not available.",
  "H1uM24": "If you had invested",
  "/Q2cl9": "Replay an investment",
  "VfYQcJ": "Compare investments",
  "sMCIP4": "Choose a ticker, dates, and amount, then replay the daily path.",
  "3SIWSd": "Choose two to four tickers and compare them with the same dates and amount.",
  "o+3W1i": "Single ticker",
  "493J7R": "Compare",
  "ziX7Yd": "Investment date",
  "1F+vfO": "Investment method",
  "EtLbXH": "Replay through",
  "RRpyqd": "Preparing history",
  "c/uCg0": "Start comparison",
  "yItLEv": "Return basis: adjusted prices including distributions.",
  "x2hUPj": "Return basis: closing prices; distributions are not included.",
  "FmlIES": "Account value",
  "93Co9g": "Return at this point",
  "pNxPUP": "Invested on {date}",
  "fu/B91": "{amount} × {count}",
  "nn6jif": "Invested capital",
  "TZiwuY": "Drawdown {value}",
  "QR/fls": "Across {count} trading sessions",
  "BPLXi7": "Holding period",
  "uXD/hw": "Historical account path",
  "v9vLyy": "Replay date",
  "J3ca41": "Play",
  "ORpWSn": "Restart replay",
  "amSNGJ": "Adjusted prices · distributions included",
  "i5y1bt": "Closing prices · distributions excluded",
  "lQuxVk": "Entry close {price}",
  "PEFUSo": "Replay comparison",
  "QGdayO": "Play comparison",
  "8vlp1n": "Comparison date",
  "0NN2tx": "Restart comparison",
  "9+47tk": "Replay history",
  "sEQvxE": "Replay history ticker",
  "hDwJ64": "Completed replays for this ticker will be saved here.",
  "q31qNa": "Completed comparisons will be saved here.",
  "Yge0jU": "This permanently deletes the saved result and cannot be undone.",
  "78QP/e": "Delete saved result?",
  "aJ/bsX": "Drag to reorder",
  "pusZVz": "Delete saved result",
  "wiKa1c": "{amount} × {count} = {total}",
  "HYZ2SW": "One-time investment of {amount}",
  "f8ox16": "{amount} × {count} = {total} per ticker",
  "JZ8i8E": "One-time investment of {amount} per ticker",
  "8xZJRI": "Tickers to compare",
  "pWLUu3": "2–4 tickers",
  "X0Q709": "Remove {ticker}",
  "0YBpXl": "Add ticker to comparison",
  "SIINHZ": "Add ticker"
}
